<template>
    <header>
    <div class="preloader" v-if="loading">
      <div class="circular-spinner">
        <img src="../assets/images/shiba-loading.png" width="150">
      </div>
    </div>
		<nav class="x-header navbar navbar-expand -logged py-0">
			<div class="container-fluid align-items-center h-100 position-relative">
				<div id="headerBrand">
				<!-- <button
					type="button"
					class="btn bg-transparent p-0 x-hamburger js-hamburger-toggle"
					@click="gotoMain()"
				>
					<span></span>
					<span></span>
					<span></span>
				</button> -->
				<div class="-branding-inner-wrapper">
					<router-link to="/" class="navbar-brand">
					<img
						class="-logo"
						src="../assets/images/logo-headline65x400.png"
						:alt="$t('funbeyond_main_alt')"
					/>
					</router-link>
				</div>
				</div>

				<div id="headerContent">
					<button v-if="hasActivePayBridgeTask" type="button" class="paybridge-task-button" @click.stop="reopenPayBridgeTask">
						<span class="paybridge-task-dot"></span>
						<span><strong>PayBridge</strong><small>{{ paybridgeTaskRemainingText }}</small></span>
					</button>
					<div class="x-language">
						<div class="current-lang -link-wrapper" @click="toggleDropdown">
							<div class="-image-wrapper">
								<img 
									class="img-fluid -ic-right-star-rank" 
									:src="getFlagImage()" 
									alt="Shiba888 change language"
								>
								<span class="lang-name" v-if="isDropdownOpen">{{ getLanguageName() }}</span>
							</div>
						</div>
						<div class="lang-dropdown" v-if="isDropdownOpen">
							<div 
								v-for="lang in languages" 
								:key="lang.code"
								class="lang-option"
								@click="selectLanguage(lang.code)"
							>
								<img 
								:src="require(`../assets/images/flags/${lang.code}.png`)" 
								:alt="lang.name"
								class="flag-icon"
								>
								<span class="lang-name">{{ lang.name }}</span>
							</div>
						</div>
					</div>
					<div class="x-ranking-entrance">
							<router-link to="/rewards" class="-link-wrapper">
								<div class="-image-wrapper">
									<img class="img-fluid -ic-right-star-rank" src="../assets/images/coin1.png" :alt="$t('rewards_exchange_alt')">
								</div>
								<div class="-text-wrapper">{{numberWithCommas2(user.coin)}}</div>
							</router-link>
					</div>
				<ul class="nav -menu-wrapper -logged">
					<li class="nav-item">
					<router-link to="/play" class="nav-link -partner">
						<div class="-img-wrapper">
						<img
							src="../assets/images/menu/play-1.png"
							class="-icon"
							:alt="$t('play_game_alt')"
						/>
						</div>
						<div class="-text">{{ $t('play') }}</div>
					</router-link>
					</li>

					<li class="nav-item">
					<router-link to="/promotion" class="nav-link -partner">
						<div class="-img-wrapper">
						<img
							src="../assets/images/menu/promotion-1.png"
							class="-icon"
							alt="Promotion"
						/>
						</div>
						<div class="-text">{{ $t('promotion') }}</div>
					</router-link>
					</li>

					<li class="nav-item">
					<router-link to="/partner" class="nav-link -partner">
						<div class="-img-wrapper">
						<img
							src="../assets/images/menu/friend-1.png"
							class="-icon"
							alt="Partner"
						/>
						</div>
						<div class="-text">{{ $t('partner') }}</div>
					</router-link>
					</li>

					<li class="nav-item">
					<router-link to="/cashback" class="nav-link -partner">
						<div class="-img-wrapper">
						<img
							src="../assets/images/menu/money-1.png"
							class="-icon"
							alt="Cashback"
						/>
						</div>
						<div class="-text">{{ $t('cashback') }}</div>
					</router-link>
					</li>
				</ul>

				<div class="navbar-nav">
					<div class="x-logged">
					<div class="-deposit-container d-none d-lg-block">
						<a
						href="#deposit"
						class="text-white js-account-approve-aware btn -btn-deposit"
						@click.prevent="handleDepositClick()"
						>
						<div class="f-7">{{ $t('deposit') }}</div>
						</a>
					</div>
					<div class="-withdraw-container d-none d-lg-block">
						<a
						href="#withdraw"
						class="text-white js-account-approve-aware btn -btn-withdraw"
						@click="handleWithdrawClick()"
						>
						<div class="f-7">{{ $t('withdraw') }}</div>
						</a>
					</div>
					<div class="-profile-container">
						<div class="d-none d-lg-block">
						<div class="-btn-wrapper">
							<div class="-inner-wrapper">
							<a
								href="#account"
								data-toggle="modal"
								data-target="#accountModal"
								class="text-decoration-none"
							>
								<div class="-profile-name2">{{user.code}}</div>
							</a>
							<div class="-balance-container">
								<div class="-text-username">
								{{user.code}}
								</div>

								<div class="-user-balance js-user-balance f-sm-6 f-7 ">
								<div class="-inner-box-wrapper2">
									<img
									class="img-fluid -ic-coin"
									src="../assets/images/shiba888-ic-coin.png"
									alt="customer image"
									width="26"
									height="21"
									/>

									<span id="customer-balance"
									><span class="-amount">{{ numberWithCommas(user.credit) }}</span>
									</span>
								</div>
								<button
									type="button"
									class="-btn-balance2"
									id="btn-customer-balance-reload"
									@click="reloadBalance()"
								>
									<i :class="{'fas':true, 'fa-sync-alt':true, 'f-10':true, 'fa-spin':fa_spin}"></i>
								</button>
								</div>
							</div>
							</div>

							<a
							href="#account"
							data-toggle="modal"
							data-target="#accountModal"
							>
							<div class="x-profile-image">
								<img
								class="img-fluid -profile-image"
								src="../assets/images/avatar.png"
								alt="customer image"
								/>
							</div>
							</a>
						</div>
						</div>

						<div class="d-lg-none">
						<div :class="{'js-ez-logged-sidebar':true, '-btn-mobile-wrapper':true , '-open':this.accountOpen }">
							<div class="-inner-wrapper" style="line-height:1;">
							<a href="javascript:void(0)" @click="showTabAccount()">
								<div class="-profile-name2">{{user.code}}</div>
							</a>
							<div class="-balance-container">
								<div class="-text-username">
								{{user.tel}}
								</div>

								<div class="-user-balance js-user-balance f-sm-6 f-7 ">
								<div class="-inner-box-wrapper2">
									<img
									class="img-fluid -ic-coin"
									src="../assets/images/shiba888-ic-coin.png"
									alt="customer image"
									width="26"
									height="21"
									/>

									<span id="customer-balance"
									><span class="-amount">{{ numberWithCommas(user.credit) }}</span>
									</span>
								</div>
								<button
									type="button"
									class="-btn-balance2"
									@click="reloadBalance()"
								>
									<i :class="{'fas':true, 'fa-sync-alt':true, 'f-10':true, 'fa-spin':fa_spin}"></i>
								</button>
								</div>
							</div>
							</div>

							<a href="javascript:void(0)" @click="showTabAccount()">
							<div class="x-profile-image">
								<img
								class="img-fluid -profile-image"
								src="../assets/images/avatar.png"
								alt="customer image"
								/>
							</div>
							</a>
						</div>

						<div :class="{'x-menu-account-list-sidebar':true,'-open':this.accountOpen}">
							<div class="x-modal-account-menu-mobile">
							<div class="-modal-profile-mobile d-xl-none d-block">
								<div class="text-right">
								<i class="fas fa-times f-5 js-close-account-sidebar" @click="showTabAccount()"></i>
								</div>

								<div class="x-profile-image">
								<img
									class="img-fluid -profile-image"
									src="../assets/images/avatar.png"
									alt="customer image"
								/>
								</div>

								<div class="-balance-container">
								<div class="-text-username">
									{{user.tel}}
								</div>

								<div
									class="-user-balance js-user-balance f-sm-6 f-7 "
								>
									<div class="-inner-box-wrapper2">
									<img
										class="img-fluid -ic-coin"
										src="../assets/images/shiba888-ic-coin.png"
										alt="customer image"
										width="26"
										height="21"
									/>

									<span id="customer-balance"
										><span class="-amount">{{numberWithCommas(user.credit)}}</span>
									</span>
									</div>
									<button
									type="button"
									class="-btn-balance2"
									@click="reloadBalance()"
									>
									<i :class="{'fas':true, 'fa-sync-alt':true, 'f-10':true, 'fa-spin':fa_spin}"></i>
									</button>
								</div>
								</div>
							</div>

							<div class="-lists-outer-wrapper">
								<ul class="navbar-nav">
								<!-- <li class="nav-item -join-promotion" v-if="!user.userId">
									<button
									type="button"
									class="nav-link js-close-account-sidebar "
									 @click="lineLogin()"
									>
									<img
										class="img-fluid -icon-image"
										src="../assets/images/icon-line.svg"
										alt="Line"
									/>
									<span class="-text-menu">{{ $t('login_with_line') }}</span>
									</button>
								</li>	 -->
								<li class="nav-item -account-profile" :class="{ 'active': mobileActiveTab === 'bank' }">
									<button type="button" class="nav-link js-close-account-sidebar" @click="setMobileActiveTab('bank')" data-toggle="modal" data-target="#accountModalMobile">
										<img class="img-fluid -icon-image" src="../assets/images/shiba888-ic-menu-user.png" alt="icon user" width="28" height="27">
										<span class="-text-menu" style="font-size:15px">
											{{ $t('header.account_info') }}
										</span>
									</button>
								</li>
								<!-- <li class="nav-item -coupon">
									<button
									type="button"
									class="nav-link js-close-account-sidebar js-account-approve-aware"
									data-toggle="modal"
									data-target="#couponModalMobile"
									>
									<img
										class="img-fluid -icon-image"
										src="../assets/images/shiba888-ic-menu-coupon.png"
										alt="ic-menu-coupon"
									/>
									<span class="-text-menu">{{ $t('use_coupon') }}</span>
									</button>
								</li> -->
								<li class="nav-item -join-promotion">
									<button
									type="button"
									class="nav-link js-close-account-sidebar "
									@click="$router.replace('/promotion')"
									>
									<img
										class="img-fluid -icon-image"
										src="../assets/images/shiba888-ic-menu-promotion.png"
										alt="ic-menu-promotion"
									/>
									<span class="-text-menu"
										>{{ $t('menu_promotion') }}</span
									>
									</button>
								</li>
								<li class="nav-item -logout">
									<a
									class="nav-link js-require-confirm"
									:data-title="$t('logout_confirmation')"
									@click="confirmLogout()"
									>
									<img
										class="img-fluid -icon-image"
										src="../assets/images/shiba888-ic-menu-logout.png"
										alt="ic-menu-logout"
									/>
									<span class="-text-menu">{{ $t('header.logout') }}</span>
									</a>
								</li>
								</ul>
								<!-- <ul class="navbar-nav -action-nav">
								<li class="nav-item">
									<a
									:href="adminContactLineLink"
									class="nav-link js-close-account-sidebar"
									target="_blank"
									>
									<img
										src="../assets/images/btn_hover.png"
										class="-img"
										width="100"
										height="100"
										style="display: initial;"
									/>
									<div class="-text" style="font-size:12px;">{{ $t('contact_admin') }}</div>
									</a>
								</li>
								</ul> -->
							</div>
							</div>
							<div class="-overlay"></div>
						</div>
						</div>
					</div>
					</div>
				</div>
				</div>
			</div>
			</nav>
			


		<div class="x-modal modal" id="accountModal" tabindex="-1" role="dialog" data-loading-container=".modal-body" data-container="#accountModal" aria-hidden="true">
			<div class="modal-dialog -modal-size  -modal-big -modal-main-account" role="document" style="padding-top: 74.8012px;">
			<div class="modal-content -modal-content">
			<button type="button" class="close f-1 " data-dismiss="modal" aria-label="Close" style="color: white;">
				<i class="fas fa-times"></i>
			</button>
				<div class="modal-body -modal-body" style="top: 0px;">
					<div class="x-modal-account-menu">
						<ul class="navbar-nav">
							<!-- <li class="nav-item -account-profile" v-if="!user.userId">
								<button type="button" class="nav-link js-close-account-sidebar" @click="lineLogin()">
									<img class="img-fluid -icon-image" src="../assets/images/icon-line.svg" alt="Line" width="28" height="27">
									<span class="-text-menu" style="font-size:15px">
										{{ $t('login_with_line') }}
									</span>
								</button>
							</li> -->
							<li class="nav-item -account-profile" :class="{ 'active': accountActiveTab === 'bank' }">
								<button type="button" class="nav-link js-close-account-sidebar" @click="setAccountActiveTab('bank')">
									<img class="img-fluid -icon-image" src="../assets/images/shiba888-ic-menu-user.png" alt="icon user" width="28" height="27">
									<span class="-text-menu" style="font-size:15px">
										{{ $t('header.account_info') }}
									</span>
								</button>
							</li>
							<!-- <li class="nav-item -account-provider ">
								<button type="button" class="nav-link js-close-account-sidebar" data-container="#accountModal" data-active-menu="-account-provider" data-loading="_onLoading_" data-target=".js-profile-account-modal">
									<img class="img-fluid -icon-image" src="../assets/images/shiba888-ic-menu-provider.png" alt="icon phone" width="28" height="27">
									<span class="-text-menu">
										{{ $t('play_through_app') }}
									</span>
								</button>
							</li> -->
										<!-- <li class="nav-item -coupon ">
									<button type="button" class="nav-link js-close-account-sidebar js-account-approve-aware" data-container="#accountModal" data-active-menu="-coupon" data-loading="_onLoading_" data-target=".js-profile-account-modal">
										<img class="img-fluid -icon-image" src="../assets/images/shiba888-ic-menu-coupon.png" alt="icon coupon" width="28" height="27">
										<span class="-text-menu">
											{{ $t('use_coupon') }}
										</span>
									</button>
								</li> -->
									<li class="nav-item -join-promotion ">
								<button type="button" class="nav-link js-close-account-sidebar" data-container="#accountModal" data-active-menu="-join-promotion" data-loading="_onLoading_" data-target=".js-profile-account-modal" @click="gotoPromotion()">
									<img class="img-fluid -icon-image" src="../assets/images/shiba888-ic-menu-promotion.png" alt="icon promotion" width="28" height="27">
									<span class="-text-menu" style="font-size:15px">
										{{ $t('menu_promotion') }}
									</span>
								</button>
							</li>

							
							<li class="nav-item js-close-account-sidebar -logout">
								<a href="javascript:void(0)" class="nav-link js-require-confirm" :data-title="$t('logout_confirmation')" @click="confirmLogout()">
									<img class="img-fluid -icon-image" src="../assets/images/shiba888-ic-menu-logout.png" alt="icon logout" width="28" height="27">
									<span class="-text-menu" style="font-size:15px">
										{{ $t('header.logout') }}
									</span>
								</a>
							</li>
						</ul>
					</div>
					<div class="js-profile-account-modal -layout-account">
						<!-- Profile Tab -->
						<div class="x-account-profile -v2" v-if="accountActiveTab === 'profile'">
							<div data-animatable="fadeInModal" class="-profile-container animated fadeInModal">
							<div class="x-title-modal -v2 mx-auto text-center">
								{{ $t('header.account_info') }}
							</div>
				
							<div class="text-center">
								<div class="my-3">
									<div class="x-profile-image">
										<img class="img-fluid -profile-image" src="../assets/images/avatar.png" alt="customer image">
									</div>
							</div>

							<div class="my-3">
								<div class="-text-username">Username:  {{user.tel}}</div>
									<button type="button" class="-link-change-password btn-primary" @click="showChangePasswordFormMobile = !showChangePasswordFormMobile" style="color:#fff; padding: 8px 16px;">{{ $t('header.change_password') }}</button>
								</div>

								<div class="-change-password-container" v-if="showChangePasswordFormMobile">
									<div class="js-collapse-content">

									<div class="form-group mt-3">
										<input type="password" v-model="password" required="required" :placeholder="$t('current_password_placeholder')" class="x-form-control form-control">
									</div>
									<div class="form-group">
										<input type="password" v-model="password1" required="required" :placeholder="$t('new_password_placeholder')" class="x-form-control form-control">
									</div>
									<div class="form-group">
										<input type="password" v-model="password2" required="required" :placeholder="$t('confirm_new_password_placeholder')" class="x-form-control form-control">
									</div>

									<button type="button" @click="changePassword()" class="btn -submit btn-primary text-center m-auto js-user-confirm-deposit">
										<span>{{ $t('confirm') }}</span>
									</button>

									</div>
								</div>
							</div>

							<!-- <div class="-bank-info-container" v-if="getApprovedAccounts().length > 0">
								<div class="x-title-modal -v2 mx-auto text-center" style="font-size: 16px; margin-bottom: 15px;">
									{{ $t('header.approved_accounts') }}
								</div>
								<div class="x-customer-bank-info-container -v2" v-for="(account, index) in getApprovedAccounts()" :key="index" style="margin-bottom: 10px;">
									<div class="media m-auto">
										<img v-if="account.bank" :src="getBankImage(account.bank)" class="-img rounded-circle" width="50" height="50" :alt="getBankName(account.bank)">
										<div class="-content-wrapper">
											<span class="-name">{{account.firstname}} {{account.lastname}}</span>
											<span class="-number">{{account.account_no}}</span>
											<span class="-bank-name">{{getBankName(account.bank)}}</span>
										</div>
									</div>
								</div>
							</div> -->

					
							<div class="x-admin-contact text-center ">
								<span class="x-text-with-link-component">
									<label class="-text-message ">{{ $t('header.contact_support') }}</label>
									<a :href="adminContactLineLink" class="-link-message " target="_blank" rel="noopener">
										<u>{{ $t('header.contact_customer_service') }}</u>
									</a>
								</span>
							</div>

							<div class="js-has-info"></div>
						</div>
						</div>

						<!-- Bank Management Tab -->
						<div class="x-account-bank -v2" v-if="accountActiveTab === 'bank'">
							<div data-animatable="fadeInModal" class="-bank-container animated fadeInModal">
								<div class="x-title-modal -v2 mx-auto text-center">
									{{ $t('header.bank_management') }}
								</div>

								<!-- User Info -->
								<div class="text-center mb-3">
									<div class="-text-username">Username: {{user.tel}}</div>
									<div class="-text-username" v-if="user.firstname || user.lastname" style="margin-top: 8px; font-size: 16px; color: #fff; font-weight: 600;">
										Name: {{user.firstname}} {{user.lastname}}
									</div>
									<a href="#0" class="-link-change-password" data-toggle="collapse" data-target=".js-change-password-collapse"><u style="color:#fff">{{ $t('header.change_password') }}</u></a>
								</div>

								<div class="collapse -change-password-container js-change-password-collapse">
									<div class="js-collapse-content">
										<div class="form-group mt-3">
											<input type="password" v-model="password" required="required" :placeholder="$t('current_password_placeholder')" class="x-form-control form-control">
										</div>
										<div class="form-group">
											<input type="password" v-model="password1" required="required" :placeholder="$t('new_password_placeholder')" class="x-form-control form-control">
										</div>
										<div class="form-group">
											<input type="password" v-model="password2" required="required" :placeholder="$t('confirm_new_password_placeholder')" class="x-form-control form-control">
										</div>
										<button type="button" @click="changePassword()" class="btn -submit btn-primary text-center m-auto js-user-confirm-deposit" style="margin-bottom: 10px !important;">
											<span>{{ $t('confirm') }}</span>
										</button>
									</div>
								</div>

								<!-- Add New Account Form -->
								<div class="-add-account-container" v-if="showAddAccountForm">
									<div class="x-title-modal -v2 mx-auto text-center" style="font-size: 16px; margin-bottom: 15px;">
										{{ $t('header.add_new_account') }}
									</div>
									<div class="form-group">
										<select v-model="newAccount.bank" class="x-form-control form-control mb-3" @change="onBankChange()">
											<option value="">{{ $t('select_bank') }}</option>
											<option value="truewallet">Truewallet</option>
											<option value="bankokbank">BBL - ธนาคารกรุงเทพ</option>
											<option value="kbank">KBANK - ธนาคารกสิกรไทย</option>
											<option value="scb">SCB - ธนาคารไทยพาณิชย์</option>
											<option value="tisco">TISCO - ธนาคารทิสโก้</option>
											<option value="ttb">TTB - ทหารไทยธนชาต</option>
											<option value="ktb">KTB - ธนาคารกรุงไทย</option>
											<option value="krungsri">BAY - ธนาคารกรุงศรีอยุธยา</option>
											<option value="kiatnakin">KKP - ธนาคารเกียรตินาคิน</option>
											<option value="gsb">GSB - ธนาคารออมสิน</option>
											<option value="lh">LHBANK - ธนาคารแลนด์ แอนด์ เฮ้าส์</option>
											<option value="uob">UOB - ธนาคารยูโอบี</option>
											<option value="ธนาคารอิสลาม">IBANK - ธนาคารอิสลามแห่งประเทศไทย</option>
											<option value="ghbank">GHB - ธนาคารอาคารสงเคราะห์</option>
											<option value="cimb">CIMB - ธนาคารซีไอเอ็มบีไทย</option>
											<option value="baac">BAAC - ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร (ธกส)</option>
											<option value="icbc">ICBC - ธนาคารไอซีบีซี (ไทย)</option>
											<option value="standard">STANDARD - ธนาคารสแตนดาร์ดชาร์เตอร์ดไทย</option>
										</select>
										<input type="text" v-model="newAccount.account_no" class="x-form-control form-control mb-3" :placeholder="newAccount.bank === 'truewallet' ? $t('phone_number') : $t('account_number')" @keypress="isNumber($event)" @input="onAccountNumberInput($event, 'desktop')" @paste="onAccountNumberPaste($event, 'desktop')" inputmode="numeric" maxlength="12">
										<div class="text-center">
											<button type="button" @click="addNewAccount()" class="btn -submit btn-primary mb-3 px-4 py-2">
												<span>{{ $t('header.add_account') }}</span>
											</button>
											<br>
											<button type="button" @click="cancelAddAccount()" class="btn btn-outline-light px-4 py-2" style="border: 2px solid #fff; color: #fff; font-weight: 500;">
												<span>{{ $t('cancel') }}</span>
											</button>
										</div>
									</div>
								</div>

								<!-- Add New Account Button -->
								<div class="text-center mb-3" v-if="!showAddAccountForm">
									<button type="button" @click="showAddAccountForm = true" class="btn -submit btn-primary">
										<i class="fas fa-plus"></i> {{ $t('header.add_new_account') }}
									</button>
								</div>

								<!-- Approved Accounts -->
								<div class="-approved-accounts" v-if="getApprovedAccounts().length > 0">
									<div class="x-title-modal -v2 mx-auto text-center" style="font-size: 16px; margin-bottom: 15px; color: #4CAF50;">
										<i class="fas fa-check-circle"></i> {{ $t('header.approved_accounts') }}
									</div>
									<div class="x-customer-bank-info-container -v2 approved-border" v-for="(account, index) in getApprovedAccounts()" :key="'approved-' + index" style="margin-bottom: 10px;">
										<div class="media m-auto">
											<img v-if="account.bank" :src="getBankImage(account.bank)" class="-img rounded-circle" width="50" height="50" :alt="getBankName(account.bank)">
											<div class="-content-wrapper">
												<span class="-name">{{account.firstname}} {{account.lastname}}</span>
												<span class="-number">{{account.account_no}}</span>
												<span class="-bank-name">{{getBankName(account.bank)}}</span>
												<span class="-status approved">{{ $t('approved_status') }}</span>
											</div>
										</div>
									</div>
								</div>

								<!-- Pending Accounts -->
								<div class="-pending-accounts" v-if="getPendingAccounts().length > 0">
									<div class="x-title-modal -v2 mx-auto text-center" style="font-size: 16px; margin-bottom: 15px; color: #FF5722;">
										<i class="fas fa-clock"></i> {{ $t('header.pending_accounts') }}
									</div>
									<div class="x-customer-bank-info-container -v2 pending-border" v-for="(account, index) in getPendingAccounts()" :key="'pending-' + index" style="margin-bottom: 10px;">
										<div class="media m-auto">
											<img v-if="account.bank" :src="getBankImage(account.bank)" class="-img rounded-circle" width="50" height="50" :alt="getBankName(account.bank)">
											<div class="-content-wrapper">
												<span class="-name">{{account.firstname}} {{account.lastname}}</span>
												<span class="-number">{{account.account_no}}</span>
												<span class="-bank-name">{{getBankName(account.bank)}}</span>
												<span class="-status pending">{{ $t('pending_approval_status') }}</span>
											</div>
										</div>
									</div>
								</div>

								<!-- No Accounts Message -->
								<div class="text-center" v-if="!user.accounts || user.accounts.length === 0">
									<p style="color: #fff; font-family: 'Kanit', sans-serif;">{{ $t('header.no_bank_account') }}</p>
								</div>

								<div class="x-admin-contact text-center mt-3">
									<span class="x-text-with-link-component">
										<label class="-text-message ">{{ $t('header.contact_support') }}</label>
										<a :href="adminContactLineLink" class="-link-message " target="_blank" rel="noopener">
											<u>{{ $t('header.contact_customer_service') }}</u>
										</a>
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			</div>
			</div>
		</div>


		<div class="x-modal modal show" id="accountModalMobile" tabindex="-1" role="dialog" data-loading-container=".modal-body" data-container="#accountModalMobile" aria-modal="true">
		<div class="modal-dialog -modal-size  -modal-mobile -account-modal -no-fixed-button" role="document" style="padding-top: 60px;">
		<div class="modal-content -modal-content">
			<button type="button" class="close f-1 " data-dismiss="modal" aria-label="Close" @click="resetMobileTabs()" style="color: white;">
				<i class="fas fa-times"></i>
			</button>
				<div class="modal-header -modal-header">
					<div class="x-modal-mobile-header">
						<div class="-header-mobile-container">
							<h3 class="x-title-modal mx-auto text-center d-inline-block">
								<span v-if="mobileActiveTab === 'profile'">{{ $t('header.account_info') }}</span>
								<span v-else-if="mobileActiveTab === 'bank'">{{ $t('header.bank_management') }}</span>
								<span v-else>{{ $t('header.account_info') }}</span>
							</h3>
						</div>
					</div>
				</div>
				<div class="modal-body -modal-body" style="top: 76px;">
					<!-- Profile Tab Mobile -->
					<div class="x-account-profile -v2" v-if="mobileActiveTab === 'profile'">
						<div data-animatable="fadeInModal" class="-profile-container animated fadeInModal">
							<div class="text-center">
								<div class="my-3">
									<div class="x-profile-image">
										<img class="img-fluid -profile-image" src="../assets/images/avatar.png" alt="customer image">
									</div>
								</div>

								<div class="my-3">
									<div class="-text-username">Username:  {{user.tel}}</div>
									<a href="#0" class="-link-change-password" data-toggle="collapse" data-target=".js-change-password-collapse"><u style="color:#fff">{{ $t('header.change_password') }}</u></a>
								</div>

								<div class="collapse -change-password-container js-change-password-collapse">
									<div class="js-collapse-content">
										<div class="form-group mt-3">
											<input type="password" v-model="password" required="required" :placeholder="$t('current_password_placeholder')" class="x-form-control form-control">
										</div>
										<div class="form-group">
											<input type="password" v-model="password1" required="required" :placeholder="$t('new_password_placeholder')" class="x-form-control form-control">
										</div>
										<div class="form-group">
											<input type="password" v-model="password2" required="required" :placeholder="$t('confirm_new_password_placeholder')" class="x-form-control form-control">
										</div>
										<button type="button" @click="changePassword()" class="btn btn-block btn-primary -submit">
											<span>{{ $t('confirm') }}</span>
										</button>
									</div>
								</div>
							</div>

							<div class="x-admin-contact text-center mt-3">
								<span class="x-text-with-link-component">
									<label class="-text-message ">{{ $t('header.contact_support') }}</label>
									<a :href="adminContactLineLink" class="-link-message " target="_blank" rel="noopener">
										<u>{{ $t('header.contact_customer_service') }}</u>
									</a>
								</span>
							</div>

							<div class="js-has-info"></div>
						</div>
					</div>

					<!-- Bank Management Tab Mobile -->
					<div class="x-account-bank -v2" v-if="mobileActiveTab === 'bank'">
						<div data-animatable="fadeInModal" class="-bank-container animated fadeInModal">
							<!-- User Info Mobile -->
							<div class="text-center mb-3">
								<div class="-text-username">Username: {{user.tel}}</div>
								<div class="-text-username" v-if="user.firstname || user.lastname" style="margin-top: 8px; font-size: 16px; color: #fff; font-weight: 600;">
									Name: {{user.firstname}} {{user.lastname}}
								</div>
								<button type="button" class="-link-change-password btn-primary" @click="showChangePasswordFormMobile = !showChangePasswordFormMobile" style="color:#fff; padding: 8px 16px;">{{ $t('header.change_password') }}</button>
							</div>

							<div class="-change-password-container" v-if="showChangePasswordFormMobile">
								<div class="js-collapse-content">
									<div class="form-group mt-3">
										<input type="password" v-model="password" required="required" :placeholder="$t('current_password_placeholder')" class="x-form-control form-control">
									</div>
									<div class="form-group">
										<input type="password" v-model="password1" required="required" :placeholder="$t('new_password_placeholder')" class="x-form-control form-control">
									</div>
									<div class="form-group">
										<input type="password" v-model="password2" required="required" :placeholder="$t('confirm_new_password_placeholder')" class="x-form-control form-control">
									</div>
									<button type="button" @click="changePassword()" style="background: linear-gradient(130deg, #6bd9ff 11%, #3498ff 88%);" class="btn btn-block btn-primary">
										<span>{{ $t('confirm') }}</span>
									</button>
								</div>
							</div>

							<!-- Add New Account Form Mobile -->
							<div class="-add-account-container" v-if="showAddAccountFormMobile">
								<div class="x-title-modal -v2 mx-auto text-center" style="font-size: 16px; margin-bottom: 15px;">
									{{ $t('header.add_new_account') }}
								</div>
								<div class="form-group">
									<select v-model="newAccountMobile.bank" class="x-form-control form-control mb-3" @change="onBankChangeMobile()">
										<option value="">{{ $t('select_bank') }}</option>
										<option value="truewallet">Truewallet</option>
										<option value="bankokbank">BBL - ธนาคารกรุงเทพ</option>
										<option value="kbank">KBANK - ธนาคารกสิกรไทย</option>
										<option value="scb">SCB - ธนาคารไทยพาณิชย์</option>
										<option value="tisco">TISCO - ธนาคารทิสโก้</option>
										<option value="ttb">TTB - ทหารไทยธนชาต</option>
										<option value="ktb">KTB - ธนาคารกรุงไทย</option>
										<option value="krungsri">BAY - ธนาคารกรุงศรีอยุธยา</option>
										<option value="kiatnakin">KKP - ธนาคารเกียรตินาคิน</option>
										<option value="gsb">GSB - ธนาคารออมสิน</option>
										<option value="lh">LHBANK - ธนาคารแลนด์ แอนด์ เฮ้าส์</option>
										<option value="uob">UOB - ธนาคารยูโอบี</option>
										<option value="ธนาคารอิสลาม">IBANK - ธนาคารอิสลามแห่งประเทศไทย</option>
										<option value="ghbank">GHB - ธนาคารอาคารสงเคราะห์</option>
										<option value="cimb">CIMB - ธนาคารซีไอเอ็มบีไทย</option>
										<option value="baac">BAAC - ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร (ธกส)</option>
										<option value="icbc">ICBC - ธนาคารไอซีบีซี (ไทย)</option>
										<option value="standard">STANDARD - ธนาคารสแตนดาร์ดชาร์เตอร์ดไทย</option>
									</select>
									<input type="text" v-model="newAccountMobile.account_no" class="x-form-control form-control mb-3" :placeholder="newAccountMobile.bank === 'truewallet' ? $t('phone_number') : $t('account_number')" @keypress="isNumber($event)" @input="onAccountNumberInput($event, 'mobile')" @paste="onAccountNumberPaste($event, 'mobile')" inputmode="numeric" maxlength="12">
									<div class="text-center">
										<button type="button" @click="addNewAccountMobile()" class="btn btn-block btn-outline-light py-2" style="border: 2px solid rgb(255, 255, 255); color: rgb(255, 255, 255); font-weight: 500; background-color: #4CAF50;">
											<span>{{ $t('header.add_account') }}</span>
										</button>
										<button type="button" @click="cancelAddAccountMobile()" class="btn btn-block btn-outline-light py-2" style="border: 2px solid #fff; color: #fff; font-weight: 500;">
											<span>{{ $t('cancel') }}</span>
										</button>
									</div>
								</div>
							</div>

							<!-- Add New Account Button Mobile -->
							<!-- <div class="text-center mb-3" v-if="!showAddAccountFormMobile">
								<button type="button" @click="showAddAccountFormMobile = true" class="btn btn-block btn-primary -submit">
									<i class="fas fa-plus"></i> {{ $t('header.add_new_account') }}
								</button>
							</div> -->

							<!-- Approved Accounts Mobile -->
							<div class="-approved-accounts" v-if="getApprovedAccounts().length > 0">
								<div class="x-title-modal -v2 mx-auto text-center" style="font-size: 16px; margin-bottom: 15px; color: #4CAF50;">
									<i class="fas fa-check-circle"></i> {{ $t('header.approved_accounts') }}
								</div>
								<div class="x-customer-bank-info-container -v2 approved-border" v-for="(account, index) in getApprovedAccounts()" :key="'approved-mobile-' + index" style="margin-bottom: 10px;">
									<div class="media m-auto">
										<img v-if="account.bank" :src="getBankImage(account.bank)" class="-img rounded-circle" width="50" height="50" :alt="getBankName(account.bank)">
										<div class="-content-wrapper">
											<span class="-name">{{account.firstname}} {{account.lastname}}</span>
											<span class="-number">{{account.account_no}}</span>
											<span class="-bank-name">{{getBankName(account.bank)}}</span>
											<span class="-status approved">{{ $t('approved_status') }}</span>
										</div>
									</div>
								</div>
								<div class="text-center mb-3" v-if="!showAddAccountFormMobile">
									<button type="button" @click="showAddAccountFormMobile = true" class="btn btn-block btn-outline-light py-2" style="border: 2px solid rgb(255, 255, 255); color: rgb(255, 255, 255); font-weight: 500; background-color: #4CAF50;">
										<i class="fas fa-plus"></i> {{ $t('header.add_new_account') }}
									</button>
								</div>
							</div>

							<!-- Pending Accounts Mobile -->
							<div class="-pending-accounts" v-if="getPendingAccounts().length > 0">
								<div class="x-title-modal -v2 mx-auto text-center" style="font-size: 16px; margin-bottom: 15px; color: #FF5722;">
									<i class="fas fa-clock"></i> {{ $t('header.pending_accounts') }}
								</div>
								<div class="x-customer-bank-info-container -v2 pending-border" v-for="(account, index) in getPendingAccounts()" :key="'pending-mobile-' + index" style="margin-bottom: 10px;">
									<div class="media m-auto">
										<img v-if="account.bank" :src="getBankImage(account.bank)" class="-img rounded-circle" width="50" height="50" :alt="getBankName(account.bank)">
										<div class="-content-wrapper">
											<span class="-name">{{account.firstname}} {{account.lastname}}</span>
											<span class="-number">{{account.account_no}}</span>
											<span class="-bank-name">{{getBankName(account.bank)}}</span>
											<span class="-status pending">{{ $t('pending_approval_status') }}</span>
										</div>
									</div>
								</div>
							</div>

							<!-- No Accounts Message Mobile -->
							<div class="text-center" v-if="!user.accounts || user.accounts.length === 0">
								<p style="color: #fff; font-family: 'Kanit', sans-serif;">{{ $t('header.no_bank_account') }}</p>
							</div>

							<div class="x-admin-contact text-center mt-3">
								<span class="x-text-with-link-component">
								<label class="-text-message ">{{ $t('header.contact_support') }}</label>
								<a :href="adminContactLineLink" class="-link-message " target="_blank" rel="noopener">
									<u>{{ $t('header.contact_customer_service') }}</u>
								</a>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		</div>

		<div
			class="x-modal modal -v2 -with-half-size"
			id="withdrawModal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
			data-loading-container=".modal-body"
			data-container="#withdrawModal"
     	 >
<div class="modal-dialog -modal-size " role="document">
  <div class="modal-content -modal-content">
    <button
      type="button"
      class="close f-1 "
      data-dismiss="modal"
      aria-label="Close"
      style="color: white;"
    >
      <i class="fas fa-times"></i>
    </button>
    <div class="modal-header -modal-header">
      <h3 class="x-title-modal -v2 m-auto">
{{ $t('withdraw') }}
      </h3>
    </div>
    <div
      class="modal-body -modal-body"
      :style="withdrawModalBodyStyle"
    >
      <div class="x-withdraw-form -v2">
  <div
    data-animatable="fadeInModal"
    class="-animatable-container animated fadeInModal"
  >
    <div class="text-center d-flex flex-column">
      <div
class="-x-input-icon x-input-operator mb-3 flex-column"
      >
<button
  type="button"
  class="-icon-left -btn-icon js-adjust-amount-by-operator"
  @click="setWithdraw('minus')"
>
  <i class="fas fa-minus-circle"></i>
</button>
<input
  type="text"
  v-model="withdraw"
  :class="{'x-form-control':true,'text-center':true, 'js-withdraw-input-amount':true ,'-no':true,'form-control':true,'is-invalid':(error)?true:false}"
  :placeholder="$t('withdraw_amount')"
  @keypress="isNumber($event)"

/>
						<div class="invalid-feedback " v-if="error">
							<ul class="list-unstyled mb-0"><li>{{error}}</li></ul>
						</div>
<button
  type="button"
  class="-icon-right -btn-icon js-adjust-amount-by-operator"
  @click="setWithdraw('plus')"
>
  <i class="fas fa-plus-circle"></i>
</button>
      </div>
					<!-- <div  v-if="lastbonus.canwithdraw || lastbonus.turncredit">
					<p class="glow" style="font-size:14px;">
						{{lastbonus.canwithdraw}}/{{lastbonus.turncredit}}
					</p>
					</div> -->
      <div
class="x-select-amount js-quick-amount -v2"
data-target-input="#withdraw_amount"
      >
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(200)"
  >
    <span class="-no">200</span>
  </button>
</div>
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(300)"
  >
    <span class="-no">300</span>
  </button>
</div>
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(500)"
  >
    <span class="-no">500</span>
  </button>
</div>
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(1000)"
  >
    <span class="-no">1000</span>
  </button>
</div>
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(2000)"
  >
    <span class="-no">2000</span>
  </button>
</div>
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(5000)"
  >
    <span class="-no">5000</span>
  </button>
</div>
      </div>
    </div>
	<div><p class="-title" style="font-family: 'Kanit', sans-serif; font-size: 12px; padding-bottom:10px;color:#fff">{{ $t('withdraw_min_max', { min: condition.minimum || 200, max: condition.maximum || 150000 }) }}</p></div>
	<div><p class="-title" style="font-family: 'Kanit', sans-serif; font-size: 12px; padding-bottom:10px;color:#fff">{{ $t('withdraw_daily_limit', { max: condition.maximumperday || 450000, qtyperday: condition.qtyperday || 3 }) }}</p></div>
	<div><p class="-title" style="font-family: 'Kanit', sans-serif; font-size: 12px; padding-bottom:10px;color:#fff" v-html="$t('withdraw_bank_close', { detail: condition.detail || $t('withdraw_bank_close_default') })"></p></div>
	<div class="mt-3 -spacer">
		<!-- Bank Selection for multiple accounts -->
		<div class="mb-3" v-if="getApprovedAccounts().length > 1">
			<label class="form-label" style="color: #fff; font-family: 'Kanit', sans-serif; font-size: 14px; margin-bottom: 10px;">{{ $t('select_withdraw_account') }}</label>
			<select v-model="selectedWithdrawAccount" class="x-form-control form-control mb-3" @change="onWithdrawAccountChange()">
				<option value="">{{ $t('select_account_to_receive') }}</option>
				<option 
					v-for="(account, index) in getApprovedAccounts()" 
					:key="'withdraw-account-' + index"
					:value="account"
				>
					{{getBankName(account.bank)}} - {{account.firstname}} {{account.lastname}} ({{account.account_no}})
				</option>
			</select>
		</div>

		<div class="x-deposit-bank-info-container -v2">
		<div class="media m-auto" v-if="getApprovedAccounts().length > 0">
			<img
			v-if="getSelectedWithdrawAccount().bank" :src="getBankImage(getSelectedWithdrawAccount().bank)"
			class="-img rounded-circle"
			width="50"
			height="50"
			alt="bank-bay"
			/>
			<div class="-content-wrapper">
			<span class="-own-name"
				>{{getSelectedWithdrawAccount().firstname}} {{getSelectedWithdrawAccount().lastname}}</span
			>
			<span id="depositBankNumber" class="-number"
				>{{getSelectedWithdrawAccount().account_no}}</span
			>
			</div>
			<div class="-copy-wrapper">
			<a
				href="javascript:void(0);"
				style="cursor: default;"
				class="btn -btn js-copy-to-clipboard"
				>{{ $t('to_this_account') }}</a
			>
			</div>
		</div>
		<div class="text-center" v-else>
			<p style="color: #fff; font-family: 'Kanit', sans-serif; font-size: 14px;">
				{{ $t('add_bank_before_withdraw') }}
			</p>
		</div>
		</div>
	</div>
    <div class="text-center">
      <button
type="button"
class="btn -submit btn-primary my-0 my-lg-3 f-5 f-lg-6"
						@click="withdrawConfirm()"
      >
{{ $t('confirm') }}
      </button>
    </div>
  </div>

  <input
    type="hidden"
    id="withdraw__token"
    name="withdraw[_token]"
    value="bllExR5-OWRJU6oF0VySYE94ynEFuTfZGWIxep2iqUo"
  />
      </div>
    </div>
  </div>
</div>
      	</div>

		<div
			class="x-modal modal -v2 -with-backdrop -with-separator -with-half-size"
			id="depositModal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
			data-loading-container=".modal-body"
			data-container="#depositModal"
      >
<div
  class="modal-dialog -modal-size"
  :class="{ 's3pay-modal-dialog--active': !!activeUnifiedDepositView }"
  role="document"
>
  <div
    class="modal-content -modal-content"
    :class="{ 's3pay-modal-content--active': !!activeUnifiedDepositView }"
  >
      <button
	v-if="!activeUnifiedDepositView"
	type="button"
	class="close f-1 "
	data-dismiss="modal"
	:disabled="!!(activeUnifiedDepositView && (activeUnifiedDepositView.cancelling || activeUnifiedDepositView.uploading))"
	aria-label="Close"
	style="color: white;"
      >
<i class="fas fa-times"></i>
      </button>
      <div
        ref="depositModalBody"
        class="modal-body -modal-body"
        :class="{
          's3pay-modal-body--active': !!activeUnifiedDepositView,
          'deposit-form-modal-body--scrollable': !activeUnifiedDepositView
        }"
        :style="{ 'top': '0px', 'min-height': showBankSelectionForDeposit ? 'auto' : '400px', 'height': showBankSelectionForDeposit ? 'auto' : 'auto' }"
      >
<UnifiedDepositPaymentPanel
  v-if="activeUnifiedDepositView"
  :customer-account="unifiedDepositCustomerAccount"
  :receiver-account="activeUnifiedDepositView.receiverAccount"
  :qr-image="activeUnifiedDepositView.qrImage"
  :qr-payload="activeUnifiedDepositView.qrPayload"
  :payment-url="activeUnifiedDepositView.paymentUrl"
  :amount="activeUnifiedDepositView.amount"
  :amount-pending="activeUnifiedDepositView.amountPending || false"
  :remaining-text="activeUnifiedDepositView.remainingText"
  :expires-at="activeUnifiedDepositView.expiresAt"
  :fallback-countdown-seconds="activeUnifiedDepositView.fallbackCountdownSeconds"
  :checking="activeUnifiedDepositView.checking"
  :cancelling="activeUnifiedDepositView.cancelling"
  :uploading="activeUnifiedDepositView.uploading"
  :show-cancel="activeUnifiedDepositView.showCancel"
  :show-upload="activeUnifiedDepositView.showUpload"
  @cancel="cancelUnifiedDepositView"
  @upload="uploadUnifiedDepositSlip"
/>
<div class="x-pending -v2 " v-else>
  <div
    class="js-content text-center -animated-wrapper animated fadeInModal"
    data-animatable="fadeInModal"
  >
    <div class="-fake-bg-bottom-wrapper">
      <div class="x-modal-separator-container ">
		<!-- Step 1: Bank Selection for Customer (when multiple approved accounts) -->
		<div class="mt-3 -spacer" v-if="showBankSelectionForDeposit && !depositAmount" style="padding: 20px 15px;">
			<div class="text-center mb-3">
				<label class="form-label" style="color: #fff; font-family: 'Kanit', sans-serif; font-size: 16px; margin-bottom: 15px;">
					{{ $t('please_select_bank_for_deposit') }}
				</label>
			</div>
			<div class="mb-3">
				<select v-model="selectedDepositAccount" class="x-form-control form-control mb-3" @change="onDepositBankSelected()" :disabled="isBankLoading" style="padding: 12px 15px; font-size: 15px; font-family: 'Kanit', sans-serif;">
					<option value="">{{ isBankLoading ? $t('loading_status') : $t('select_your_bank') }}</option>
					<option 
						v-for="(account, index) in getApprovedAccounts()" 
						:key="'deposit-account-' + index"
						:value="account"
					>
						{{getBankName(account.bank)}} - {{account.firstname}} {{account.lastname}} ({{account.account_no}})
					</option>
				</select>
				
				<!-- Slip Upload Button for Step 1 -->
				<div class="mb-3">
					<input type="file" ref="fileInputStep1" accept="image/*" @change="uploadSlip" style="display: none;">
					<button 
						type="button" 
						@click="openBrowseFileStep1()" 
						class="btn btn-block w-100"
						style="background: linear-gradient(135deg, #ff8c42 0%, #f48d1f 100%); border: none; font-family: 'Kanit', sans-serif; font-size: 16px; padding: 14px; border-radius: 10px; color: white; font-weight: 500; box-shadow: 0 2px 10px rgba(244, 141, 31, 0.3);"
					>
						<i class="fas fa-cloud-upload-alt mr-2"></i>
						<span style="font-size:14px;">{{ $t('deposit_slip') }}</span>
					</button>
				</div>
				
				<div class="text-center" v-if="isBankLoading">
					<div style="color: #fff; font-family: 'Kanit', sans-serif; font-size: 14px; margin: 10px 0;">
						<i class="fas fa-spinner fa-spin"></i> {{ $t('loading_bank_data') }}
					</div>
				</div>
				<div class="text-center mt-3" v-else>
					<button type="button" @click="cancelBankSelection()" class="btn btn-outline-light px-4 py-2" style="border: 2px solid #fff; color: #fff; font-weight: 500; font-family: 'Kanit', sans-serif; font-size: 14px;">
						<span>{{ $t('skip_for_now') }} ({{ $t('use_first_account') }})</span>
					</button>
				</div>
			</div>
		</div>

		<!-- Step 2: Amount Input -->
		<div class="mt-3 -spacer" v-if="!showBankSelectionForDeposit && !depositAmount && !corepaypage" style="padding: 15px;">
			
			<!-- Promotion Selection for Amount Input Page -->
			<div class="mb-3" v-if="promotions && promotions.name">
				<div class="text-center mb-2">
					<label class="form-label deposit-promotion-hint" style="color: #fff; font-family: 'Kanit', sans-serif; font-size: 14px; margin-bottom: 10px; display: block;">
						{{ $t('deposit_promotion') }}
					</label>
				</div>
				<div class="d-flex align-items-center justify-content-between mb-3" :style="{background: gotpro ? '#64fc7ecc' : '#f74040cc', borderRadius: '10px', padding: '15px'}">
					<div class="d-flex align-items-center">
						<img src="../assets/images/ic-gift.png" class="mr-3" :alt="promotions.name" width="32" height="32" style="filter: brightness(1.2);">
						<div>
							<div class="font-weight-bold" style="color: white; font-family: 'Kanit', sans-serif; font-size: 16px; line-height: 1.2;">
								{{promotions.name}}
							</div>
							<div class="mt-1" style="color: rgba(255,255,255,0.9); font-family: 'Kanit', sans-serif; font-size: 13px;">
								{{gotpro ? $t('select_receive_promotion') : $t('no_promotion')}}
								<span @click="showPromotionTerms" class="ml-2" style="color: #ffeb3b; cursor: pointer; text-decoration: underline; font-size: 15px;">{{ $t('terms') }}</span>
							</div>
						</div>
					</div>
					<div class="ml-3">
						<label class="rocker rocker-small" style="transform: scale(0.9);">
							<input type="checkbox" v-model="gotpro">
							<span class="switch-left" style="background: #4CAF50; color: white; font-family: 'Kanit', sans-serif; font-size: 12px;">{{ $t('receive') }}</span>
							<span class="switch-right" style="background: #f44336; color: white; font-family: 'Kanit', sans-serif; font-size: 12px;">{{ $t('not_receive') }}</span>
						</label>
					</div>
				</div>
			</div>
			<!-- Promotion Terms Info Box -->
			<div class="promotion-terms-info" style="background: linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 152, 0, 0.1) 100%); border: 1px solid rgba(255, 193, 7, 0.3); border-radius: 10px; padding: 15px; margin: 15px 0; font-family: 'Kanit', sans-serif;">
				<div style="display: flex; align-items: center; margin-bottom: 10px;">
					<i class="fas fa-info-circle" style="color: #ffc107; font-size: 16px; margin-right: 8px;"></i>
					<span style="color: #ffc107; font-weight: 600; font-size: 14px;">{{ $t('promotion_terms_info') }}</span>
				</div>
				<ul style="margin: 0; padding-left: 20px; list-style: none; color: rgba(255, 255, 255, 0.9); font-size: 13px; line-height: 1.6;">
					<li style="margin-bottom: 6px;">
						<span style="color: #4CAF50;">✓</span> {{ $t('promotion_term_1') }}
					</li>
					<li class="promotion-term-single-line" style="margin-bottom: 6px;">
						<span style="color: #FF5722;">⚠</span> {{ $t('promotion_term_2') }}
					</li>
					<li style="margin-bottom: 0;">
						<span style="color: #f44336;">⛔</span> {{ $t('promotion_term_3') }}
					</li>
				</ul>
			</div>
			<div class="text-center mb-3">
				<label class="form-label" style="color: #fff; font-family: 'Kanit', sans-serif; font-size: 18px; margin-bottom: 20px; display: block;">
					{{ $t('specify_deposit_amount') }}
				</label>
			</div>
			<!-- Quick Amount Buttons -->
			<!-- <div class="row mb-3" style="margin: 0 -5px;">
				<div class="col-4 px-1 mb-2">
					<button 
						type="button" 
						@click="setDepositAmount(200)" 
						class="btn btn-block w-100"
						style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; font-family: 'Kanit', sans-serif; font-size: 15px; padding: 14px 8px; border-radius: 10px; border: none; min-height: 50px; font-weight: 500; white-space: nowrap; overflow: hidden;"
					>200</button>
				</div>
				<div class="col-4 px-1 mb-2">
					<button 
						type="button" 
						@click="setDepositAmount(300)" 
						class="btn btn-block w-100"
						style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; font-family: 'Kanit', sans-serif; font-size: 15px; padding: 14px 8px; border-radius: 10px; border: none; min-height: 50px; font-weight: 500; white-space: nowrap; overflow: hidden;"
					>300</button>
				</div>
				<div class="col-4 px-1 mb-2">
					<button 
						type="button" 
						@click="setDepositAmount(500)" 
						class="btn btn-block w-100"
						style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; font-family: 'Kanit', sans-serif; font-size: 15px; padding: 14px 8px; border-radius: 10px; border: none; min-height: 50px; font-weight: 500; white-space: nowrap; overflow: hidden;"
					>500</button>
				</div>
				<div class="col-4 px-1 mb-2">
					<button 
						type="button" 
						@click="setDepositAmount(1000)" 
						class="btn btn-block w-100"
						style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; font-family: 'Kanit', sans-serif; font-size: 15px; padding: 14px 8px; border-radius: 10px; border: none; min-height: 50px; font-weight: 500; white-space: nowrap; overflow: hidden;"
					>1000</button>
				</div>
				<div class="col-4 px-1 mb-2">
					<button 
						type="button" 
						@click="setDepositAmount(2000)" 
						class="btn btn-block w-100"
						style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; font-family: 'Kanit', sans-serif; font-size: 15px; padding: 14px 8px; border-radius: 10px; border: none; min-height: 50px; font-weight: 500; white-space: nowrap; overflow: hidden;"
					>2000</button>
				</div>
				<div class="col-4 px-1 mb-2">
					<button 
						type="button" 
						@click="setDepositAmount(5000)" 
						class="btn btn-block w-100"
						style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; font-family: 'Kanit', sans-serif; font-size: 15px; padding: 14px 8px; border-radius: 10px; border: none; min-height: 50px; font-weight: 500; white-space: nowrap; overflow: hidden;"
					>5000</button>
				</div>
			</div> -->
			
			<!-- Custom Amount Input -->
			<div class="mb-3">
				<!-- <label style="color: rgba(255,255,255,0.7); font-family: 'Kanit', sans-serif; font-size: 14px; margin-bottom: 8px; display: block;">
					{{ $t('deposit_amount') }}
				</label> -->
				<div class="input-group">
					<input 
						type="number" 
						v-model="inputDepositAmount" 
						class="form-control" 
						:placeholder="$t('amount_baht_placeholder')" 
						min="1"
						style="padding: 12px 15px; font-size: 18px; font-family: 'Kanit', sans-serif; text-align: center; background: rgba(255,255,255,0.1); color: #fff; border: 1px solid rgba(255,255,255,0.3); border-radius: 10px 0 0 10px;"
					/>
					<span class="input-group-text" style="background: rgba(255,255,255,0.1); color: #fff; border: 1px solid rgba(255,255,255,0.3); border-radius: 0 10px 10px 0; font-family: 'Kanit', sans-serif;">{{ $t('baht_unit') }}</span>
				</div>
			</div>

			<small class="s3pay-deposit-range" v-if="paymentOnlyDepositRangeText">
				ระบบรองรับยอดฝาก {{ paymentOnlyDepositRangeText }} บาท ต่อรายการเท่านั้น
			</small>
			
			<!-- Action Buttons -->
			<div class="row mt-4" style="margin: 0 -5px;">
				<div class="col-6 px-1">
					<button 
						type="button" 
						@click="submitDepositAmount()" 
						class="btn btn-block w-100" 
						:disabled="!inputDepositAmount || inputDepositAmount <= 0 || isBankLoading"
						style="background: linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%); border: none; font-weight: 500; font-family: 'Kanit', sans-serif; font-size: 16px; padding: 14px; border-radius: 10px; min-height: 52px;"
					>
						<span v-if="!isBankLoading">{{ $t('confirm_amount') }}</span>
						<span v-else><i class="fas fa-spinner fa-spin"></i> {{ $t('processing_status') }}</span>
					</button>
				</div>
				<div class="col-6 px-1">
					<button 
						type="button" 
						data-dismiss="modal"
						class="btn btn-block w-100" 
						style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); border: none; font-weight: 500; font-family: 'Kanit', sans-serif; font-size: 16px; padding: 14px; border-radius: 10px; min-height: 52px; color: white;"
					>
						{{ $t('close_window') }}
					</button>
				</div>
			</div>
			
			<!-- Upload Slip Button for Step 2 -->
			<div class="mt-4 mb-3">
				<input type="file" ref="fileInputStep2" accept="image/*" @change="uploadSlip" style="display: none;">
				<button 
					type="button" 
					@click="openBrowseFileStep2()" 
					class="btn btn-block w-100"
					style="background: linear-gradient(135deg, #ff8c42 0%, #f48d1f 100%); border: none; font-family: 'Kanit', sans-serif; font-size: 16px; padding: 14px; border-radius: 10px; color: white; font-weight: 500; box-shadow: 0 2px 10px rgba(244, 141, 31, 0.3);"
				>
					<i class="fas fa-cloud-upload-alt mr-2"></i>
					<span style="font-size:14px;">{{ $t('deposit_slip') }}</span>
				</button>
			</div>
		</div>

		<PayBridgeDepositPanel
			v-if="paybridgeMatch && !corepaypage"
			:match="paybridgeMatch"
			:amount="paybridgeDisplayAmount"
			:acknowledged="paybridgeAcknowledged"
			:remaining-text="paybridgeTaskRemainingText"
			:bank-image="getPayBridgeBankImage((paybridgeMatch.recipientAccount || {}).bankCode)"
			:cancelling="paybridgeCancelling"
			@acknowledge="acknowledgePayBridgeTerms"
			@cancel="cancelPayBridgeTask"
			@upload="uploadPayBridgeSlip"
		/>

		<!-- Step 3: Show Bank Details with Decimal -->
		<div class="mt-3 -spacer" v-if="depositAmount && assignedBank && !corepaypage && !paybridgeMatch" style="padding: 20px 15px;">
			<div class="text-center mb-3">
				<!-- Selected Customer Account Info -->
				<div style="margin-top: 0px; background: #fff; border: 1px solid #4CAF50; border-radius: 8px; padding: 12px; margin-bottom: 10px;">
					<div style="color: #000;padding-bottom: 5px;">{{ $t('deposit_from_this_account_only') }}</div>
					<div style="display: flex; align-items: center; justify-content: space-between; font-family: 'Kanit', sans-serif;">
						<div style="display: flex; align-items: center;">
							<img
								v-if="(currentDepositAccount || getApprovedAccounts()[0] || {}).bank"
								:src="getBankImage((currentDepositAccount || getApprovedAccounts()[0] || {}).bank)"
								style="width: 24px; height: 24px; border-radius: 50%; margin-right: 8px;"
								:alt="(currentDepositAccount || getApprovedAccounts()[0] || {}).bank"
							/>
							<div>
								<div style="color: #4CAF50; font-size: 14px; font-weight: 600; margin-bottom: 2px;">
									{{ getBankName((currentDepositAccount || getApprovedAccounts()[0] || {}).bank) }}
								</div>
								<div style="color: #333; font-size: 11px;">
									{{ (currentDepositAccount || getApprovedAccounts()[0] || {}).firstname }} {{ (currentDepositAccount || getApprovedAccounts()[0] || {}).lastname }}
								</div>
							</div>
						</div>
						<div style="text-align: right;">
							<div style="color: #333; font-size: 14px; font-weight: 600; font-family: monospace;">
								{{ (currentDepositAccount || getApprovedAccounts()[0] || {}).account_no }}
							</div>
						</div>
					</div>
				</div>
				<div style="background: rgba(76, 175, 80, 0.2); border: 2px solid #4CAF50; border-radius: 10px; padding: 15px; margin-bottom: 15px;">
					<h5 style="color: #4CAF50; font-family: 'Kanit', sans-serif; margin-bottom: 10px;">
						{{ $t('amount_to_transfer') }}
					</h5>
					<h3 style="color: #fff; font-family: 'Kanit', sans-serif; font-size: 32px; margin: 0;">
						฿ {{ depositAmountWithDecimal }}
					</h3>
					<p style="color: #ffc107; font-family: 'Kanit', sans-serif; font-size: 14px; margin-top: 10px; margin-bottom: 5px;">
						<i class="fas fa-clock"></i> กรุณาทำรายการก่อน {{ deadlineTime }}
					</p>
					<div v-if="depositTimer" style="color: #fff; font-size: 18px; font-weight: bold;">
						{{ $t('time_remaining') }}: {{ formatTime(depositTimer) }}
					</div>
				</div>

				<div v-if="isSecurePayDepositActive" style="margin-bottom: 15px;">
					<SecurePayDepositFrame
						:payment-url="securePayPageUrl"
						:transaction="securePayTransaction"
					/>
				</div>

				<div class="x-deposit-bank-info-container -v2" v-if="!isSecurePayDepositActive">
					<div class="media m-auto" v-if="assignedBank.bank_name">
						<img
							:src="getBankImage(assignedBank.bank_name)"
							class="-img rounded-circle"
							width="50"
							height="50"
							:alt="assignedBank.bank_name"
						/>
						<div class="-content-wrapper">
							<span class="-name">{{getBankName(assignedBank.bank_name)}}</span>
							<span class="-own-name">{{assignedBank.firstname}} {{assignedBank.lastname}}</span>
							<span class="-number">{{assignedBank.account_no}}</span>
						</div>
						<div class="-copy-wrapper">
							<a
								href="javascript:void(0);"
								class="btn -btn js-copy-to-clipboard"
								v-clipboard:copy="assignedBank.account_no ? assignedBank.account_no.replace(/-/g,'') : ''"
								v-clipboard:success="clipboardSuccessHandler"
							>{{ $t('copy_button') }}</a>
						</div>
					</div>
					<!--div-- class="media m-auto" v-if="assignedBank.bank_name === 'truewallet'">
						<img
							:src="getBankImage(assignedBank.bank_name)"
							class="-img rounded-circle"
							width="50"
							height="50"
							:alt="assignedBank.bank_name"
						/>
						<div class="-content-wrapper">
							<span class="-name">{{getBankName(assignedBank.bank_name)}}</span>
							<span class="-own-name">{{assignedBank.firstname}} {{assignedBank.lastname}}</span>
							<span class="-number">{{assignedBank.mobile}}</span>
						</div>
						<div class="-copy-wrapper">
							<a
								href="javascript:void(0);"
								class="btn -btn js-copy-to-clipboard"
								v-clipboard:copy="assignedBank.mobile ? assignedBank.mobile.replace(/-/g,'') : ''"
								v-clipboard:success="clipboardSuccessHandler"
							>{{ $t('copy_button') }}</a>
						</div>
					</!--div-->
				</div>
				
				<div v-if="!isSecurePayDepositActive" style="margin-top: 10px;background: rgba(76, 175, 80, 0.2); border: 2px solid #f44336; border-radius: 10px; padding: 15px; margin-bottom: 15px;" v-html="$t('auto_credit_adjustment_warning')"></div>
				<!-- Upload Slip Button for Step 3 -->
				<div class="mt-4 mb-3" v-if="!isSecurePayDepositActive">
					<input type="file" ref="fileInputStep3" accept="image/*" @change="uploadSlip" style="display: none;">
					<button 
						type="button" 
						@click="openBrowseFileStep3()" 
						class="btn btn-block w-100"
						style="background: linear-gradient(135deg, #ff8c42 0%, #f48d1f 100%); border: none; font-family: 'Kanit', sans-serif; font-size: 16px; padding: 14px; border-radius: 10px; color: white; font-weight: 500; box-shadow: 0 2px 10px rgba(244, 141, 31, 0.3);"
					>
						<i class="fas fa-cloud-upload-alt mr-2"></i>
						<span style="font-size:14px;">{{ $t('deposit_slip') }}</span>
					</button>
				</div>
				
				<div class="text-center mt-4">
					<button
						type="button"
						class="btn btn-block w-100"
						:disabled="isCancellingBankDeposit"
						style="margin-bottom: 10px; background: #fee2e2; border: none; font-family: 'Kanit', sans-serif; font-size: 16px; padding: 12px; border-radius: 10px; color: #b91c1c; font-weight: 600;"
						@click="confirmCancelBankDeposit()"
					>
						<i :class="isCancellingBankDeposit ? 'fas fa-spinner fa-spin mr-2' : 'fas fa-times-circle mr-2'"></i>
						<span>{{ isCancellingBankDeposit ? 'กำลังยกเลิกรายการ' : 'ยกเลิกรายการเดิมและสร้างรายการใหม่' }}</span>
					</button>
					<button 
						type="button" 
						data-dismiss="modal"
						class="btn btn-block w-100" 
						style="background: #e2e8f0; border: none; font-family: 'Kanit', sans-serif; font-size: 16px; padding: 12px; border-radius: 10px; color: #334155; font-weight: 600;"
					>
						<i class="fas fa-times mr-2"></i>
						<span>{{ $t('close_window') }}</span>
					</button>
				</div>
			</div>
		</div>

		<!-- Old deposit system - hidden for new flow -->
		<div class="-top " v-if="false">
	<div class="mt-3 -spacer" v-if="papaya && user.bank !== 'truewallet'">
		<div class="x-deposit-bank-info-container -v2">
		<div class="media m-auto" @click="showCorepayPage()">
			<img
			src="https://play-lh.googleusercontent.com/UIdkgBTFEFYTbE-_hUnekG5Aq16au9J7C6RI5gnoAeEZV2zMC3XgOnjL-0aYdmyWk6k=w240-h480-rw"
			class="-img rounded-circle"
			width="50"
			height="50"
			alt="bank-bay"
			/>
			<div class="-content-wrapper">
				<span class="-name" style="font-size: large;">{{ $t('deposit_promptpay') }}</span>
			</div>
			<div class="-copy-wrapper">
			<a
				href="javascript:void(0);"
				class="btn -btn js-copy-to-clipboard"
				style="padding: 10px;"
				>Click</a
			>
			</div>
		</div>
		</div>
	</div>
	<!-- Bank Loading Skeleton -->
	<div class="mt-3 -spacer" v-if="isBankLoading && !bank.bank_name">
		<div class="x-deposit-bank-info-container -v2">
			<div class="media m-auto">
				<div style="width: 50px; height: 50px; background: linear-gradient(90deg, #f0f0f0 25%, rgba(255,255,255,.5) 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite;" class="rounded-circle"></div>
				<div class="-content-wrapper">
					<div style="height: 18px; background: linear-gradient(90deg, #f0f0f0 25%, rgba(255,255,255,.5) 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; border-radius: 4px; margin-bottom: 8px; width: 120px;"></div>
					<div style="height: 16px; background: linear-gradient(90deg, #f0f0f0 25%, rgba(255,255,255,.5) 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; border-radius: 4px; margin-bottom: 8px; width: 160px;"></div>
					<div style="height: 16px; background: linear-gradient(90deg, #f0f0f0 25%, rgba(255,255,255,.5) 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; border-radius: 4px; width: 140px;"></div>
				</div>
				<div class="-copy-wrapper">
					<div style="width: 60px; height: 32px; background: linear-gradient(90deg, #f0f0f0 25%, rgba(255,255,255,.5) 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; border-radius: 4px;"></div>
				</div>
			</div>
		</div>
	</div>

	<!-- Debug Info (สำหรับ development) -->
	<div v-if="false" style="color: white; background: rgba(0,0,0,0.8); padding: 10px; margin: 10px 0; font-size: 12px;">
		Debug: hideBankSection={{ hideBankSection }}, isBankLoading={{ isBankLoading }}, 
		bank.bank_name={{ bank.bank_name }}, banks={{ bank }}
	</div>

	<!-- No Bank Available Message -->
	<div class="mt-3 -spacer" v-if="hideBankSection && !isBankLoading">
		<div class="x-deposit-bank-info-container -v2">
			<div class="text-center" style="padding: 20px;">
				<div style="color: #ff6b6b; font-size: 48px; margin-bottom: 15px;">
					<i class="fas fa-clock"></i>
				</div>
				<h5 style="color: #fff; font-family: 'Kanit', sans-serif; margin-bottom: 10px;">
					{{ $t('no_deposit_channel_available') }}
				</h5>
				<p style="color: #ccc; font-family: 'Kanit', sans-serif; font-size: 14px; margin-bottom: 15px;">
					{{ $t('bank_closed_now') }}
				</p>
				<div style="background: rgba(255,255,255,0.1); border-radius: 8px; padding: 15px; margin-bottom: 15px;">
					<p style="color: #4CAF50; font-family: 'Kanit', sans-serif; font-size: 13px; margin-bottom: 8px;">
						<i class="fas fa-info-circle"></i> {{ $t('service_hours') }}
					</p>
					<p style="color: #fff; font-family: 'Kanit', sans-serif; font-size: 12px; margin: 0;">
						• SCB: 01:00 - 23:50<br>
						• KBANK: 00:00 - 23:50<br>
						• {{ $t('truewallet_24hrs') }}
					</p>
				</div>
				<div class="text-center">
					<button type="button" @click="retryBankLoad()" 
					        class="btn btn-outline-light px-3 py-2 mr-2" 
					        style="border: 2px solid #fff; color: #fff; font-weight: 500;">
						<i class="fas fa-sync-alt"></i> {{ $t('try_again') }}
					</button>
					<a :href="adminContactLineLink" target="_blank" 
					   class="btn btn-outline-light px-3 py-2" 
					   style="border: 2px solid #4CAF50; color: #4CAF50; font-weight: 500; text-decoration: none;">
						<i class="fab fa-line"></i> {{ $t('contact_admin') }}
					</a>
				</div>
			</div>
		</div>
	</div>

	<!-- Bank Data -->
	<div class="mt-3 -spacer" v-if="bank && bank.bank_name && bank.bank_name !== 'truewallet' && !isBankLoading && !hideBankSection">
    <div class="x-deposit-bank-info-container -v2">
      <div class="media m-auto">
		<img
		:src="getBankImage(bank.bank_name)"
		class="-img rounded-circle"
		width="50"
		height="50"
		alt="bank-bay"
		/>
		<div class="-content-wrapper">
		<span class="-name">{{getBankName(bank.bank_name)}}</span>
		<span class="-own-name"
			>{{bank.firstname}} {{bank.lastname}}</span
		>
		<span id="depositBankNumber" class="-number"
			>{{bank.account_no}}</span
		>
		</div>
		<div class="-copy-wrapper">
		<a
			href="javascript:void(0);"
			class="btn -btn js-copy-to-clipboard"
			v-clipboard:copy="bank.account_no ? bank.account_no.replace(/-/g,'') : ''"
											v-clipboard:success="clipboardSuccessHandler"
			>{{ $t('copy_button') }}</a>
		
		</div>
      </div>
    </div>
  </div>
  <!-- <div class="mt-3 -spacer" v-if="bank && bank.scb && bank.scb.accountno && user && (config.scb || config.scb2 || config.scb3)">
    <div class="x-deposit-bank-info-container -v2">
      <div class="media m-auto">
		<img
		src="../assets/images/bank/scb.jpg"
		class="-img rounded-circle"
		width="50"
		height="50"
		alt="bank-bay"
		/>
		<div class="-content-wrapper">
		<span class="-name">ธนาคารไทยพาณิชย์</span>
		<span class="-own-name"
			>{{bank.scb.firstname}} {{bank.scb.lastname}}</span
		>
		<span id="depositBankNumber" class="-number"
			>{{bank.scb.accountno}}</span
		>
		</div>
		<div class="-copy-wrapper">
		<a
			href="javascript:void(0);"
			class="btn -btn js-copy-to-clipboard"
			v-clipboard:copy="bank.scb.accountno.replace(/-/g,'')"
											v-clipboard:success="clipboardSuccessHandler"
			>{{ $t('copy_button') }}</a>
		
		</div>
      </div>
    </div>
  </div> -->

  <!-- <div class="mt-3 -spacer" v-if="bank.kbank && bank.kbank.accountno && user && (user.bank !== 'kbank' || config_kbank) && config.kbank">
				<div class="x-deposit-bank-info-container -v2">
				<div class="media m-auto">
					<img
					src="../assets/images/bank/kbank.jpg"
					class="-img rounded-circle"
					width="50"
					height="50"
					alt="bank-bay"
					/>
					<div class="-content-wrapper">
					<span class="-name">ธนาคารกสิกร</span>
					<span class="-own-name"
						>{{bank.kbank.firstname}} {{bank.kbank.lastname}}</span
					>
					<span id="depositBankNumber" class="-number"
						>{{bank.kbank.accountno}}</span
					>
					</div>
					<div class="-copy-wrapper">
					<a
						href="javascript:void(0);"
						class="btn -btn js-copy-to-clipboard"
						v-clipboard:copy="bank.kbank.accountno.toString().replace(/-/g,'')"
														v-clipboard:success="clipboardSuccessHandler"
						>{{ $t('copy_button') }}</a>
					
					</div>
				</div>
				</div>
			</div>	 -->
  
						  <div class="mt-3 -spacer" v-if="bank && bank.bank_name == 'truewallet' && !hideBankSection">
    <div class="x-deposit-bank-info-container -v2">
      <div class="media m-auto">
<img
  src="../assets/images/bank/tmw.png"
  class="-img rounded-circle"
  width="50"
  height="50"
  alt="bank-bay"
/>
<div class="-content-wrapper">
  <span class="-name">ทรูมันนี่ วอลเล็ท</span>
  <span class="-own-name"
    >{{bank.firstname}}  {{bank.lastname}}</span
  >
  <span id="depositBankNumber2" class="-number"
    >{{bank.account_no}}</span
  >
</div>
<div class="-copy-wrapper">
  <a
    href="javascript:void(0);"
	v-clipboard:copy="bank.account_no ? bank.account_no.replace(/-/g,'') : ''"
	v-clipboard:success="clipboardSuccessHandler"
    class="btn -btn js-copy-to-clipboard"
    >{{ $t('copy_button') }}</a>
  
</div>
      </div>
    </div>
  </div>
							<!-- <div class="-spacer">
								<div class="x-danger-zone -v2 ">
								<span
									>{{ $t('deposit_account') }}</span
								>
								</div>
							</div> -->
						  	<div class="-spacer">
								<hr class="-liner">
							</div>
							

							<div class="x-deposit-promotion-outer-container js-scroll-ltr -fade -on-left -on-right" v-if="promotions && promotions.name">
								<div><p class="-title" style="font-family: 'Kanit', sans-serif; font-size: 12px; padding-bottom:10px;color:#fff">{{ $t('deposit_promotion') }}</p></div>
								<div class="x-deposit-promotion -v2 -slide pt-0" data-scroll-booster-container=".x-deposit-promotion-outer-container" data-scroll-booster-content=".x-deposit-promotion" style="transform: translate(0px, 0px);">
									<div :class="{'-promotion-box-wrapper':true,'-active':this.gotpro}">
										<button type="button" :class="{'btn -promotion-box-apply-btn js-promotion-apply':true,'-active':this.gotpro}">
											<img src="../assets/images/ic-gift.png" class="-img" :alt="promotions.name" width="26" height="26">
											<span class="-title" style="font-size: 12px;">{{promotions.name}}</span>
										</button>
										<div class="mid">
										 <label class="rocker rocker-small" style="box-sizing: inherit;margin:0;padding:0;">
											<input type="checkbox" v-model="this.gotpro">
											<span class="switch-left">{{ $t('receive') }}</span>
											<span class="switch-right">{{ $t('not_receive') }}</span>
										</label>
										</div>
										<!-- <a href="javascript:void(0)" :class="{'-promotion-box-cancel-btn js-cancel-promotion':true,'-show':this.gotpro}">
											<i class="fas fa-times"></i>
										</a> -->
									</div>

									<div class="-promotion-box-wrapper -active" style="font-family: Kanit, sans-serif;min-width: 65%;background: transparent;align-items: flex-start;justify-content: flex-start;" v-if="promotions.detail">
										<span style="font-size:16px">{{ $t('details') }}</span>
										<span style="font-size:13px;text-align: left;" v-html="nl2br(promotions.detail)"></span>
									</div>

									<!-- <div class="-promotion-box-wrapper -active">
										<button type="button" class="btn -promotion-box-apply-btn js-promotion-apply -active" data-url="/promotion/27/apply" data-type="deposit" data-display-slide-mode="true">
											<img src="../assets/images/ic-gift.png" class="-img" :alt="$t('bonus_2_percent_deposit')" width="26" height="26">
											<span class="-title" style="font-size: 12px;">{{ $t('bonus_2_percent_deposit') }}</span>
										</button>
										<a href="javascript:void(0)" class="-promotion-box-cancel-btn js-cancel-promotion -show" data-url="/promotion-active/cancel" data-display-slide-mode="true">
											<i class="fas fa-times"></i>
										</a>
									</div> -->
    							</div>
 							</div>
							<div><p class="-description" style="font-family: 'Kanit', sans-serif;">{{ $t('no_bonus_description') }}</p></div>
							<div class="-spacer" style="cursor:pointer" @click="openBrowseFileOld()">
								<input type="file" ref="fileInputOld" accept="image/*" @change="uploadSlip">
								<div class="x-danger-zone -v2" style="background:#f48d1f;color:#fff;">
								<span style="font-size:13px;">{{ $t('deposit_slip') }}</span>
								</div>
							</div>

</div>
<div class="-top" v-else-if="corepayimage">
	<iframe :src="corepayimage" width="100%" style="height:90vh;"></iframe>
</div>
<div class="-top" v-else-if="corepaymessage">
	{{corepaymessage}}
</div>
<div class="-top" style="padding-bottom: 30px;" v-else-if="corepaypage">
  <div class="x-deposit-bank-info-container -v2" style="background-color: transparent;">
		<div class="media m-auto">
        <div
          data-animatable="fadeInModal"
          class="-animatable-container animated fadeInModal" style="width:80%"
        >
          <div class="text-center d-flex flex-column" style="bottom: 30px;">
          <div
            class="-x-input-icon x-input-operator mb-3 flex-column"
          >
        <button
        type="button"
        class="-icon-left -btn-icon js-adjust-amount-by-operator"
        @click="setWithdraw2('minus')"
        >
        <i class="fas fa-minus-circle"></i>
        </button>
        <input
        type="text"
        v-model="deposit_value"
        :class="{'x-form-control':true,'text-center':true, 'js-withdraw-input-amount':true ,'-no':true,'form-control':true,'is-invalid':(error)?true:false}"
        :placeholder="$t('deposit_amount')"
        @keypress="isNumber($event)"

        />
                    <div class="invalid-feedback " v-if="error">
                      <ul class="list-unstyled mb-0"><li>{{error}}</li></ul>
                    </div>
        <button
        type="button"
        class="-icon-right -btn-icon js-adjust-amount-by-operator"
        @click="setWithdraw2('plus')"
        >
        <i class="fas fa-plus-circle"></i>
        </button>
          </div>
          <div
        class="x-select-amount js-quick-amount -v2"
        data-target-input="#withdraw_amount"
          >
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(300)"
        >
          <span class="-no">300</span>
        </button>
        </div>
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(500)"
        >
          <span class="-no">500</span>
        </button>
        </div>
		<div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(800)"
        >
          <span class="-no">800</span>
        </button>
        </div>
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(1000)"
        >
          <span class="-no">1000</span>
        </button>
        </div>
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(2000)"
        >
          <span class="-no">2000</span>
        </button>
        </div>
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(5000)"
        >
          <span class="-no">5000</span>
        </button>
        </div>
          </div>
          </div>
        </div>
		</div>
	</div>
	<div>
                  <p class="glow" style="font-size:14px;">
                    {{ $t('deposit_instruction') }}
                  </p>
                  </div>
</div>
<div class="-bottom ">
	<!-- Hidden old buttons for new deposit system -->
	<div class="my-3 -spacer" v-if="false">
		<button
		type="button"
		class="btn -submit btn-primary text-center m-auto js-user-confirm-deposit"
		data-dismiss="modal"
		aria-label="Close"
		>
		{{ $t('close_window') }}
		</button>
  	</div>
	<div class="my-3 -spacer" v-if="false">
		<button
		type="button"
		class="btn -submit btn-primary text-center m-auto js-user-confirm-deposit"
		@click="genQrCodeCorePay()"
		>
		{{ $t('confirm_deposit') }}
		</button>
	</div>
</div>
    </div>
  </div>
</div>
      </div>
    </div>
  </div>
</div>
      	</div>
<!--Anoucement-->
<div id="open-modal" class="modal-window">
  <div class="announcement-modal">
    <a href="#" id="an-close" title="Close" style="display:none" class="modal-close">Close</a>
    <h1 class="announcement-modal-title">{{announcement_user.title}}</h1>
    <div class="announcement-modal-scroll">
      <div class="announcement-modal-detail" v-html="nl2br(announcement_user.detail)"></div>
      <div class="announcement-modal-date">{{showDateTime(announcement_user.createdate)}}</div>
    </div>
    <div class="announcement-modal-actions">
      <button class="announcement-modal-button" @click="closeAnnouncement(1)">{{ $t('acknowledged') }}</button>
      <button class="announcement-modal-button" @click="closeAnnouncement(2)">{{ $t('skip_for_now') }}</button>
    </div>
  </div>
</div>
<!-- Promotion -->
		  <div data-loading-container=".modal-body" data-container=".promotion-detail-modal-27" data-ajax-modal-always-reload="true" tabindex="-1" class="modal x-modal -promotion-detail-modal promotion-detail-modal-27 show" aria-modal="true" :style="`display: ${(promotion && promotion.name)?`block`:'none'}; padding-right: 8px;`"><div class="modal-dialog -modal-size  " role="document" style="padding-top: 152.8px;">
    <div class="modal-content -modal-content" :style="{ 'background-image': `url(${require('../assets/images/Shiba-BG.jpg')})`}">
                    <button type="button" class="close f-1 " data-dismiss="modal" aria-label="Close" @click="closePromotion()" style="color: white;">
                <i class="fas fa-times"></i>
            </button>
                                <div class="modal-body -modal-body" style="top: 0px;">
                            
        <div class="container">
            <div class="row">
                <div class="col-12 mt-4">
                    <div class="x-page-title-component ">
    <div class="-inner-wrapper">
        <h1 class="-title">{{ $t('menu_promotion') }}</h1>
            </div>
</div>
                </div>
            </div>
        </div>

        <div class="d-flex flex-column">
                            <div class="-real-content">
                    
    <div class="x-card card -card-promotion-detail ">
                                            
            <div class="card-body">
                <div class="-img-container">
                    <img :src="promotion.image" :alt="promotion.name" class="-img-promotion img-fluid">
                </div>


                <div class="x-promotion-content"><h2>{{promotion.name}}</h2>

<p><br>
<div v-html="nl2br(promotion.detail)" style="font-size:15px;font-family: 'Kanit', sans-serif;">
</div>
<br>
<!-- <a href="/term-and-condition">{{ $t('promotion_terms') }}</a> -->
</p></div>
            </div>

                            <div class="card-footer">
                    <!-- <button class="btn -btn -get-promotion-btn js-promotion-apply " data-toggle="modal" data-target="#depositModal" data-promotion-target="promotion-detail-modal-27" data-type="deposit" data-dismiss="modal" data-url="/promotion/27/apply">
                        <span>{{ $t('get_promotion') }}</span>
                    </button> -->
                </div>
                        </div>
                </div>
            
                                                        
                                    <div class="mx-3 mb-3">
                        <div class="x-admin-contact -no-fixed">
                            <span class="x-text-with-link-component" style="font-size:15px;font-family: 'Kanit', sans-serif;">
     <label class="-text-message ">{{ $t('header.contact_support') }}&nbsp;</label>&nbsp;
     <a :href="adminContactLineLink" class="-link-message " target="_blank" rel="noopener">
        <u>{{ $t('header.contact_customer_service') }}</u>
    </a>
</span>
                        </div>
                    </div>
                                    </div>
            </div>
    </div>
</div></div>
<a class="btn" href="#open-modal" id="a-modal" style="display: none;">👋 Basic CSS-Only Modal</a>
	</header>
</template>
<script>
import queryString from 'querystring'
import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/firestore'
import 'firebase/storage'
import router from './../router'
import moment from 'moment'
import settingsMixin from '@/mixins/settingsMixin'
import paybridgeDepositMixin from '@/mixins/paybridgeDepositMixin'
import PayBridgeDepositPanel from '@/components/paybridge/PayBridgeDepositPanel.vue'
import dypayDepositMixin from '@/mixins/dypayDepositMixin'
import paykumoDepositMixin from '@/mixins/paykumoDepositMixin'
import s3payDepositMixin from '@/mixins/s3payDepositMixin'
import copayDepositMixin from '@/mixins/copayDepositMixin'
import kisspayDepositMixin from '@/mixins/kisspayDepositMixin'
import UnifiedDepositPaymentPanel from '@/components/payment/UnifiedDepositPaymentPanel.vue'
import { assertLegacyDepositReceiverBank, isLegacyDepositReceiverBank, isPaymentProviderBank } from '@/utils/depositReceiverGuard'
import {
	buildLockedDepositCandidates,
	clearDepositChannelLock,
	saveDepositChannelLock
} from '@/utils/depositChannelSelection'
import { ensureLatestBuild } from '@/utils/buildVersionGuard'
import { getPendingWithdrawalStatus, getWithdrawConditionOnce } from '@/utils/withdrawConditionCache'
import { getBankPublicOptionsOnce } from '@/utils/bankPublicOptions'
import {
  isPaymentBankBlocked,
  normalizePaymentBankCode as normalizeConfiguredPaymentBankCode,
  paymentBlockedBanksFromRecord
} from '@/utils/paymentBankAvailability'
const audio = new Audio(require('../assets/money.mp3'))
const audio2 = new Audio(require('../assets/moneyout.mp3'))
const audio3 = new Audio(require('../assets/coin.mp3'))
const axios = require('axios').default
const qs = require('qs')
const FINAL_SLIP_STATUSES = ['ดำเนินการแล้ว', 'ยกเลิก']
const ACTIVE_SLIP_ERROR = 'ACTIVE_SLIP_EXISTS'
const SLIP_UPLOAD_ACTIVE_WINDOW_MINUTES = 30
const CLOUD_FUNCTIONS_API_KEY = 'LosnQ8W6uWoVs8N-ik_'
const RETIRED_PAYMENT_PROVIDER_KEYS = new Set(['badoo', 'badoopay'])

function isFinalSlipStatus(status) {
  return FINAL_SLIP_STATUSES.includes(String(status || ''))
}

function getSlipCreatedAt(data) {
  if(data && data.created_at && typeof data.created_at.toDate === 'function'){
    return moment(data.created_at.toDate()).tz('Asia/Bangkok')
  }

  const createdate = data && (data.createdate || data.createdate_client || data.updatetime)
  const parsed = createdate ? moment.tz(createdate, 'YYYY-MM-DD HH:mm:ss', 'Asia/Bangkok') : null
  return parsed && parsed.isValid() ? parsed : null
}

function isActiveSlipInUploadWindow(data) {
  if(isFinalSlipStatus(data && data.status)) return false

  const createdAt = getSlipCreatedAt(data)
  if(!createdAt) return true

  return moment().tz('Asia/Bangkok').diff(createdAt, 'minutes') <= SLIP_UPLOAD_ACTIVE_WINDOW_MINUTES
}

export default {
  name: "Header",
  mixins: [settingsMixin, paybridgeDepositMixin, dypayDepositMixin, paykumoDepositMixin, s3payDepositMixin, copayDepositMixin, kisspayDepositMixin],
  components: { PayBridgeDepositPanel, UnifiedDepositPaymentPanel },
	  mounted () {
	this.$root.$on('request-deposit', this.handleDepositClick)
	if (typeof window !== 'undefined') {
		this.handleViewportChange()
		window.addEventListener('resize', this.handleViewportChange)
	}
   	const user = localStorage.getItem('userData');
	if(user){
		  const _user = JSON.parse(user);
		  if(!_user.lastlogin || _user.lastlogin !== moment().tz('Asia/Bangkok').format('YYYY-MM-DD')){
			  _user.lastlogin = moment().tz('Asia/Bangkok').format('YYYY-MM-DD')
			  localStorage.setItem('userData', JSON.stringify(_user))
			  this.addLogin(_user)
		  }
		  			$('#depositModal').on('hidden.bs.modal',  (e)=> {
			if (this.hasActiveDepositInProgress()) {
				this.corepaypage = false;
				this.corepayimage = '';
				return;
			}
			this.corepaypage = false;
			this.corepayimage = '';
			// Reset all deposit states
			this.showBankSelectionForDeposit = false;
			this.selectedDepositAccount = null;
			this.inputDepositAmount = null;
			this.depositAmount = null;
			this.depositAmountWithDecimal = null;
			this.assignedBank = null;
			this.depositDecimal = null;
			this.depositTransactionId = null;
			this.securePayOnlyDeposit = false;
			// Clear timer if exists
			if (this.depositTimerInterval) {
				clearInterval(this.depositTimerInterval);
				this.depositTimerInterval = null;
			}
			this.depositTimer = null;
			
			if(this.unsubscribe){
				this.unsubscribe()
			}
			});

			// Add event listener for when modal is shown to reset state properly on mobile
			$('#depositModal').on('show.bs.modal', async (e) => {
				this.restoreDepositCustomerAccount();
				if (this.hasActiveDepositInProgress()) {
					this.corepaypage = false;
					this.corepayimage = '';
					return;
				}
				// Reset all deposit states when modal is shown
				this.showBankSelectionForDeposit = false;
				this.selectedDepositAccount = null;
				this.corepaypage = false;
				this.corepayimage = '';
				this.inputDepositAmount = null;
				this.depositAmount = null;
				this.depositAmountWithDecimal = null;
				this.assignedBank = null;
				this.depositDecimal = null;
				this.depositTransactionId = null;
				const restoredCopay = await this.restoreCopayDeposit();
				if (restoredCopay) return;

				const restoredDyPay = await this.restoreDyPayDeposit();
				if (restoredDyPay) return;

				// Clear timer if exists
				if (this.depositTimerInterval) {
					clearInterval(this.depositTimerInterval);
					this.depositTimerInterval = null;
				}
				this.depositTimer = null;
				
				const restoredPaykumo = await this.restorePaykumoDeposit();
				if (restoredPaykumo) return;

				const restoredS3Pay = await this.restoreS3PayDeposit();
				if (restoredS3Pay) return;

				const restoredKissPay = await this.restoreKissPayDeposit();
				if (restoredKissPay) return;

				const restoredSecurePay = await this.restoreSecurePayDepositFromCache();
				if (restoredSecurePay) return;

				// Check if user has multiple approved accounts
				const approvedAccounts = this.getApprovedAccounts();
				if (approvedAccounts.length > 1) {
					this.showBankSelectionForDeposit = true;
				}
			});
			
			// Reset mobile tabs when modal is closed
			$('#accountModalMobile').on('hidden.bs.modal', (e) => {
				this.resetMobileTabs();
			});
			
			  this.getAnnouncementUser(_user.key);
	  } else {
		firebase.auth().signOut()
		localStorage.removeItem('userData')
		router.replace('/login')
	  }
	  },
	  beforeDestroy () {
	this.$root.$off('request-deposit', this.handleDepositClick)
	if (typeof window !== 'undefined') {
		window.removeEventListener('resize', this.handleViewportChange)
	}
	this.cleanupSecurePayDepositListener()
  },
  async created(){
	  //$("#depositChoosePromotionModal").modal('show')
	const user = localStorage.getItem('userData');
	if(user){
		const _user = JSON.parse(user);
		this.$store.dispatch('user/setUser',_user).catch(err => { console.error(err) });
	}else{
		firebase.auth().signOut()
		localStorage.removeItem('userData')
		router.replace('/login')
	}
	const { code } = queryString.parse(window.location.search.replace('?', ''))
	if (!code) return
	const result = await this.getToken(code)
	if (result && result.access_token) {
		const { data } = await this.getProfile(result.access_token)
		this.checkLineLogin(data)
	}
	
	
  },
  data() {
    return {
			condition:{
			detail:'',
			maximum:0,
			minimum:0,
			maximumperday:0,
			disableDeposit: false,
				disableWithdraw: false,
			},
			conditionLoaded: false,
		isDropdownOpen: false,
		languages: [
			{ code: 'th', name: 'ไทย' },
			{ code: 'en', name: 'English' },
			{ code: 'my', name: 'မြန်မာ' },
		],
		viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
		viewportHeight: typeof window !== 'undefined' ? window.innerHeight : 0,
      disabled: false,
      deposit_value:'',
      corepaymessage:'',
      corepayimage:'',
      corepaypage:false,
      papaya: false,
      config_kbank:false,
      config:{
        scb:false,
        scb2:false,
        scb3:false,
        kbank:false,
        truewallet:false,
        withdraw:false,
      },
      announcement_user:{
        close:false,
        createdate:'',
        detail:'',
        title:'',
      },
      password:'',
      password1:'',
      password2:'',
      fa_spin:false,
      accountOpen:false,
      withdraw: '',
      error: '',
      copyfield:'',
      canwithdraw: 'ยืนยัน',
      clientId: '1656935750',
      callbackUri: 'https://vr1game-v2.club',
      clientSecret: '4b4c6d35256b0034244f1a0056ddb640',
      bank:{
        scb:{
          firstname:'',
          lastname:'',
          accountno:'',
        },
        kbank:{
          firstname:'',
          lastname:'',
          accountno:'',
        },
        truewallet:{
          firstname:'',
          lastname:'',
          mobile:'',
        }
      },
      // New properties for multiple accounts management
      accountActiveTab: 'profile',
      mobileActiveTab: 'profile',
      showAddAccountForm: false,
      showAddAccountFormMobile: false,
      showChangePasswordForm: false,
      showChangePasswordFormMobile: false,
      newAccount: {
        bank: '',
        account_no: '',
        firstname: '',
        lastname: '',
      },
      newAccountMobile: {
        bank: '',
        account_no: '',
        firstname: '',
        lastname: '',
      },
      // Add selected withdraw account for withdrawal modal
      selectedWithdrawAccount: null,
      // Add selected deposit account for deposit modal
      selectedDepositAccount: null,
      showBankSelectionForDeposit: false,
      // Current deposit account for transaction storage
      currentDepositAccount: null,
      // Add loading state (removed cache for real-time data)
      isBankLoading: false,
      isCancellingBankDeposit: false,
      // New deposit system properties
      inputDepositAmount: null,
      depositAmount: null,
      depositAmountWithDecimal: null,
      assignedBank: null,
      depositTimer: null,
      depositTimerInterval: null,
      depositDeadline: null,
      depositDecimal: null,
      depositTransactionId: null,
	      securePayTransaction: null,
	      securePayPageUrl: '',
	      securePayDepositUnsubscribe: null,
	      securePayOnlyDeposit: false,
      hideBankSection: false,
      isSlipUploading: false,
      bankNames: {
        'truewallet': 'Truewallet',
        'bankokbank': 'BBL - ธนาคารกรุงเทพ',
        'kbank': 'KBANK - ธนาคารกสิกรไทย',
        'scb': 'SCB - ธนาคารไทยพาณิชย์',
        'tisco': 'TISCO - ธนาคารทิสโก้',
        'ttb': 'TTB - ทหารไทยธนชาต',
        'ktb': 'KTB - ธนาคารกรุงไทย',
        'krungsri': 'BAY - ธนาคารกรุงศรีอยุธยา',
        'kiatnakin': 'KKP - ธนาคารเกียรตินาคิน',
        'gsb': 'GSB - ธนาคารออมสิน',
        'lh': 'LHBANK - ธนาคารแลนด์ แอนด์ เฮ้าส์',
        'uob': 'UOB - ธนาคารยูโอบี',
        'ธนาคารอิสลาม': 'IBANK - ธนาคารอิสลามแห่งประเทศไทย',
        'ghbank': 'GHB - ธนาคารอาคารสงเคราะห์',
        'cimb': 'CIMB - ธนาคารซีไอเอ็มบีไทย',
        'baac': 'BAAC - ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร (ธกส)',
        'icbc': 'ICBC - ธนาคารไอซีบีซี (ไทย)',
        'standard': 'STANDARD - ธนาคารสแตนดาร์ดชาร์เตอร์ดไทย',
        'securepay': 'SecurePay'
      }
    }
  },
  watch: {
	'user.language': {
		immediate: true,
		handler(newLang) {
		if (newLang) {
			this.$i18n.locale = newLang;
		} else {
			this.$i18n.locale = 'th'; // default to Thai
		}
		}
	},
	coin_voice(newVoice,oldVoice) {
		if(newVoice){
			audio3.volume = 0.5;
			audio3.play();
			this.$store.commit("user/SET_COIN_VOICE", false) 
		}
	},
    // whenever question changes, this function will run
    creditincrese(newQuestion, oldQuestion) {
		if(newQuestion){
			audio.volume = 0.5;
			audio.play();
			this.$store.commit("user/SET_CREDIT_INCREASE", false) 
		}
    },
	creditdecrese(newQuestion, oldQuestion) {
		if(newQuestion){
			audio2.volume = 0.5;
			audio2.play();
			this.$store.commit("user/SET_CREDIT_DECREASE", false) 
		}
    },
	
	alertwithdraw(newalert, oldwithdraw) {
		if(newalert){
			if(!this.lastbonus.withdrawBlocked){
				// ตรวจสอบจำนวนบัญชีที่อนุมัติแล้ว
				const approvedAccounts = this.getApprovedAccounts();
				const promoSummary = this.getPromoWithdrawSummary();
				
				// ปิด withdraw modal ก่อน
				$("#withdrawModal").modal('hide')
				
				if(approvedAccounts.length > 1) {
					// มีหลายบัญชี - แสดง dropdown เลือกบัญชี
					this.showWithdrawConfirmWithAccountSelection();
				} else if(approvedAccounts.length === 1) {
					this.$swal({
						icon: 'question',
						title: this.$t('withdraw'),
						html: this.buildPromoWithdrawSummaryHTML(),
						showCancelButton: true,
						confirmButtonText: this.$t('confirm')
					}).then((result) => {
						if(result.isConfirmed){
							// ตั้งค่าบัญชีที่จะใช้ (บัญชีเดียว)
							this.selectedWithdrawAccount = approvedAccounts[0];
							this.withdraw = promoSummary.withdrawAmount;
							this.withdrawConfirm();
						}
					});
				} else {
					// ไม่มีบัญชีที่อนุมัติ
					this.$swal({ 
						icon: 'error', 
						title: this.$t('withdraw'), 
						text: 'กรุณาเพิ่มบัญชีธนาคารและรอการอนุมัติก่อนทำการถอนเงิน' 
					});
				}
			}else if(Number(this.user.credit)>5){
				$("#withdrawModal").modal('hide')
				this.$swal({ icon: 'error', title: this.$t('withdraw'), text: `คุณต้องทำยอด ${this.lastbonus.turncredit} ค่ะ`}).then((result) => {
				});
			}
			this.$store.commit("user/SET_ALERT_WITHDRAWALL", false) 
		}
	},
	// Watch for user data changes
	'user.key': {
		immediate: true,
		handler(newKey) {
			if (newKey && !this.condition.maximum) {
				// Only call if condition data hasn't been loaded yet
				this.callGetWithdrawCondition();
			}
		}
	}
  },
  computed: {
	user(){
		return this.$store.state.user.user;
    },
	creditincrese(){
		return this.$store.state.user.creditincrese;
	},
	creditdecrese(){
		return this.$store.state.user.creditdecrese;
	},
	lastbonus () {
      return this.$store.state.user.lastbonus;
    },
	alertwithdraw (){
		return this.$store.state.user.alertwithdraw;
	},
	promotions (){
		return this.$store.state.user.promotions;
	},
	isSecurePayDepositActive() {
		return this.isSecurePayBank(this.assignedBank) && !!this.securePayTransaction;
	},
	gotpro: {
		get() {
			return this.$store.state.user.gotpro;
		},
		set(value) {
			if(this.user && this.user.key){
				this.$store.commit("user/SET_GOT_PRO", value);
				firebase.database().ref(`users/${this.user.key}`).update({bonus: value ? 'Y' : 'N'});
			}
		}
	},
	promotion(){
		return this.$store.state.user.promotion;
	},
	coin_voice(){
		return this.$store.state.user.coin_voice;
	},
	loading () {
      return this.$store.state.user.loading
    },
	paymentOnlyDepositRangeText() {
		if (!this.condition || !this.condition.disableDeposit) return '';
		return this.formatConfiguredPaymentDepositRange(
			this.getAvailableConfiguredPaymentChannels()
		);
	},
	unifiedDepositCustomerAccount() {
		const transactionAccount =
			(this.securePayTransaction && this.securePayTransaction.account) ||
			(this.copayTransaction && this.copayTransaction.account) ||
			(this.paykumoTransaction && this.paykumoTransaction.account) ||
			(this.s3PayTransaction && this.s3PayTransaction.account) ||
			(this.kisspayTransaction && this.kisspayTransaction.account) ||
			(this.dypayTransaction && this.dypayTransaction.account) ||
			null;
		const account = this.currentDepositAccount || transactionAccount || this.selectedDepositAccount || this.getApprovedAccounts()[0] || {};
		const bank = account.bank || account.bank_name || '';
		const bankName = bank ? this.getBankName(bank) : '';
		const rawBankCode = String(bank || '').trim();
		const bankNamePrefix = String(bankName || '').split(/\s*[-–]\s*/)[0].trim();
		const bankCode = /^[A-Za-z0-9]+$/.test(rawBankCode)
			? rawBankCode.toUpperCase()
			: (/^[A-Za-z0-9]+$/.test(bankNamePrefix) ? bankNamePrefix.toUpperCase() : '');
		const accountName = String(account.account_name || account.accountName || '').trim();
		const accountOwnerName = [account.firstname, account.lastname].filter(Boolean).join(' ').trim();
		const customerName = [this.user && this.user.firstname, this.user && this.user.lastname].filter(Boolean).join(' ').trim();
		return {
			bankName,
			bankCode,
			bankImage: bank ? this.getBankImage(bank) : '',
			accountName: accountName && accountName !== '-' ? accountName : (accountOwnerName || customerName),
			accountNo: account.account_no || account.accountNo || account.account || ''
		};
	},
	activeUnifiedDepositView() {
		const base = {
			kind: '', receiverAccount: {}, qrImage: '', qrPayload: '', paymentUrl: '',
			amount: this.depositAmountWithDecimal || this.depositAmount || '', remainingText: '',
			expiresAt: null, fallbackCountdownSeconds: 0, checking: false,
			cancelling: false, uploading: false, showCancel: true, showUpload: false
		};

		if (this.hasActiveCopayDeposit) {
			const paymentInfo = (this.copayTransaction && this.copayTransaction.payment_info) || {};
			return {
				...base, kind: 'copay', qrImage: paymentInfo.promptpay_qr || '',
				receiverAccount: paymentInfo.account_no ? this.normalizeUnifiedReceiverAccount({
					bank: paymentInfo.bank_code || paymentInfo.bank_name,
					accountNo: paymentInfo.account_no,
					accountName: paymentInfo.account_name
				}) : {},
				amount: paymentInfo.amount || base.amount,
				expiresAt: this.resolveCopayPaymentExpiresAt(paymentInfo),
				fallbackCountdownSeconds: 10 * 60,
				checking: this.copayStatusChecking,
				cancelling: this.copayCancelling
			};
		}

		if (this.hasActiveKissPayDeposit) {
			const transaction = this.kisspayTransaction || {};
			return {
				...base, kind: 'kisspay',
				qrImage: transaction.qr_code_url || transaction.qrCodeUrl || '',
				paymentUrl: transaction.redirect_url || transaction.showurl || this.kisspayRedirectUrl || '',
				amount: this.kisspayPayableAmount || '',
				amountPending: this.kisspayPayableAmount === null,
				expiresAt: this.resolveTimestampWithDuration(transaction.provider_created_at, 5 * 60),
				fallbackCountdownSeconds: 5 * 60,
				checking: this.kisspayStatusChecking
			};
		}

		if (this.hasActivePaykumoDeposit) {
			const transaction = this.paykumoTransaction || {};
			return {
				...base, kind: 'paykumo',
				receiverAccount: this.normalizeUnifiedReceiverAccount({
					bank: transaction.receiver_bank,
					accountNo: transaction.receiver_account,
					accountName: transaction.receiver_name
				}),
				paymentUrl: this.paykumoRedirectUrl || transaction.redirect_url || transaction.address || '',
				qrImage: transaction.qr_image || '',
				expiresAt: transaction.expires_at || null,
				amount: transaction.actual_amount || transaction.amount || base.amount,
				checking: this.paykumoStatusChecking
			};
		}

		if (this.hasActiveS3PayDeposit) {
			const transaction = this.s3PayTransaction || {};
			return {
				...base, kind: 's3pay',
				qrPayload: transaction.qr_data || (transaction.qr && transaction.qr.qr_data) || '',
				paymentUrl: this.s3PayShowUrl || '',
				amount: transaction.amount || transaction.amount_requested || base.amount,
				expiresAt: transaction.expires_at || null,
				fallbackCountdownSeconds: 15 * 60,
				checking: this.s3PayStatusChecking
			};
		}

		if (this.hasActiveDyPayDeposit) {
			const transaction = this.dypayTransaction || {};
			return {
				...base, kind: 'dypay',
				qrPayload: transaction.payment_value || transaction.paymentValue || '',
				paymentUrl: transaction.payment_url || '',
				amount: transaction.recommended_amount || transaction.request_amount || base.amount,
				expiresAt: transaction.expires_at || null,
				checking: this.dypayStatusChecking
			};
		}

		if (this.isSecurePayDepositActive) {
			const transaction = this.securePayTransaction || {};
			const qrPayload = transaction.qr_code_text || transaction.qrCodeText || '';
			const destinationAccount = transaction.destination_account_number ? this.normalizeUnifiedReceiverAccount({
				bank: transaction.destination_bank_code || transaction.destination_bank_name,
				bankName: transaction.destination_bank_name,
				accountNo: transaction.destination_account_number,
				accountName: transaction.destination_account_name
			}) : {};
			return {
				...base, kind: 'securepay', receiverAccount: destinationAccount, qrPayload,
				paymentUrl: this.securePayPageUrl || '',
				amount: transaction.amount_generated || transaction.amount || base.amount,
				remainingText: this.depositTimer ? this.formatTime(this.depositTimer) : '',
				expiresAt: transaction.expired_at || this.depositDeadline || null,
				cancelling: this.isCancellingBankDeposit,
				uploading: this.isSlipUploading,
				showUpload: Boolean(destinationAccount.accountNo && !qrPayload)
			};
		}

		if (this.depositAmount && this.assignedBank && !this.paybridgeMatch) {
			return {
				...base, kind: 'bank',
				receiverAccount: this.normalizeUnifiedReceiverAccount({
					bank: this.assignedBank.bank_name,
					accountNo: this.assignedBank.account_no || this.assignedBank.mobile,
					accountName: [this.assignedBank.firstname, this.assignedBank.lastname].filter(Boolean).join(' ').trim()
				}),
				remainingText: this.depositTimer ? this.formatTime(this.depositTimer) : '',
				cancelling: this.isCancellingBankDeposit,
				uploading: this.isSlipUploading,
				showUpload: true
			};
		}

		return null;
	},
	deadlineTime() {
		if (!this.depositDeadline) return '';
		const deadline = new Date(this.depositDeadline);
		if (Number.isNaN(deadline.getTime())) return '';
		return deadline.toLocaleTimeString('th-TH', { 
			hour: '2-digit', 
			minute: '2-digit',
			hour12: false 
		});
	},
	withdrawModalBodyStyle () {
		const style = {
			top: '0px',
			overflowY: 'auto'
		}
		const defaultHeight = '470px'
		const viewportWidth = this.viewportWidth || 0
		const viewportHeight = this.viewportHeight || 0

		if (viewportWidth <= 575) {
			const verticalMargin = 120
			const availableHeight = Math.max(viewportHeight - verticalMargin, 320)
			const heightValue = `${availableHeight}px`
			style.height = heightValue
			style.maxHeight = heightValue
			style.paddingBottom = '16px'
		} else {
			style.height = defaultHeight
			style.maxHeight = defaultHeight
		}

		return style
	}
  },
  methods: {
	normalizeUnifiedReceiverAccount({ bank = '', bankName = '', accountNo = '', accountName = '' } = {}) {
		const rawBank = String(bank || bankName || '').trim();
		const bankAliases = {
			'002': 'bankokbank', BBL: 'bankokbank', BKKB: 'bankokbank',
			BANGKOKBANK: 'bankokbank',
			'004': 'kbank', KBNK: 'kbank', KBANK: 'kbank', KASI: 'kbank', KASIKORN: 'kbank',
			KASIKORNBANK: 'kbank', KARIKORN: 'kbank', KARIKORNBANK: 'kbank',
			'006': 'ktb', KTB: 'ktb', KRUNGTHAI: 'ktb', KRUNGTHAIBANK: 'ktb',
			'014': 'scb', SCB: 'scb', SICO: 'scb', SIAMCOMMERCIALBANK: 'scb',
			'025': 'krungsri', BAY: 'krungsri', KRUNGSRI: 'krungsri', BANKOFAYUDHYA: 'krungsri',
			KKP: 'kiatnakin', KIATNAKINPHATRA: 'kiatnakin', KIATNAKINPHATRABANK: 'kiatnakin',
			GSB: 'gsb', GOVERNMENTSAVINGSBANK: 'gsb',
			TTB: 'ttb', TMB: 'ttb', TMBTHANACHART: 'ttb', TMBTHANACHARTBANK: 'ttb',
			TISCO: 'tisco', TISCOBANK: 'tisco',
			LHBANK: 'lh', LANDANDHOUSES: 'lh', LANDANDHOUSESBANK: 'lh',
			UOB: 'uob', UNITEDOVERSEASBANK: 'uob',
			BAAC: 'baac', BANKFORAGRICULTUREANDAGRICULTURALCOOPERATIVES: 'baac',
			GHB: 'ghbank', GHBANK: 'ghbank', GOVERNMENTHOUSINGBANK: 'ghbank',
			CIMB: 'cimb', CIMBTHAI: 'cimb', CIMBTHAIBANK: 'cimb',
			ICBC: 'icbc', ICBCTHAI: 'icbc',
			STANDARDCHARTERED: 'standard', STANDARDCHARTEREDBANK: 'standard',
			STANDARDCHARTEREDTHAI: 'standard'
		};
		const canonicalBankKeys = new Set([
			'bankokbank', 'kbank', 'ktb', 'scb', 'krungsri', 'kiatnakin', 'gsb',
			'ttb', 'tisco', 'lh', 'uob', 'baac', 'ghbank', 'cimb', 'icbc', 'standard'
		]);
		const resolveBankKey = (value) => {
			const normalizedValue = String(value || '').trim();
			if (!normalizedValue) return '';
			const canonicalKey = normalizedValue.toLowerCase();
			if (canonicalBankKeys.has(canonicalKey)) return canonicalKey;
			const compactKey = normalizedValue.toUpperCase().replace(/[^A-Z0-9ก-๙]/g, '');
			return bankAliases[compactKey] || bankAliases[compactKey.replace(/^THA/, '')] || '';
		};
		const bankKey = resolveBankKey(bank) || resolveBankKey(bankName) || rawBank.toLowerCase();
		const normalizedBankName = this.getBankName(bankKey);
		return {
			bankName: normalizedBankName !== bankKey ? normalizedBankName : (bankName || rawBank),
			bankImage: bankKey ? this.getBankImage(bankKey) : '',
			accountNo: String(accountNo || '').trim(),
			accountName: String(accountName || '').trim()
		};
	},
	resolveTimestampWithDuration(value, durationSeconds) {
		if (!value) return null;
		const timestamp = Date.parse(String(value));
		return Number.isFinite(timestamp) ? timestamp + Number(durationSeconds || 0) * 1000 : null;
	},
	resolveCopayPaymentExpiresAt(paymentInfo = {}) {
		const timeout = paymentInfo.timeout || {};
		const value = timeout.days && timeout.time ? `${timeout.days} ${timeout.time}` : timeout.date;
		if (!value) return null;
		const text = String(value).trim();
		const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(text);
		const parsed = hasTimezone ? moment.parseZone(text) : moment.utc(text);
		return parsed.isValid() ? parsed.valueOf() : null;
	},
	getDepositCustomerAccountStorageKey() {
		return `vr1game_deposit_customer_account_${(this.user && this.user.key) || 'guest'}`;
	},
	persistDepositCustomerAccount(account) {
		if (typeof window === 'undefined' || !window.localStorage || !account) return;
		localStorage.setItem(this.getDepositCustomerAccountStorageKey(), JSON.stringify({
			bank: account.bank || account.bank_name || '',
			account_no: account.account_no || account.accountNo || account.account || '',
			firstname: account.firstname || '',
			lastname: account.lastname || '',
			account_name: account.account_name || '',
			stored_at: Date.now()
		}));
	},
	restoreDepositCustomerAccount() {
		if (typeof window === 'undefined' || !window.localStorage) return null;
		try {
			const cached = JSON.parse(localStorage.getItem(this.getDepositCustomerAccountStorageKey()) || 'null');
			if (!cached || !cached.account_no) return null;
			const approved = this.getApprovedAccounts();
			const match = approved.find(account =>
				String(account.account_no || '').replace(/\D/g, '') === String(cached.account_no || '').replace(/\D/g, '') &&
				String(account.bank || '').toLowerCase() === String(cached.bank || '').toLowerCase()
			);
			this.currentDepositAccount = match || cached;
			return this.currentDepositAccount;
		} catch (error) {
			return null;
		}
	},
	async cancelUnifiedDepositView() {
		const view = this.activeUnifiedDepositView;
		if (!view) return;
		if (view.kind === 'copay') return this.cancelCopayDeposit();
		if (view.kind === 'kisspay') return this.cancelKissPayDeposit();
		if (view.kind === 'paykumo') return this.cancelPaykumoDeposit();
		if (view.kind === 's3pay') return this.cancelS3PayDeposit();
		if (view.kind === 'dypay') return this.cancelDyPayDeposit();
		if (view.kind === 'securepay') return this.confirmCancelSecurePayDeposit();
		if (view.kind === 'bank') return this.confirmCancelBankDeposit();
	},
	uploadUnifiedDepositSlip(event) {
		const view = this.activeUnifiedDepositView;
		if (!view) return;
		if (view.kind === 'securepay') return this.uploadSecurePaySlip(event);
		if (view.kind === 'bank') return this.uploadSlip(event);
	},
	handleViewportChange () {
		if (typeof window === 'undefined') {
			return
		}
		this.viewportWidth = window.innerWidth
		this.viewportHeight = window.innerHeight
	},
	showPromotionTerms() {
		// ใช้ข้อความจาก promotions.detail หากมี ถ้าไม่มีใช้ fallback text
		const termsMessage = this.promotions && this.promotions.detail 
			? this.promotions.detail 
			: this.$t('promotion_terms_message');

		this.$swal({
			icon: 'info',
			title: this.$t('promotion_terms_title'),
			html: termsMessage.replace(/\n/g, '<br>').replace(/\\n/g, '<br>'),
			confirmButtonText: this.$t('acknowledge'),
			customClass: {
				popup: 'swal-wide',
				content: 'text-left'
			}
		});
	},
	getLocalizedImage(item) {
      if (!item) return '';
      
      const currentLang = this.$i18n.locale;
      const imageField = `image_${currentLang}`;
      
      // ใช้รูปตามภาษา ถ้าไม่มีใช้รูปภาษาไทย ถ้าไม่มีอีกใช้รูปปกติ
      return item[imageField] || item.image_th || item.image;
    },
	toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    selectLanguage(langCode) {
      // Update user language in database
      if(this.user && this.user.key) {
        firebase.database().ref(`users/${this.user.key}`).update({
          language: langCode
        });
        
        // Update local user data
        const userData = JSON.parse(localStorage.getItem('userData'));
        userData.language = langCode;
        localStorage.setItem('userData', JSON.stringify(userData));
        
        // Update Vuex store
        this.$store.dispatch('user/setUser', userData);
		this.$i18n.locale = langCode;
      }
      
      this.isDropdownOpen = false;
    },
	getLanguageName () {
		const language = this.user.language;
		const validLanguages = ['my', 'en', 'lo', 'th'];
		if (validLanguages.includes(language)) {
			const lang = this.languages.find(lang => lang.code === language);
			return lang ? lang.name : this.$t('thai_lang');
		}
		return this.$t('thai_lang');
	},
	getFlagImage() {
		const language = this.user.language;
		const validLanguages = ['my', 'en', 'lo', 'th'];
		
		if (validLanguages.includes(language)) {
		return require(`../assets/images/flags/${language}.png`);
		}
		
		return require('../assets/images/flags/th.png');
	},
	setWithdraw2 (value) {
		  if (value === 'plus') {
			  this.deposit_value = (this.deposit_value) ? this.deposit_value + 10 : 10
		  } else if (value === 'minus') {
			  if (this.deposit_value) { this.deposit_value = (this.deposit_value) ? this.deposit_value - 10 : 0 }
		  } else if (value > 0) { this.deposit_value = value } else { this.deposit_value = 0 }
	},
	genQrCodeCorePay(){
		if(this.papaya){
			if(this.deposit_value < 300){
				this.$swal({ icon: 'error', title: this.$t('promptpay_deposit_title'), text: this.$t('amount_must_exceed_300')}).then((result) => {});
			}else{
				this.$store.commit('user/SET_LOADING', true)
				firebase.firestore().collection('papaya').add({
					userkey:this.user.key,
					code:this.user.code,
					createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
					status:false,
					amount:this.deposit_value,
				}).then(async (result)=>{
					this.unsubscribe = firebase.firestore().collection('papaya').doc(result.id).onSnapshot(async (doc) => {
					if(doc.data().papaya && doc.data().status){
						this.corepayimage = doc.data().papaya.payurl;
						this.unsubscribe()
					}else if(doc.data().papaya && !doc.data().status){
						this.$store.commit('user/SET_LOADING', false)
						if(doc.data().papaya)
						this.$swal({ icon: 'error', title: this.$t('promptpay_problem'), text: this.$tWithSettings('please_contact_admin')}).then((result) => {
						});
						this.unsubscribe()
					}else if(doc.data().papaya && doc.data().status){
						this.$store.commit('user/SET_LOADING', false)
						this.$swal({ icon: 'success', title: 'Success', text: this.$t('promptpay_success')})
						this.unsubscribe()
						$("#depositModal").modal('hide')
					}
					});
					axios.get(`https://api.vr1game-v2.online/sonic/${result.id}`).then((result)=>{
					this.$store.commit('user/SET_LOADING', false)
					})
				})
			}
		}
    },
	showCorepayPage(){
      if(this.corepaypage)
        this.corepaypage = false;
      else
        this.corepaypage = true;
    },
	showDateTime(date){
		return moment(date,'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY HH:mm');
	},
	async closeAnnouncement(type){
		if(type===1){
			firebase.database().ref(`/announcement_users/${this.user.key}`).update({
				status: this.$t('acknowledged_status'),
				updatetime:moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
				close:true
			});
		}
		document.getElementById("an-close").click();
	},
	async getAnnouncementUser(key){
		if(key){
			const announcement = (await firebase.database().ref(`/announcement_users/${key}`).once('value')).val();
			if(announcement && !announcement.close && announcement.title && (!announcement.status || announcement.status !== this.$t('acknowledged_status'))){
				this.announcement_user = announcement;
				document.getElementById("a-modal").click();
			}
		}
	},
	getSlipImageExtension(file) {
		const filename = String((file && file.name) || '');
		const extension = filename.includes('.') ? filename.split('.').pop().toLowerCase() : '';
		if (['jpg', 'jpeg', 'png', 'webp', 'gif', 'heic', 'heif'].includes(extension)) {
			return extension;
		}

		const contentType = String((file && file.type) || '').toLowerCase();
		if (contentType.includes('png')) return 'png';
		if (contentType.includes('webp')) return 'webp';
		if (contentType.includes('gif')) return 'gif';
		if (contentType.includes('heic')) return 'heic';
		if (contentType.includes('heif')) return 'heif';
		return 'jpg';
	},
	resizeImage(file, maxWidth = 800, maxHeight = 800) {
		return new Promise((resolve, reject) => {
		const reader = new FileReader();
		const outputType = /^image\/(jpeg|jpg|png|webp)$/i.test(file.type) ? file.type : 'image/jpeg';
		reader.onload = (event) => {
			const img = new Image();
			img.onload = () => {
			let width = img.width;
			let height = img.height;

			// คำนวณขนาดใหม่
			if (width > maxWidth || height > maxHeight) {
				if (width / height > maxWidth / maxHeight) {
				height = Math.round((height * maxWidth) / width);
				width = maxWidth;
				} else {
				width = Math.round((width * maxHeight) / height);
				height = maxHeight;
				}
			}

			const canvas = document.createElement('canvas');
			canvas.width = width;
			canvas.height = height;
			const ctx = canvas.getContext('2d');
			ctx.drawImage(img, 0, 0, width, height);

			canvas.toBlob((blob) => {
				if (blob) {
					resolve(blob);
					return;
				}
				reject(new Error('image_resize_failed'));
			}, outputType, 0.85); // 0.85 คือ quality (jpeg/png)
			};
			img.onerror = reject;
			img.src = event.target.result;
		};
		reader.onerror = reject;
		reader.readAsDataURL(file);
		});
	},
	async findActiveSlipUpload(){
		if(!this.user || !this.user.key) return null;
		const result = await firebase.firestore().collection('slip')
			.where('userkey','==',this.user.key)
			.get();

		const activeSlip = result.docs.find((doc) => {
			const data = doc.data() || {};
			return isActiveSlipInUploadWindow(data);
		});

		return activeSlip ? { id: activeSlip.id, ...activeSlip.data() } : null;
	},
	async createSlipUploadRecord(selectedAccount){
		const db = firebase.firestore();
		const now = moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss');
		const slipRef = db.collection('slip').doc();
		const slipData = {
			userkey:this.user.key,
			code:this.user.code,
			user:{
				code:this.user.code,
				firstname: selectedAccount.firstname || this.user.firstname,
				lastname: selectedAccount.lastname || this.user.lastname,
				bank: selectedAccount.bank,
				//tel:this.user.tel,
				account_no: selectedAccount.account_no,
				bonus:this.user.bonus,
			},
			slip_bank: selectedAccount.bank,
			selected_account: {
				bank: selectedAccount.bank,
				account_no: selectedAccount.account_no,
				firstname: selectedAccount.firstname || this.user.firstname,
				lastname: selectedAccount.lastname || this.user.lastname,
			},
			created_at: firebase.firestore.FieldValue.serverTimestamp(),
			createdate_client: now,
			createdate: now,
			status:'กำลังดำเนินการ',
			auto_read_status:'not_started',
		};

		await slipRef.set(slipData);

		return slipRef;
	},
	formatPromotionBalanceAmount(amount) {
		return Number(amount || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	},
	showPromotionBalanceBlockedAlert(result) {
		const rawLimit = Number(result && result.limit ? result.limit : 10);
		const limit = rawLimit % 1 === 0 ? rawLimit.toLocaleString('en-US') : this.formatPromotionBalanceAmount(rawLimit);
		const lineLink = this.adminContactLineLink || 'https://lin.ee/xalM4XE';
		return this.$swal({
			icon: 'warning',
			title: 'ขออภัยค่ะ',
			html: `เครดิตคงเหลือมากกว่า ${limit} บาท ไม่สามารถฝากแบบรับโปรโมชั่นได้ค่ะ<br><br>สอบถามข้อมูลเครดิตเพิ่มเติม กรุณาติดต่อแอดมิน`,
			showCancelButton: true,
			confirmButtonText: 'ตกลง',
			cancelButtonText: 'ติดต่อแอดมิน',
			reverseButtons: false
		}).then((swalResult) => {
			if (swalResult && swalResult.dismiss === 'cancel' && lineLink) {
				window.open(lineLink, '_blank');
			}
			return swalResult;
		});
	},
	showActivePromotionDepositBlockedAlert() {
		const lineLink = this.adminContactLineLink || 'https://lin.ee/xalM4XE';
		return this.$swal({
			icon: 'warning',
			title: 'ยังไม่สามารถฝากเงินเพิ่มได้',
			html: 'ขณะนี้มีโปรโมชั่นเดิมที่ยังไม่จบเงื่อนไข จึงยังไม่สามารถฝากเงินเพิ่มได้ค่ะ<br>ท่านยังสามารถเข้าเล่นในค่ายที่โปรโมชั่นกำหนดได้ตามปกติ<br><br>กรุณากดเมนู “ทางเข้าเล่น” เพื่อเล่นต่อ หรือยกเลิกโปรโมชั่นก่อนฝากครั้งใหม่',
			showCancelButton: true,
			confirmButtonText: 'ตกลง',
			cancelButtonText: 'ติดต่อแอดมิน',
			reverseButtons: false
		}).then((swalResult) => {
			if (swalResult && swalResult.dismiss === 'cancel' && lineLink) {
				window.open(lineLink, '_blank');
			}
			return swalResult;
		});
	},
	async ensureActivePromotionDepositAllowed() {
		try {
			const result = await this.$store.dispatch('user/checkActivePromotionDepositBlock');
			if(result && result.blocked){
				await this.showActivePromotionDepositBlockedAlert(result);
				return false;
			}
			if(result && result.status === false){
				this.$swal({
					icon: 'error',
					title: 'ไม่สามารถตรวจสอบเงื่อนไขโบนัสได้',
					text: 'กรุณาลองใหม่อีกครั้ง'
				});
				return false;
			}
			return true;
		} catch (err) {
			console.error(err);
			this.$swal({
				icon: 'error',
				title: 'ไม่สามารถตรวจสอบเงื่อนไขโบนัสได้',
				text: 'กรุณาลองใหม่อีกครั้ง'
			});
			return false;
		}
	},
	async ensureDepositPromotionAllowed() {
		if(!this.gotpro) return true;
		try {
			const result = await this.$store.dispatch('user/checkBonusClaimEligibility', { type: 'deposit-promo' });
			if(result && result.blocked){
				await this.showPromotionBalanceBlockedAlert(result);
				return false;
			}
			if(result && result.status === false){
				this.$swal({
					icon: 'error',
					title: 'ไม่สามารถตรวจสอบ balance ได้',
					text: 'กรุณาลองใหม่อีกครั้ง'
				});
				return false;
			}
			return true;
		} catch (err) {
			console.error(err);
			this.$swal({
				icon: 'error',
				title: 'ไม่สามารถตรวจสอบ balance ได้',
				text: 'กรุณาลองใหม่อีกครั้ง'
			});
			return false;
		}
	},
	setPromotionChoice(value) {
		if(!this.user || !this.user.key) return;

		this.$store.commit("user/SET_GOT_PRO", value);
		firebase.database().ref(`users/${this.user.key}`).update({bonus: value ? 'Y' : 'N'});
	},
	getLocalizedImage(item) {
      if (!item) return '';
      
      const currentLang = this.$i18n.locale;
      const imageField = `image_${currentLang}`;
      
      // ใช้รูปตามภาษา ถ้าไม่มีใช้รูปภาษาไทย ถ้าไม่มีอีกใช้รูปปกติ
      return item[imageField] || item.image_th || item.image;
    },
	toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    selectLanguage(langCode) {
      // Update user language in database
      if(this.user && this.user.key) {
        firebase.database().ref(`users/${this.user.key}`).update({
          language: langCode
        });
        
        // Update local user data
        const userData = JSON.parse(localStorage.getItem('userData'));
        userData.language = langCode;
        localStorage.setItem('userData', JSON.stringify(userData));
        
        // Update Vuex store
        this.$store.dispatch('user/setUser', userData);
		this.$i18n.locale = langCode;
      }
      
      this.isDropdownOpen = false;
    },
	getLanguageName () {
		const language = this.user.language;
		const validLanguages = ['my', 'en', 'lo', 'th'];
		if (validLanguages.includes(language)) {
			const lang = this.languages.find(lang => lang.code === language);
			return lang ? lang.name : this.$t('thai_lang');
		}
		return this.$t('thai_lang');
	},
	getFlagImage() {
		const language = this.user.language;
		const validLanguages = ['my', 'en', 'lo', 'th'];
		
		if (validLanguages.includes(language)) {
		return require(`../assets/images/flags/${language}.png`);
		}
		
		return require('../assets/images/flags/th.png');
	},
	setWithdraw2 (value) {
		  if (value === 'plus') {
			  this.deposit_value = (this.deposit_value) ? this.deposit_value + 10 : 10
		  } else if (value === 'minus') {
			  if (this.deposit_value) { this.deposit_value = (this.deposit_value) ? this.deposit_value - 10 : 0 }
		  } else if (value > 0) { this.deposit_value = value } else { this.deposit_value = 0 }
	},
	genQrCodeCorePay(){
		if(this.papaya){
			if(this.deposit_value < 300){
				this.$swal({ icon: 'error', title: this.$t('promptpay_deposit_title'), text: this.$t('amount_must_exceed_300')}).then((result) => {});
			}else{
				this.$store.commit('user/SET_LOADING', true)
				firebase.firestore().collection('papaya').add({
					userkey:this.user.key,
					code:this.user.code,
					createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
					status:false,
					amount:this.deposit_value,
				}).then(async (result)=>{
					this.unsubscribe = firebase.firestore().collection('papaya').doc(result.id).onSnapshot(async (doc) => {
					if(doc.data().papaya && doc.data().status){
						this.corepayimage = doc.data().papaya.payurl;
						this.unsubscribe()
					}else if(doc.data().papaya && !doc.data().status){
						this.$store.commit('user/SET_LOADING', false)
						if(doc.data().papaya)
						this.$swal({ icon: 'error', title: this.$t('promptpay_problem'), text: this.$tWithSettings('please_contact_admin')}).then((result) => {
						});
						this.unsubscribe()
					}else if(doc.data().papaya && doc.data().status){
						this.$store.commit('user/SET_LOADING', false)
						this.$swal({ icon: 'success', title: 'Success', text: this.$t('promptpay_success')})
						this.unsubscribe()
						$("#depositModal").modal('hide')
					}
					});
					axios.get(`https://api.vr1game-v2.online/sonic/${result.id}`).then((result)=>{
					this.$store.commit('user/SET_LOADING', false)
					})
				})
			}
		}
    },
	showCorepayPage(){
      if(this.corepaypage)
        this.corepaypage = false;
      else
        this.corepaypage = true;
    },
	showDateTime(date){
		return moment(date,'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY HH:mm');
	},
	async closeAnnouncement(type){
		if(type===1){
			firebase.database().ref(`/announcement_users/${this.user.key}`).update({
				status: this.$t('acknowledged_status'),
				updatetime:moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
				close:true
			});
		}
		document.getElementById("an-close").click();
	},
	async getAnnouncementUser(key){
		if(key){
			const announcement = (await firebase.database().ref(`/announcement_users/${key}`).once('value')).val();
			if(announcement && !announcement.close && announcement.title && (!announcement.status || announcement.status !== this.$t('acknowledged_status'))){
				this.announcement_user = announcement;
				document.getElementById("a-modal").click();
			}
		}
	},
	async uploadSlip(event){
		if(!(await this.ensureActivePromotionDepositAllowed())){
			if(event && event.target){
				event.target.value = '';
			}
			return;
		}
		const imageData = event && event.target && event.target.files ? event.target.files[0] : null;
		if(!imageData || this.isSlipUploading) return;

		let slipRef = null;
		this.isSlipUploading = true;
		this.$store.commit('user/SET_LOADING', true)

		try {
			const approvedAccounts = this.getApprovedAccounts();
			if (approvedAccounts.length === 0) {
				this.$swal({ icon: 'error', title: 'ข้อผิดพลาด', text: 'กรุณาเพิ่มบัญชีธนาคารที่ได้รับการอนุมัติก่อนแจ้งสลิป'});
				return;
			}

			const activeSlip = await this.findActiveSlipUpload();
			if(activeSlip){
				throw new Error(ACTIVE_SLIP_ERROR);
			}

			let uploadImage = imageData;
			try {
				uploadImage = await this.resizeImage(imageData, 800, 800);
			}catch(resizeError){
				console.warn('resize slip image failed, uploading original image', resizeError);
			}

			const selectedAccount = this.currentDepositAccount || this.selectedDepositAccount || approvedAccounts[0];
			slipRef = await this.createSlipUploadRecord(selectedAccount);

			const fileExtension = this.getSlipImageExtension(imageData);
			const uploadMetadata = {
				contentType: uploadImage.type || imageData.type || 'image/jpeg'
			};
			const uploadTask = firebase.storage().ref(`images/slip/${slipRef.id}.${fileExtension}`).put(uploadImage, uploadMetadata);
			uploadTask.on(`state_changed`, snapshot => {
				this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
			});

			const uploadSnapshot = await uploadTask;
			const url = await uploadSnapshot.ref.getDownloadURL();
			await slipRef.update({ image:url });

			this.$swal({ icon: 'success', title: 'แจ้งสลิปเรียบร้อย', text: `ทีมงานขออภัยในความล่าช้าและจะรีบดำเนินการให้โดยเร็วที่สุด`}).then((result) => {
			});
		}catch(error){
			if(slipRef){
				try {
					await slipRef.update({
						status:'ยกเลิก',
						auto_read_status:'failed',
						auto_read_reason:'upload_failed',
						auto_read_error:error.message || 'Upload failed',
						updatetime: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
					});
				}catch(cleanupError){
					console.error(cleanupError);
				}
			}

			if(error.message === ACTIVE_SLIP_ERROR){
				this.$swal({ icon: 'error', title: 'แจ้งสลิป', text: `ทีมงานกำลังตรวจสอบสลิปของท่านก่อนหน้า กรุณารอให้รายการเป็นดำเนินการแล้วหรือยกเลิกก่อน หรือรอครบ 30 นาที จึงจะส่งสลิปใหม่ได้`}).then((result) => {
				});
			}else{
				console.error(error);
				this.$swal({ icon: 'error', title: 'แจ้งสลิป', text: `ไม่สามารถอัปโหลดสลิปได้ กรุณาลองใหม่อีกครั้ง`}).then((result) => {
				});
			}
		}finally{
			this.isSlipUploading = false;
			this.$store.commit('user/SET_LOADING', false)
			if(event.target){
				event.target.value = '';
			}
		}
	},
	openBrowseFile(){
    	document.getElementById('my_file').click();
	},
	openBrowseFileStep1(){
		if (this.$refs.fileInputStep1) {
			this.$refs.fileInputStep1.click();
		}
	},
	openBrowseFileStep2(){
		if (this.$refs.fileInputStep2) {
			this.$refs.fileInputStep2.click();
		}
	},
	openBrowseFileStep3(){
		if (this.$refs.fileInputStep3) {
			this.$refs.fileInputStep3.click();
		}
	},
	openBrowseFileOld(){
		if (this.$refs.fileInputOld) {
			this.$refs.fileInputOld.click();
		}
	},
	async getBankDeposit(){
		this.bank = {};
		this.hideBankSection = false; // Reset hide flag ตั้งแต่ต้น
		// ตรวจสอบข้อมูลผู้ใช้ก่อนส่ง request
		if (!this.user || !this.user.key) {
			console.warn('getBankDeposit: Missing user data');
			return;
		}

		// ตรวจสอบจำนวนบัญชีที่อนุมัติแล้ว (status = true)
		const approvedAccounts = this.getApprovedAccounts();
		
		if(approvedAccounts.length === 0) {
			console.warn('getBankDeposit: No approved accounts found');
			return;
		}

		// ถ้ามีบัญชีที่อนุมัติแล้วมากกว่า 1 ให้แสดงให้เลือกก่อน
		if(approvedAccounts.length > 1) {
			this.showBankSelectionForDeposit = true;
			// โหลดข้อมูลธนาคารแรกไว้ก่อน เพื่อให้เร็วขึ้น
			await this.callGetBanksOnTimeAPI(approvedAccounts[0]);
			return;
		}

		// ถ้ามีแค่ 1 บัญชี ให้เรียก API โดยส่งธนาคารของบัญชีนั้นไป
		const selectedBank = approvedAccounts[0];
		await this.callGetBanksOnTimeAPI(selectedBank);
	},

	// Method แยกสำหรับเรียก API
	async callGetBanksOnTimeAPI(customerBank) {
		try {
			// Set loading state
			this.fa_spin = true;
			this.isBankLoading = true;

			const data = JSON.stringify({
				"bank": customerBank.bank,
				"key": this.user.key
			});
			const config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: 'https://asia-east2-vr1game.cloudfunctions.net/getBanksOnTime',
				headers: { 
					'x-api-key': 'LosnQ8W6uWoVs8N-ik_', 
					'Content-Type': 'application/json'
				},
				data: data,
				timeout: 8000 // ลดเวลาจาก 10 เป็น 8 วินาที
			};

			const response = await axios.request(config);
			// ตรวจสอบข้อมูลที่ได้รับ
			// console.log('response',response.data);
			if (response.data && response.data.banks && response.data.banks.length > 0) {
				const bankData = response.data.banks[0];
				// ใช้ Object.assign เพื่อ merge ข้อมูลใหม่เข้ากับ object เดิม เพื่อรักษา reactivity
				Object.assign(this.bank, bankData);
				
				// รีเซ็ต hide flag เมื่อมีข้อมูลธนาคาร
				this.hideBankSection = false;
				
				// console.log('Bank data loaded:', {
				// 	bankData: bankData,
				// 	hideBankSection: this.hideBankSection,
				// 	bank: this.bank
				// });
			} else {
				console.warn('No bank data received, hiding bank section');
				
				// ถ้าไม่มีธนาคารจาก API (เช่น เวลา 00:00) ให้ซ่อน deposit section
				this.hideBankSection = true;
			}

		} catch (error) {
			console.error('getBankDeposit error:', error);
			
			// แสดงข้อความแจ้งเตือนให้ผู้ใช้เมื่อเกิดข้อผิดพลาด
			if (error.code === 'ECONNABORTED') {
				this.$swal({ 
					icon: 'error', 
					title: 'ข้อผิดพลาด', 
					text: 'เครือข่ายช้า กรุณาลองใหม่อีกครั้ง' 
				});
			} else if (error.response) {
				// Server responded with error status
				this.$swal({ 
					icon: 'error', 
					title: 'ข้อผิดพลาด', 
					text: 'ไม่สามารถโหลดข้อมูลธนาคารได้ กรุณาลองใหม่อีกครั้ง' 
				});
			} else {
				// Network error or other issues
				this.$swal({ 
					icon: 'error', 
					title: 'ข้อผิดพลาด', 
					text: 'เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาตรวจสอบอินเทอร์เน็ต' 
				});
			}
		} finally {
			// Reset loading state
			this.fa_spin = false;
			this.isBankLoading = false;
		}
	},
	async callGetWithdrawCondition() {
		try {
			const condition = await getWithdrawConditionOnce(this.user.key);
				if (condition) {
					this.condition = condition;
					this.conditionLoaded = true;
					return true;
				} else {
					console.warn('No bank data received, hiding bank section');
				}

			} catch (error) {
				console.error('getWithdrawCondition error:', error);
			}
			return this.conditionLoaded;
		},

	// Method สำหรับเมื่อผู้ใช้เลือกธนาคารในการฝากเงิน (ระบบใหม่)
	async onDepositBankSelected() {
		if (this.selectedDepositAccount) {
			this.showBankSelectionForDeposit = false;
			// ไม่เรียก API ทันที รอให้ user กรอกจำนวนเงินก่อน
		}
	},

	// Set quick deposit amount
	setDepositAmount(amount) {
		this.inputDepositAmount = amount;
	},

	isTrueWalletDepositAccount(account) {
		return normalizeConfiguredPaymentBankCode(account && (account.bank || account.bank_name)) === 'truewallet';
	},

	getAvailableConfiguredPaymentChannels(selectedAccount, options = {}) {
		const account = selectedAccount || this.selectedDepositAccount || this.getApprovedAccounts()[0] || null;
		const ignoreAccountRestrictions = options.ignoreAccountRestrictions === true;
		const channels = [];
		if (this.dypayConfig && this.dypayConfig.enabled && this.dypayConfig.depositEnabled && this.dypayConfig.availableNow !== false && this.dypayVisibleToUser && (ignoreAccountRestrictions || !this.isDyPayBlockedDepositAccount(account))) {
			channels.push({ type: 'dypay', min: Number(this.dypayConfig.depositMin || 300), max: Number(this.dypayConfig.depositMax || 100000) });
		}
		if (this.paykumoConfig && this.paykumoConfig.enabled && this.paykumoConfig.depositEnabled && this.paykumoConfig.availableNow === true && this.paykumoVisibleToUser && (ignoreAccountRestrictions || !this.isPaykumoBlockedDepositAccount(account))) {
			channels.push({ type: 'paykumo', min: Number(this.paykumoConfig.depositMin || 300), max: Number(this.paykumoConfig.depositMax || 100000) });
		}
		if (this.s3PayConfig && this.s3PayConfig.enabled && this.s3PayConfig.depositEnabled && this.s3PayVisibleToUser && (ignoreAccountRestrictions || !this.isS3PayBlockedDepositAccount(account))) {
			channels.push({ type: 's3pay', min: Number(this.s3PayConfig.depositMin || 300), max: Number(this.s3PayConfig.depositMax || 100000) });
		}
		if (this.copayConfig && this.copayConfig.enabled && this.copayConfig.depositEnabled && this.copayConfig.availableNow !== false && this.copayVisibleToUser && (ignoreAccountRestrictions || !this.isCopayBlockedDepositAccount(account))) {
			channels.push({ type: 'copay', min: Number(this.copayConfig.depositMin || 300), max: Number(this.copayConfig.depositMax || 100000) });
		}
		if (this.kisspayConfig && this.kisspayConfig.enabled && this.kisspayConfig.depositEnabled && this.kisspayConfig.availableNow !== false && this.kisspayVisibleToUser && (ignoreAccountRestrictions || !this.isKissPayBlockedDepositAccount(account))) {
			channels.push({
				type: 'kisspay',
				min: Number(this.kisspayConfig.depositMin || 300),
				max: Number(this.kisspayConfig.depositMax || 200000)
			});
		}
		return channels;
	},

	formatConfiguredPaymentDepositRange(channels) {
		if (!Array.isArray(channels) || channels.length === 0) return '';
		const minimum = Math.min(...channels.map(channel => Number(channel.min || 0)).filter(value => value > 0));
		const maximum = Math.max(...channels.map(channel => Number(channel.max || 0)).filter(value => value > 0));
		if (!Number.isFinite(minimum) || !Number.isFinite(maximum)) return '';
		return `${minimum.toLocaleString()}-${maximum.toLocaleString()}`;
	},

	isConfiguredPaymentAmountAllowed(channel, amount) {
		const value = Number(amount || 0);
		return Number.isInteger(value) && value >= channel.min && (channel.max <= 0 || value <= channel.max);
	},

	async loadConfiguredPaymentChannels() {
		await Promise.all([
			typeof this.loadDyPayConfig === 'function' ? this.loadDyPayConfig() : Promise.resolve(),
			typeof this.loadPaykumoConfig === 'function' ? this.loadPaykumoConfig() : Promise.resolve(),
			typeof this.loadS3PayConfig === 'function' ? this.loadS3PayConfig() : Promise.resolve(),
			typeof this.loadCopayConfig === 'function' ? this.loadCopayConfig() : Promise.resolve(),
			typeof this.loadKissPayConfig === 'function' ? this.loadKissPayConfig() : Promise.resolve()
		]);
	},

	getDepositChannelLockContext() {
		return {
			storage: typeof window !== 'undefined' ? window.localStorage : null,
			userKey: this.user && this.user.key ? this.user.key : ''
		};
	},

	buildDepositCandidates(paymentChannels, receiverBanks) {
		return buildLockedDepositCandidates(paymentChannels, receiverBanks, this.getDepositChannelLockContext());
	},

	lockDepositCandidate(candidate) {
		const { storage, userKey } = this.getDepositChannelLockContext();
		return saveDepositChannelLock(storage, userKey, candidate);
	},

	releaseDepositChannelLock() {
		const { storage, userKey } = this.getDepositChannelLockContext();
		clearDepositChannelLock(storage, userKey);
	},

	async tryConfiguredPaymentChannel(channel, selectedAccount) {
		if (!channel) return false;
		let created = false;
		if (channel.type === 'dypay') created = await this.tryDyPayDeposit(selectedAccount);
		if (channel.type === 'paykumo') created = await this.tryPaykumoDeposit(selectedAccount);
		if (channel.type === 's3pay') created = await this.tryS3PayDeposit(selectedAccount);
		if (channel.type === 'copay') created = await this.tryCopayDeposit(selectedAccount);
		if (channel.type === 'kisspay') created = await this.tryKissPayDeposit(selectedAccount);
		if (created) this.lockDepositCandidate({ type: 'payment', channel });
		return created;
	},

	isConfiguredPaymentTemporarilyUnavailable(error) {
		const message = String(error && error.message || '').trim().toLowerCase();
		return message.includes('outside deposit service hours') ||
			(message.includes('outside') && message.includes('service hours')) ||
			message.includes('ปิดให้บริการตามเวลาที่กำหนด') ||
			message.includes('นอกเวลาให้บริการ');
	},

	isLegacyDepositReceiverBank(bank) {
		return isLegacyDepositReceiverBank(bank);
	},

	isSecurePayBank(bank) {
		if (!bank) return false;
		return bank.bank_name === 'securepay' || bank.type_deposit === 'securepay' || bank.payment_provider === 'securepay';
	},

	isRetiredPaymentBank(bank) {
		if (!bank) return false;
		return [bank.id, bank.key, bank.bank_name, bank.type_deposit, bank.payment_provider]
			.some(value => RETIRED_PAYMENT_PROVIDER_KEYS.has(String(value || '').trim().toLowerCase()));
	},

	isSecurePayDepositAllowed(bank, amount, customerBank) {
		if (!this.isSecurePayBank(bank)) return true;
		if (isPaymentBankBlocked(paymentBlockedBanksFromRecord(bank), customerBank)) return false;
		const usage = ['deposit', 'withdraw', 'both'].includes(String(bank.payment_usage || '').toLowerCase())
			? String(bank.payment_usage).toLowerCase()
			: 'both';
		if (usage !== 'deposit' && usage !== 'both') return false;
		if (this.normalizePaymentBankCode(customerBank) === 'kiatnakin') return false;
		const value = Number(amount || 0);
		const min = Number(bank.payment_deposit_min_amount === undefined ? 50 : bank.payment_deposit_min_amount);
		const max = Number(bank.payment_deposit_max_amount || 0);
		if (!Number.isFinite(value) || value < min || (max > 0 && value > max)) return false;
		const visibleCodes = String(bank.visible_to_codes === undefined ? '*' : bank.visible_to_codes)
			.split(',').map(code => code.trim().toUpperCase()).filter(Boolean);
		const userCode = String(this.user && this.user.code || '').toUpperCase();
		return visibleCodes.length === 0 || visibleCodes.includes('*') || visibleCodes.includes(userCode);
	},

	normalizePaymentBankCode(bankValue) {
		const raw = String(bankValue || '').toLowerCase().replace(/\s+/g, '').replace(/ธนาคาร/g, '');
		const bankMap = {
			'002': 'bankokbank',
			'004': 'kbank',
			'006': 'ktb',
			'011': 'ttb',
			'014': 'scb',
			'022': 'cimb',
			'024': 'uob',
			'025': 'krungsri',
			'030': 'gsb',
			'033': 'ghbank',
			'034': 'baac',
			'067': 'tisco',
			'069': 'kiatnakin',
			'073': 'lh',
			'074': 'ttb',
			bbl: 'bankokbank',
			bangkok: 'bankokbank',
			bangkokbank: 'bankokbank',
			kbank: 'kbank',
			kasikorn: 'kbank',
			kasikornbank: 'kbank',
			ktb: 'ktb',
			krungthai: 'ktb',
			scb: 'scb',
			scba: 'scb',
			bay: 'krungsri',
			krungsri: 'krungsri',
			gsb: 'gsb',
			ttb: 'ttb',
			tmb: 'ttb',
			cimb: 'cimb',
			uob: 'uob',
			baac: 'baac',
			tisco: 'tisco',
			kkp: 'kiatnakin',
			kiatnakin: 'kiatnakin',
			ghb: 'ghbank',
			ghbank: 'ghbank',
			lh: 'lh',
			lhbank: 'lh'
		};
		return bankMap[raw] || raw;
	},

	isTruthyPaymentFlag(value) {
		if (value === true) return true;
		if (value === false || value === null || value === undefined) return false;
		return ['true', '1', 'yes', 'y', 'active', 'public'].includes(String(value).trim().toLowerCase());
	},

	getVisibleDepositReceiverBanks(banks, customerBank) {
		return banks.filter((bank) =>
			(!this.isSecurePayBank(bank) || this.isSecurePayDepositAllowed(bank, this.inputDepositAmount, customerBank))
		);
	},

	securePayStorageKey() {
		return this.user && this.user.key ? `securepay_deposit_${this.user.key}` : '';
	},

	storeSecurePayDeposit(payload) {
		const key = this.securePayStorageKey();
		if (key) window.localStorage.setItem(key, JSON.stringify(payload));
	},

	clearSecurePayDepositCache() {
		const key = this.securePayStorageKey();
		if (key) window.localStorage.removeItem(key);
	},

	cleanupSecurePayDepositListener() {
		if (this.securePayDepositUnsubscribe) {
			this.securePayDepositUnsubscribe();
			this.securePayDepositUnsubscribe = null;
		}
	},

	resetSecurePayDepositLocalState() {
		this.cleanupSecurePayDepositListener();
		this.clearSecurePayDepositCache();
		if (this.depositTimerInterval) {
			clearInterval(this.depositTimerInterval);
			this.depositTimerInterval = null;
		}
		this.inputDepositAmount = null;
		this.depositAmount = null;
		this.depositAmountWithDecimal = null;
		this.assignedBank = null;
		this.depositTimer = null;
		this.depositDeadline = null;
		this.depositDecimal = null;
		this.depositTransactionId = null;
		this.securePayTransaction = null;
		this.securePayPageUrl = '';
		this.isSlipUploading = false;
		this.releaseDepositChannelLock();
	},

	listenSecurePayDepositStatus(refId) {
		this.cleanupSecurePayDepositListener();
		if (!refId) return;
		this.securePayDepositUnsubscribe = firebase.firestore().collection('securepay_transactions').doc(refId).onSnapshot(snapshot => {
			if (!snapshot.exists) return;
			const data = snapshot.data() || {};
			const status = String(data.status || '').toUpperCase();
			if (status === 'SUCCESS' || data.credit_applied === true) {
				this.resetSecurePayDepositLocalState();
				this.$swal({ icon: 'success', title: 'ฝากเงินสำเร็จ', text: 'ระบบเติมเครดิตเรียบร้อยแล้ว' });
				$('#depositModal').modal('hide');
			} else if (['FAILED', 'EXPIRED', 'CANCELLED'].includes(status)) {
				this.resetSecurePayDepositLocalState();
				$('#depositModal').modal('hide');
			}
		}, error => console.error('SecurePay listener error:', error));
	},

	async createSecurePayDepositTransaction(bank) {
		const account = this.currentDepositAccount || this.getApprovedAccounts()[0] || {};
		const amount = parseInt(this.inputDepositAmount) || 0;
		const response = await axios.request({
			method: 'post',
			url: 'https://asia-east2-vr1game.cloudfunctions.net/securePayCreateDeposit',
			headers: { 'x-api-key': CLOUD_FUNCTIONS_API_KEY, 'Content-Type': 'application/json' },
			data: {
				userKey: this.user.key,
				amount,
				bonus: this.user.bonus || 'N',
				paymentBankId: bank.id || bank.key || 'securepay',
				account
			},
			timeout: 70000
		});
		if (!response.data || !response.data.success || !response.data.data) {
			throw new Error(response.data && response.data.error || 'ไม่สามารถสร้างรายการ SecurePay ได้');
		}
		const data = response.data.data;
		const pageUrl = data.qr_embed_url || data.payment_url || data.slip_upload_url || '';
		const hasDirectPaymentDetails = Boolean(
			data.qr_code_text ||
			data.qrCodeText ||
			data.destination_account_number
		);
		if (!data.ref_id || !(pageUrl || hasDirectPaymentDetails)) throw new Error('SecurePay ส่งข้อมูลชำระเงินไม่ครบถ้วน');
		return { ...data, pageUrl };
	},

	async restoreSecurePayDepositFromCache() {
		const key = this.securePayStorageKey();
		if (!key) return false;
		let cached = null;
		try { cached = JSON.parse(window.localStorage.getItem(key) || 'null'); } catch (_) { cached = null; }
		if (!cached || !cached.refId || Number(cached.expiresAt || 0) <= Date.now()) {
			this.clearSecurePayDepositCache();
			return false;
		}
		const snapshot = await firebase.firestore().collection('securepay_transactions').doc(cached.refId).get();
		if (!snapshot.exists) {
			this.clearSecurePayDepositCache();
			return false;
		}
		const data = snapshot.data() || {};
		if (data.user_key !== this.user.key || ['SUCCESS', 'FAILED', 'EXPIRED', 'CANCELLED'].includes(String(data.status || '').toUpperCase())) {
			this.clearSecurePayDepositCache();
			return false;
		}
		this.currentDepositAccount = cached.account || null;
		this.assignedBank = cached.bank || { id: 'securepay', bank_name: 'securepay', payment_provider: 'securepay' };
		this.depositAmount = cached.amount;
		this.depositAmountWithDecimal = Number(cached.displayAmount || cached.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
		this.depositTransactionId = cached.refId;
		this.securePayTransaction = {
			...data,
			refId: cached.refId,
			paymentLinkId: cached.paymentLinkId || data.payment_link_id || ''
		};
		this.securePayPageUrl = data.qr_embed_url || data.payment_url || data.slip_upload_url || cached.pageUrl;
		this.showBankSelectionForDeposit = false;
		this.startDepositTimer(Math.max(1, Math.ceil((Number(cached.expiresAt) - Date.now()) / 1000)));
		this.listenSecurePayDepositStatus(cached.refId);
		return true;
	},

	async confirmCancelSecurePayDeposit() {
		const accountType = String(
			(this.securePayTransaction && (this.securePayTransaction.account_type || this.securePayTransaction.accountType)) || ''
		).trim().toUpperCase();
		const isPromptPay = accountType === 'PROMPTPAY';
		const result = await this.$swal({
			icon: 'warning',
			title: isPromptPay ? 'ยกเลิกรายการ QR Code นี้?' : 'ท่านยังไม่ได้อัปโหลดสลิป',
			text: isPromptPay
				? 'หากชำระ QR Code ไปแล้วอย่ายกเลิก กรุณารอระบบตรวจสอบรายการเดิม'
				: 'หากออกจากหน้านี้ จะไม่สามารถกลับมาแนบสลิปรายการนี้ได้ ต้องการออกหรือไม่',
			showCancelButton: true,
			confirmButtonText: 'ยืนยัน',
			cancelButtonText: 'ยกเลิก'
		});
		if (result && result.isConfirmed) await this.cancelDeposit();
	},

	async uploadSecurePaySlip(event) {
		const file = event && event.target && event.target.files && event.target.files[0];
		if (!file || this.isSlipUploading) return false;
		const transaction = this.securePayTransaction || {};
		const refId = transaction.refId || transaction.ref_id || this.depositTransactionId || '';
		const paymentLinkId = transaction.paymentLinkId || transaction.payment_link_id || '';
		if (!refId || !paymentLinkId) {
			await this.$swal({ icon: 'error', title: 'อัปโหลดสลิปไม่สำเร็จ', text: 'ไม่พบรายการ SecurePay กรุณาสร้างรายการฝากใหม่' });
			if (event && event.target) event.target.value = '';
			return false;
		}

		this.isSlipUploading = true;
		this.$store.commit('user/SET_LOADING', true);
		try {
			let uploadImage = file;
			try {
				uploadImage = await this.resizeImage(file, 800, 800);
			} catch (resizeError) {
				console.warn('resize SecurePay slip failed, uploading original image', resizeError);
			}
			const extension = this.getSlipImageExtension(file);
			const contentType = uploadImage.type || file.type || 'image/jpeg';
			const storagePath = `images/securepay/${refId}-${Date.now()}.${extension}`;
			const uploadSnapshot = await firebase.storage().ref(storagePath).put(uploadImage, { contentType });
			const imageUrl = await uploadSnapshot.ref.getDownloadURL();
			const response = await axios.post('https://asia-east2-vr1game.cloudfunctions.net/securePayUploadSlip', {
				userKey: this.user && this.user.key,
				refId,
				paymentLinkId,
				imageUrl,
				fileName: file.name || `${refId}.${extension}`,
				contentType
			}, {
				headers: { 'x-api-key': CLOUD_FUNCTIONS_API_KEY, 'Content-Type': 'application/json' },
				timeout: 60000
			});
			const result = response.data || {};
			if (!result.success) throw new Error(result.error || 'SecurePay ไม่สามารถรับสลิปได้');
			await this.$swal({
				icon: 'success',
				title: 'อัปโหลดสลิปเรียบร้อย',
				text: result.alreadyCompleted ? 'รายการฝากสำเร็จแล้ว' : 'ระบบกำลังตรวจสอบสลิป กรุณารอสักครู่'
			});
			return true;
		} catch (error) {
			console.error('SecurePay slip upload failed:', error);
			const message = error && error.response && error.response.data && error.response.data.error;
			await this.$swal({ icon: 'error', title: 'อัปโหลดสลิปไม่สำเร็จ', text: message || error.message || 'กรุณาลองใหม่อีกครั้ง' });
			return false;
		} finally {
			this.isSlipUploading = false;
			this.$store.commit('user/SET_LOADING', false);
			if (event && event.target) event.target.value = '';
		}
	},

	// Submit deposit amount and generate decimal
	async submitDepositAmount() {
		if (!(await ensureLatestBuild(true))) return;
		if (!this.inputDepositAmount || this.inputDepositAmount <= 0) {
			// Use alert if $vs is not available
			if (this.$vs && this.$vs.notify) {
				this.$vs.notify({
					title: 'ข้อผิดพลาด',
					text: 'กรุณาระบุจำนวนเงินที่ถูกต้อง',
					color: 'danger',
					position: 'top-right'
				});
			} else {
				alert('กรุณาระบุจำนวนเงินที่ถูกต้อง');
			}
			return;
		}

		try {
			this.isBankLoading = true;

			if (!(await this.ensureNoPendingWithdrawal())) {
				return;
			}

			if(!(await this.ensureActivePromotionDepositAllowed())){
				return;
			}

			if(!(await this.ensureDepositPromotionAllowed())){
				return;
			}
			
			// Get selected account or default to first approved account
			const selectedAccount = this.selectedDepositAccount || this.getApprovedAccounts()[0];
			
			// Check if approved account exists
			if (!selectedAccount) {
				throw new Error('กรุณาเพิ่มบัญชีธนาคารก่อนทำการฝากเงิน');
			}
			
			// Store account for transaction
			this.currentDepositAccount = selectedAccount;
			this.persistDepositCustomerAccount(selectedAccount);

			const isTrueWalletDeposit = this.isTrueWalletDepositAccount(selectedAccount);
			const amountInt = parseInt(this.inputDepositAmount) || 0;
			// PayBridge must get the first chance to match an active withdrawal.
			// When no match is available it returns false and the existing providers remain the fallback.
			if (!isTrueWalletDeposit && await this.tryPayBridgeDeposit(selectedAccount)) return;
			await this.loadConfiguredPaymentChannels();
			const configuredPaymentChannels = this.getAvailableConfiguredPaymentChannels(selectedAccount);
			const eligiblePaymentChannels = configuredPaymentChannels
				.filter(channel => this.isConfiguredPaymentAmountAllowed(channel, amountInt));
			const eligibleConfiguredChannels = eligiblePaymentChannels;
			
			// เช็คว่าลูกค้าใช้ truewallet ไหม (ทั้งบัญชีเดียวและหลายบัญชี)
			const customerBank = selectedAccount.bank;
			if(isTrueWalletDeposit){
				// Set deposit amount for truewallet
				this.depositAmount = amountInt;
				this.depositAmountWithDecimal = `${amountInt.toLocaleString('en-US')}.00`;
				this.depositDecimal = '00';

				const allBanks = await getBankPublicOptionsOnce(firebase.database());

				if (!allBanks) {
					throw new Error('ไม่พบบัญชี TrueWallet');
				}

				const availableTrueWalletBanks = Object.entries(allBanks)
					.filter(([, bank]) => bank && bank.bank_name === 'truewallet' && this.isBankOpenNow(bank))
					.map(([key, bank]) => ({ ...bank, id: key }));

					if (availableTrueWalletBanks.length === 0) {
						throw new Error('ไม่มีบัญชี TrueWallet ที่พร้อมให้บริการในขณะนี้');
					}

					const selectedTrueWalletCandidate = this.buildDepositCandidates([], availableTrueWalletBanks)[0];
					this.assignedBank = selectedTrueWalletCandidate.bank;
					this.lockDepositCandidate(selectedTrueWalletCandidate);
					this.isBankLoading = false;
					return;
				}
			// Get available banks from realtime database
			const allBanks = await getBankPublicOptionsOnce(firebase.database());
			
			if (!allBanks) {
				throw new Error('ไม่พบข้อมูลธนาคาร');
			}

			// Filter banks with status true and valid display_time
			const availableBanks = [];
			
			Object.entries(allBanks).forEach(([key, bank]) => {
				const bankWithId = { ...bank, id: key };
				const isSupportedSecurePay = this.isSecurePayBank(bankWithId);
				if (bank.bank_name !== 'truewallet' && (isSupportedSecurePay || this.isLegacyDepositReceiverBank(bankWithId)) && !this.isRetiredPaymentBank(bankWithId) && this.isBankOpenNow(bank)) {
					availableBanks.push(bankWithId);
				}
			});

			const depositBanks = this.condition.disableDeposit
				? availableBanks.filter(bank => this.isSecurePayBank(bank))
				: availableBanks;
			const visibleBanks = this.getVisibleDepositReceiverBanks(depositBanks, selectedAccount.bank);

			const candidates = this.buildDepositCandidates(eligibleConfiguredChannels, visibleBanks);
			if (candidates.length === 0) {
				const range = this.formatConfiguredPaymentDepositRange(configuredPaymentChannels);
				throw new Error(this.condition.disableDeposit && range
					? `ไม่สามารถสร้างการฝากได้ ตอนนี้ระบบรองรับยอดฝาก ${range} บาท ต่อรายการเท่านั้น`
					: 'ไม่มีธนาคารที่พร้อมให้บริการในขณะนี้');
			}
			let selectedReceiverBank = null;
			for (const candidate of candidates) {
				if (candidate.type === 'bank') {
					selectedReceiverBank = candidate.bank;
					break;
				}

				try {
					if (await this.tryConfiguredPaymentChannel(candidate.channel, selectedAccount)) return;
					this.releaseDepositChannelLock();
				} catch (error) {
					if (!this.isConfiguredPaymentTemporarilyUnavailable(error)) throw error;
					this.releaseDepositChannelLock();
					console.info(`ข้าม ${candidate.channel.type} เนื่องจากอยู่นอกเวลาให้บริการ`);
				}
			}

			if (!selectedReceiverBank) {
				throw new Error('ไม่มีธนาคารที่พร้อมให้บริการในขณะนี้');
			}

					if (!this.isSecurePayBank(selectedReceiverBank)) {
						assertLegacyDepositReceiverBank(selectedReceiverBank);
					}

					if (this.isSecurePayBank(selectedReceiverBank)) {
						const securePayDeposit = await this.createSecurePayDepositTransaction(selectedReceiverBank);
						const displayAmount = Number(securePayDeposit.amount_generated || securePayDeposit.amount || amountInt);
						const expiresAt = securePayDeposit.expired_at
							? new Date(securePayDeposit.expired_at).getTime()
							: Date.now() + (600 * 1000);
						this.depositAmount = amountInt;
						this.depositAmountWithDecimal = displayAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
						this.depositDecimal = '00';
						this.assignedBank = selectedReceiverBank;
						this.depositTransactionId = securePayDeposit.ref_id;
						this.securePayTransaction = {
							...securePayDeposit,
							refId: securePayDeposit.ref_id,
							paymentLinkId: securePayDeposit.payment_link_id || ''
						};
						this.securePayPageUrl = securePayDeposit.pageUrl;
						this.storeSecurePayDeposit({
							refId: securePayDeposit.ref_id,
							paymentLinkId: securePayDeposit.payment_link_id || '',
							pageUrl: securePayDeposit.pageUrl,
							amount: amountInt,
							displayAmount,
							expiresAt: Number.isFinite(expiresAt) ? expiresAt : Date.now() + (600 * 1000),
							accountType: securePayDeposit.account_type || '',
							bank: selectedReceiverBank,
							account: selectedAccount
						});
						this.lockDepositCandidate({ type: 'bank', bank: selectedReceiverBank });
						this.listenSecurePayDepositStatus(securePayDeposit.ref_id);
						this.startDepositTimer(Math.max(1, Math.ceil(((Number.isFinite(expiresAt) ? expiresAt : Date.now() + 600000) - Date.now()) / 1000)));
						return;
					}

					// Reserve decimal and create deposit transaction atomically on the backend
					const reservation = await this.reserveDepositTransaction(selectedReceiverBank);
					
					// Set deposit data
					this.depositAmount = amountInt;
					this.depositAmountWithDecimal = `${amountInt.toLocaleString('en-US')}.${reservation.decimal}`;
					this.depositDecimal = reservation.decimal;
					this.assignedBank = selectedReceiverBank;
					this.depositTransactionId = reservation.depositTransactionId;
					this.lockDepositCandidate({ type: 'bank', bank: selectedReceiverBank });
				
				// Start 10-minute timer
				this.startDepositTimer();
				
			} catch (error) {
				this.releaseDepositChannelLock();
				console.error('Submit deposit error:', error);
			const responseData = error && error.response && error.response.data;
			const errorText =
				(responseData && (responseData.error || responseData.message)) ||
				error.message ||
				'เกิดข้อผิดพลาด กรุณาลองใหม่';
			await this.$swal({
				icon: 'warning',
				title: 'แจ้งเตือน',
				text: errorText,
				confirmButtonText: 'ตกลง'
			});
		} finally {
			this.isBankLoading = false;
		}
	},

		// Reserve decimal and create deposit transaction atomically on the backend
		async reserveDepositTransaction(bank) {
			assertLegacyDepositReceiverBank(bank);
			const account = this.currentDepositAccount || this.getApprovedAccounts()[0] || {};
			const amountInt = parseInt(this.inputDepositAmount) || 0;
			const data = JSON.stringify({
				key: this.user.key || '',
				amount: amountInt,
				bank: bank.bank_name || '',
				bank_account: bank.account_no || '',
				customer_bank: account.bank || '',
				customer_account: account.account_no || '',
				customer_firstname: account.firstname || '',
				customer_lastname: account.lastname || ''
			});
			const config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: 'https://asia-east2-vr1game.cloudfunctions.net/reserveDepositDecimal',
				headers: {
					'x-api-key': CLOUD_FUNCTIONS_API_KEY,
					'Content-Type': 'application/json'
				},
				data: data,
				timeout: 8000
			};
			const response = await axios.request(config);
			if (!response.data || !response.data.success || !response.data.decimal || !response.data.depositTransactionId) {
				throw new Error((response.data && response.data.message) || 'ไม่สามารถสร้างเลขทศนิยมได้ กรุณาลองใหม่');
			}

			return {
				decimal: response.data.decimal.toString().padStart(2, '0'),
				depositTransactionId: response.data.depositTransactionId
			};
	},

	// Start countdown timer for deposit
	startDepositTimer(seconds = 600) {
		const durationSeconds = Math.max(1, parseInt(seconds) || 600);
		this.depositTimer = durationSeconds;

		// Set deadline time
		this.depositDeadline = new Date(Date.now() + durationSeconds * 1000);

		if (this.depositTimerInterval) {
			clearInterval(this.depositTimerInterval);
		}
		
		this.depositTimerInterval = setInterval(() => {
			this.depositTimer--;
			if (this.depositTimer <= 0) {
				this.cancelDeposit();
			}
		}, 1000);
	},

	// Format timer display
	formatTime(seconds) {
		const minutes = Math.floor(seconds / 60);
		const secs = seconds % 60;
		return `${minutes}:${secs.toString().padStart(2, '0')}`;
	},

	// Format deadline time (HH:MM)
	formatDeadlineTime() {
		if (!this.depositDeadline) return '';
		const now = new Date(this.depositDeadline);
		const hours = now.getHours().toString().padStart(2, '0');
		const minutes = now.getMinutes().toString().padStart(2, '0');
		return `${hours}:${minutes}`;
	},

	async confirmCancelBankDeposit() {
		if (this.isCancellingBankDeposit) return false;
		const result = await this.$swal({
			icon: 'warning',
			title: 'ยกเลิกรายการและสร้างรายการใหม่?',
			text: 'หากโอนไปแล้วอย่ายกเลิก กรุณารอระบบตรวจสอบหรืออัปโหลดสลิปของรายการเดิม',
			showCancelButton: true,
			confirmButtonText: 'ยืนยันยกเลิก',
			cancelButtonText: 'ทำรายการเดิมต่อ',
			allowOutsideClick: false,
			allowEscapeKey: false
		});
		if (!result || !result.isConfirmed) return false;

		this.isCancellingBankDeposit = true;
		try {
			return await this.cancelDeposit();
		} finally {
			this.isCancellingBankDeposit = false;
		}
	},

	// Cancel deposit
	async cancelDeposit() {
		const depositTransactionId = this.depositTransactionId;
		const isSecurePayDeposit = this.isSecurePayDepositActive;
		
		try {
			//Update transaction status if exists
			if (depositTransactionId && isSecurePayDeposit) {
				const response = await axios.request({
					method: 'post',
					url: 'https://asia-east2-vr1game.cloudfunctions.net/securePayCancelDeposit',
					headers: { 'x-api-key': CLOUD_FUNCTIONS_API_KEY, 'Content-Type': 'application/json' },
					data: {
						userKey: this.user.key,
						refId: this.securePayTransaction && this.securePayTransaction.refId || depositTransactionId,
						paymentLinkId: this.securePayTransaction && this.securePayTransaction.paymentLinkId || ''
					},
					timeout: 15000
				});
				const result = response.data || {};
				if (!result.success) throw new Error(result.error || 'ไม่สามารถยกเลิกรายการ SecurePay ได้');
				if (result.alreadyCompleted) {
					await this.$swal({ icon:'info', title:'รายการฝากเดิมสำเร็จแล้ว', text:'ระบบได้รับยอดฝากของรายการเดิมแล้ว' });
					return false;
				}
			} else if (depositTransactionId) {
				const db = firebase.firestore();
				await db.collection('deposit_decimals').doc(depositTransactionId).set({
					status: 'cancelled',
					cancelled_at: firebase.firestore.FieldValue.serverTimestamp()
				}, { merge: true });
			}
		} catch (error) {
			console.warn('Failed to cancel active deposit:', error && error.message ? error.message : error);
			await this.$swal({ icon:'error', title:'ยังไม่สามารถสร้างรายการใหม่ได้', text:'ระบบปิดรายการฝากเดิมไม่สำเร็จ กรุณาลองอีกครั้ง' });
			return false;
		}

		if (this.depositTimerInterval) {
			clearInterval(this.depositTimerInterval);
			this.depositTimerInterval = null;
		}
		this.cleanupSecurePayDepositListener();
		this.inputDepositAmount = null;
		this.depositAmount = null;
		this.depositAmountWithDecimal = null;
		this.assignedBank = null;
		this.depositTimer = null;
		this.depositDeadline = null;
		this.depositDecimal = null;
		this.depositTransactionId = null;
		this.currentDepositAccount = null;
		this.securePayTransaction = null;
		this.securePayPageUrl = '';
		this.clearSecurePayDepositCache();
		const approvedAccounts = this.getApprovedAccounts();
		if (approvedAccounts.length > 1) {
			this.showBankSelectionForDeposit = true;
			this.selectedDepositAccount = null;
		}
		return true;
	},

	// Helper method to check if time is in range
	isTimeInRange(current, start, end) {
		const currentTime = moment(current, 'HH:mm');
		const startTime = moment(start, 'HH:mm');
		const endTime = moment(end, 'HH:mm');
		
		if (endTime.isBefore(startTime)) {
			// Range crosses midnight
			return currentTime.isAfter(startTime) || currentTime.isBefore(endTime);
		} else {
			return currentTime.isBetween(startTime, endTime, null, '[]');
		}
	},

	isBankEnabled(bank) {
		return !!bank && (bank.status === true || bank.status === 'Y');
	},

	getDisplayTimeRange(displayTime) {
		if (!displayTime) {
			return { startTime: null, endTime: null };
		}

		if (typeof displayTime === 'string') {
			const times = displayTime.split('-');
			if (times.length === 2) {
				return {
					startTime: times[0],
					endTime: times[1]
				};
			}
		}

		if (typeof displayTime === 'object' && displayTime.start_time && displayTime.end_time) {
			return {
				startTime: displayTime.start_time,
				endTime: displayTime.end_time
			};
		}

		return { startTime: null, endTime: null };
	},

		isBankOpenNow(bank) {
			if (!this.isBankEnabled(bank)) {
				return false;
			}

		const { startTime, endTime } = this.getDisplayTimeRange(bank.display_time);
		if (!startTime || !endTime) {
			return true;
		}

			return this.isTimeInRange(moment().tz('Asia/Bangkok').format('HH:mm'), startTime, endTime);
		},

		getDepositReceiverStorageKey() {
			if (!this.user || !this.user.key) {
				return null;
			}

			return `preferred-deposit-receiver:${this.user.key}`;
		},

		getStoredDepositReceiver() {
			if (typeof window === 'undefined') {
				return null;
			}

			const storageKey = this.getDepositReceiverStorageKey();
			if (!storageKey) {
				return null;
			}

			try {
				const rawValue = window.localStorage.getItem(storageKey);
				return rawValue ? JSON.parse(rawValue) : null;
			} catch (error) {
				console.warn('Failed to parse preferred deposit receiver:', error);
				return null;
			}
		},

		storeDepositReceiver(bank) {
			if (typeof window === 'undefined' || !this.isLegacyDepositReceiverBank(bank) || isPaymentProviderBank(bank)) {
				return;
			}

			const storageKey = this.getDepositReceiverStorageKey();
			if (!storageKey) {
				return;
			}

			window.localStorage.setItem(storageKey, JSON.stringify({
				id: bank.id || '',
				bank_name: bank.bank_name || '',
				account_no: bank.account_no || '',
				firstname: bank.firstname || '',
				lastname: bank.lastname || '',
				type: 'deposit'
			}));
		},

		findPreferredDepositReceiver(availableBanks) {
			const preferredBank = this.getStoredDepositReceiver();
			if (!preferredBank) {
				return null;
			}

				return availableBanks.find((bank) =>
					bank &&
					(
						(preferredBank.id && bank.id === preferredBank.id) ||
						(bank.bank_name === preferredBank.bank_name && bank.account_no === preferredBank.account_no)
					) &&
					this.isBankOpenNow(bank)
				) || null;
			},

		selectDepositReceiverBank(availableBanks) {
			const preferredBank = this.findPreferredDepositReceiver(availableBanks);
			const selectedBank = preferredBank || availableBanks[Math.floor(Math.random() * availableBanks.length)];

			this.storeDepositReceiver(selectedBank);
			return selectedBank;
		},



		// Method สำหรับยกเลิกการเลือกธนาคารและใช้บัญชีแรก
	async cancelBankSelection() {
		this.showBankSelectionForDeposit = false;
		this.selectedDepositAccount = null;
		const approvedAccounts = this.getApprovedAccounts();
		if (approvedAccounts.length > 0) {
			await this.callGetBanksOnTimeAPI(approvedAccounts[0]);
		}
	},

	// Method สำหรับลองโหลดข้อมูลธนาคารใหม่
	async retryBankLoad() {
		this.hideBankSection = false;
		await this.getBankDeposit();
	},


	
	// Helper function to check if current time is within display time range
	isInTimeRange(currentTime, displayTime) {
		if (!displayTime || !displayTime.start_time || !displayTime.end_time) {
			return true; // If no time restriction, always visible
		}
		
		const current = moment(currentTime, 'HH:mm');
		const start = moment(displayTime.start_time, 'HH:mm');
		const end = moment(displayTime.end_time, 'HH:mm');
		
		// Handle case where end time is next day (e.g., 22:00 - 02:00)
		if (end.isBefore(start)) {
			return current.isSameOrAfter(start) || current.isSameOrBefore(end);
		}
		
		return current.isBetween(start, end, null, '[]');
	},
	
	// Helper function to check if bank is visible to current user
	isVisibleToUser(visibleTo) {
		if (!visibleTo || !Array.isArray(visibleTo)) {
			return true; // If no restriction, visible to all
		}
		
		// Check if user's bank is in visible_to array or if "other" is included
		return visibleTo.some(item => {
			if (typeof item === 'object' && item.value) {
				return item.value === this.user.bank || item.value === 'other';
			}
			return item === this.user.bank || item === 'other';
		});
	},
	isNumber(evt){
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode === 46) {
            evt.preventDefault();
        } else {
            return true;
        }
    },
	checkLineLogin (data) {
		if(data.userId && this.user && this.user.key){
	  		firebase.database().ref(`users/${this.user.key}`).update({userId:data.userId,pictureUrl:data.pictureUrl});
			this.$swal({ icon: 'success', title: 'Line', text: 'เชื่อมต่อระบบ Line เรียบร้อยแล้วค่ะ' })
			const user = localStorage.getItem('userData');
			if(user){
				const _user = JSON.parse(user);
				this.$store.dispatch('user/setUser',_user).catch(err => { console.error(err) });
			}
		}
    },
	async getToken (code) {
      const data = qs.stringify({
        grant_type: 'authorization_code',
        code,
        redirect_uri: this.callbackUri,
        client_id: this.clientId,
        client_secret: this.clientSecret
      })
      let response
      await axios({
        method: 'post',
        url: 'https://api.line.me/oauth2/v2.1/token',
        data: data
      }).then(async res => {
        if (res.status !== 200) {
          this.error = 'โปรดติดต่อแอดมิน'
        } else if (res.data) {
          response = res.data
        }
      })
      return response
    },
	async getProfile (token) {
      return await axios.get('https://api.line.me/v2/profile', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    },
	lineLogin () {
      const url = 'https://access.line.me/oauth2/v2.1/authorize'
      let params = {
        response_type: 'code',
        client_id: this.clientId,
        redirect_uri: this.callbackUri,
        state: Math.random().toString(32).substring(2),
        scope: 'openid profile'
      }
      if (this.addFriend) {
        params = Object.assign(params, {
          prompt: 'consent',
          bot_prompt: 'aggressive'
        })
      }
      window.location.href = `${url}?${queryString.stringify(params)}`
    },
	async addLogin(user){
        await axios.get('https://api.ipify.org?format=json').then(x => {
          if(x.data.ip && user.key){
			axios({
				method: 'post',
				url: 'https://api.vr1game-v2.online/api/addlogin',
				data: {
					key: user.key,
					ip: x.data.ip
				}
			})
          }
        });
        // await axios.get('https://checkip.amazonaws.com').then(x => {
        //   if(x){
        //     firebase.database().ref(`/users/${key}`).update({
        //       ip:x
        //     });
        //   }
        // });
	},
	nl2br (str, is_xhtml) {
		if (typeof str === 'undefined' || str === null) {
			return '';
		}
		var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
		return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
	},
	closePromotion(){
		this.$store.commit('user/SET_PROMOTION', [])
	},
	clipboardSuccessHandler () {
      this.$swal({ icon: 'success', title: 'Copy', text: this.$t('copy_success') })
    },
	gotoMain(){
		router.replace('/')
	},

	getUserId(){
	  	const user = localStorage.getItem('userData');
		if(user){
			const _user = JSON.parse(user);
			return _user;
		}else{
			firebase.auth().signOut()
			localStorage.removeItem('userData')
			router.replace('/login')
		}
	},
	async moveCreditToWallet(){
		this.selectedWithdrawAccount = null;
		if(this.disabled){
			return { status: false, promoHandled: false };
		}

		this.disabled = true;
		this.$store.commit('user/SET_LOADING', true)
		try {
			const user = this.getUserId();
			const moveResult = await this.$store.dispatch('user/moveCreditToWallet');
			if(!moveResult || moveResult.status !== true){
				throw new Error((moveResult && (moveResult.error || moveResult.message)) || 'ไม่สามารถโยกเครดิตกลับเข้ากระเป๋าหลักได้');
			}

			const promoResult = await this.$store.dispatch('user/preparePromoWithdrawal', user);
			if(!promoResult || promoResult.status !== true || promoResult.withdrawBlocked){
				this.$swal({
					icon: 'warning',
					title: 'ยังไม่สามารถถอนได้',
					text: (promoResult && promoResult.blockingMessage) || 'กรุณาลองใหม่อีกครั้ง'
				});
				return { status: false, promoHandled: Boolean(promoResult && promoResult.activePromotion) };
			}

			if(promoResult.activePromotion){
				this.$store.commit("user/SET_ALERT_WITHDRAWALL", true);
				return { status: true, promoHandled: true };
			}
			return { status: true, promoHandled: false };
		} catch (err) {
			console.error(err);
			this.$swal({
				icon: 'error',
				title: 'ไม่สามารถเตรียมรายการถอนได้',
				text: err.message || 'กรุณาลองใหม่อีกครั้ง'
			});
			return { status: false, promoHandled: false };
		} finally {
			this.$store.commit('user/SET_LOADING', false);
			setTimeout(() => {
				this.disabled = false;
			}, 2000);
		}
	},
	async checkPromotions(){
	  this.$store.commit('user/SET_LOADING', true)
	  // Note: All deposit state resets are now handled in the modal's show.bs.modal event
	  // The new deposit system doesn't need to call getBankDeposit immediately
	  try {
		return await this.$store.dispatch('user/checkPromotions')
	  } catch (err) {
		console.error(err)
		return { status: false, blocked: false }
	  } finally {
		this.$store.commit('user/SET_LOADING', false)
	  }
	    },
	hasActiveDepositInProgress() {
		const hasBankDeposit = !!(this.depositAmount && (this.assignedBank || this.depositTransactionId));
		const hasSecurePay = !!this.isSecurePayDepositActive;
		const hasPayBridge = !!(this.hasActivePayBridgeTask || this.paybridgeMatch);
		return !!(this.hasActiveCopayDeposit || this.hasActiveDyPayDeposit || this.hasActivePaykumoDeposit || this.hasActiveS3PayDeposit || this.hasActiveKissPayDeposit || hasSecurePay || hasPayBridge || hasBankDeposit);
	},
	async restoreActiveDepositInProgress() {
		if (this.hasActiveDepositInProgress()) return true;

		if (typeof this.restoreCopayDeposit === 'function' && await this.restoreCopayDeposit()) return true;
		if (typeof this.restoreDyPayDeposit === 'function' && await this.restoreDyPayDeposit()) return true;
		if (typeof this.restorePaykumoDeposit === 'function' && await this.restorePaykumoDeposit()) return true;
		if (typeof this.restoreS3PayDeposit === 'function' && await this.restoreS3PayDeposit()) return true;
		if (typeof this.restoreKissPayDeposit === 'function' && await this.restoreKissPayDeposit()) return true;
		if (typeof this.restoreSecurePayDepositFromCache === 'function' && await this.restoreSecurePayDepositFromCache()) return true;
		if (typeof this.restorePayBridgeTask === 'function' && this.restorePayBridgeTask()) return true;

		return this.hasActiveDepositInProgress();
	},
	async cancelActiveDepositForNewRequest() {
		if (this.hasActiveCopayDeposit && typeof this.cancelCopayDeposit === 'function') {
			await this.cancelCopayDeposit({ skipConfirmation: true });
			return !this.hasActiveCopayDeposit;
		}
		if (this.hasActiveDyPayDeposit && typeof this.cancelDyPayDeposit === 'function') {
			await this.cancelDyPayDeposit({ skipConfirmation: true });
			return !this.hasActiveDyPayDeposit;
		}
		if (this.hasActivePaykumoDeposit && typeof this.cancelPaykumoDeposit === 'function') {
			await this.cancelPaykumoDeposit({ skipConfirmation: true });
			return !this.hasActivePaykumoDeposit;
		}
		if (this.hasActiveS3PayDeposit && typeof this.cancelS3PayDeposit === 'function') {
			await this.cancelS3PayDeposit({ skipConfirmation: true });
			return !this.hasActiveS3PayDeposit;
		}
		if (this.hasActiveKissPayDeposit && typeof this.cancelKissPayDeposit === 'function') {
			await this.cancelKissPayDeposit({ skipConfirmation: true });
			return !this.hasActiveKissPayDeposit;
		}
		if ((this.hasActivePayBridgeTask || this.paybridgeMatch) && typeof this.cancelPayBridgeTask === 'function') {
			await this.cancelPayBridgeTask({ skipConfirmation: true });
			return !(this.hasActivePayBridgeTask || this.paybridgeMatch);
		}
		if (this.hasActiveDepositInProgress() && typeof this.cancelDeposit === 'function') {
			await this.cancelDeposit();
			return !this.hasActiveDepositInProgress();
		}
		return true;
	},
	async confirmActiveDepositBeforeNewRequest() {
		if (!(await this.restoreActiveDepositInProgress())) return true;

		const result = await this.$swal({
			icon: 'warning',
			title: 'คุณยังทำรายการฝากที่สร้างไว้ไม่สำเร็จ',
			text: 'กรุณาเลือกทำรายการฝากเดิมต่อ หรือยกเลิกรายการฝากเดิม',
			showCancelButton: true,
			confirmButtonText: 'ตกลง',
			cancelButtonText: 'ยกเลิกฝากเงิน',
			allowOutsideClick: false,
			allowEscapeKey: false
		});

		if (result.isConfirmed) {
			window.$('#depositModal').modal('show');
			return false;
		}
		if (result.dismiss === 'cancel') {
			return await this.cancelActiveDepositForNewRequest();
		}
		return false;
	},
	async ensureNoPendingWithdrawal() {
		const user = this.getUserId();
		const userKey = user && user.key;
		if (!userKey) {
			this.$swal({
				icon: 'error',
				title: 'ไม่สามารถตรวจสอบรายการถอนได้',
				text: 'กรุณาเข้าสู่ระบบใหม่แล้วลองอีกครั้ง'
			});
			return false;
		}

		try {
			const pendingWithdrawal = await getPendingWithdrawalStatus(userKey);
			if (!pendingWithdrawal) return true;

			this.$swal({
				icon: 'warning',
				title: this.$t('withdraw'),
				text: this.$t('withdraw_pending')
			});
			return false;
		} catch (error) {
			console.error('Pending withdrawal check failed:', error);
			this.$swal({
				icon: 'error',
				title: 'ไม่สามารถตรวจสอบรายการถอนได้',
				text: 'กรุณาลองใหม่อีกครั้ง'
			});
			return false;
		}
	},
	async handleDepositClick() {
		if (this.$store.state.user.user && this.$store.state.user.user.pending_approval) {
			this.$swal({
				icon: 'info',
				title: 'แจ้งเตือน',
				text: 'รบกวนรอ admin ตรวจสอบและอนุมัติการสมัครสมาชิกก่อนเริ่มทำรายการฝากครั้งแรกนะคะ (ใช้เวลาประมาณ 5 นาทีค่ะ)'
			});
			return;
		}
		if (!(await this.confirmActiveDepositBeforeNewRequest())) {
			return;
		}
		if (!(await this.ensureNoPendingWithdrawal())) {
			return;
		}
		if (!(await this.ensureActivePromotionDepositAllowed())) {
			return;
		}
		const conditionReady = await this.callGetWithdrawCondition();
		if (!conditionReady) {
			this.$swal({
				icon: 'error',
				title: 'ไม่สามารถตรวจสอบสถานะระบบฝากได้',
				text: 'กรุณาลองใหม่อีกครั้ง'
			});
			return;
		}

		this.securePayOnlyDeposit = false;
		if (this.condition.disableDeposit) {
			const [securePayAccess] = await Promise.all([
				this.$store.dispatch('user/checkSecurePayDepositAccess'),
				this.loadConfiguredPaymentChannels()
			]);
			const trueWalletDepositAvailable = this.getApprovedAccounts()
				.some(account => this.isTrueWalletDepositAccount(account));
			const alternativeDepositAvailable = trueWalletDepositAvailable
				|| this.getAvailableConfiguredPaymentChannels().length > 0;
			if ((!securePayAccess || securePayAccess.status === false) && !alternativeDepositAvailable) {
				this.$swal({
					icon: 'error',
					title: 'ไม่สามารถตรวจสอบ SecurePay ได้',
					text: 'กรุณาลองใหม่อีกครั้ง'
				});
				return;
			}
			this.securePayOnlyDeposit = Boolean(securePayAccess && securePayAccess.status !== false && securePayAccess.allowed);
			if (!this.securePayOnlyDeposit && !alternativeDepositAvailable) {
				this.$swal({
					icon: 'warning',
					title: 'ระบบฝากเงินปิดปรับปรุง',
					text: 'กรุณารอสักครู่แล้วลองใหม่อีกครั้ง'
				});
				return;
			}
		}
		await this.checkPromotions();
		window.$('#depositModal').modal('show');
	},
	async handleWithdrawClick() {
		if (this.condition.disableWithdraw) {
			this.$swal({
				icon: 'warning',
				title: 'ระบบถอนเงินปิดปรับปรุง',
				text: 'กรุณารอสักครู่แล้วลองใหม่อีกครั้ง'
			});
			return;
		}
		const result = await this.moveCreditToWallet();
		if(result && result.status && !result.promoHandled){
			window.$('#withdrawModal').modal('show');
		}
	},
	getBank(){
		if(this.user.bank){
			require(`../assets/images/${this.user.bank}.jpg`)
		}
	},
	numberWithCommas (x) {
	  if(!x) x = 0;
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
	numberWithCommas2 (x) {
	  if(!x) x = 0;
      return x.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  	},
	gotoPromotion(){
		$("#accountModal").modal('hide')
		router.replace('/promotion')
	},
	confirmLogout(){
      this.$swal({ icon: 'question', title: 'Log Out!', text: this.$t('confirm_logout'),showCancelButton: true,confirmButtonText: this.$t('confirm')}).then((result) => {
		if (result.isConfirmed) {
			$("#accountModal").modal('hide')
			firebase.auth().signOut()
			localStorage.removeItem('userData')
			router.replace('/login')
		}
      })
    },
	setWithdraw (value) {
		  if (value === 'plus') {
			  this.withdraw = (this.withdraw) ? this.withdraw + 10 : 10
		  } else if (value === 'minus') {
			  if (this.withdraw) { this.withdraw = (this.withdraw) ? this.withdraw - 10 : 0 }
		  } else if (value > 0) { this.withdraw = value } else { this.withdraw = 0 }
	},
	rand () {
    	return Math.random().toString(36).substr(2); // remove `0.`
	},
	token () {
    	return this.rand() + this.rand(); // to make it longer
	},
	async withdrawConfirm () {
		if(this.config.withdraw){
			this.$swal({ icon: 'error', title: this.$t('withdraw'), text: this.$t('withdraw_temporarily_closed') })
			return;
		}
		
		// Validate account selection for multiple approved accounts
		const approvedAccounts = this.getApprovedAccounts();
		if (approvedAccounts.length > 1 && !this.selectedWithdrawAccount) {
			this.$swal({ icon: 'error', title: this.$t('withdraw_modal.title'), text: this.$t('please_select_account') });
			return;
		}
		
		if (approvedAccounts.length === 0) {
			this.$swal({ icon: 'error', title: this.$t('withdraw_modal.title'), text: this.$t('add_bank_before_withdraw') });
			return;
		}
			
		const user = this.getUserId();
		if (user) {
			if (this.withdraw && this.withdraw >= Number(this.condition.minimum) && user.key && this.withdraw <= Number(this.condition.maximum)) {
				if (Number(this.withdraw) <= Number(this.user.credit)) {
					let check = false;
					await firebase.firestore().collection('history').where('userkey','==',user.key).where('status','not-in',['ดำเนินการแล้ว','ยกเลิก']).where('type','==','ถอน').limit(1).get().then((result)=>{
						if(result.size){
							check = true;
						}
					});
					if(!check){
						let total = 0;
						if(this.condition.qtyperday || this.condition.maximumperday){
							await firebase.firestore().collection('history').where('userkey','==',user.key).where('status','==','ดำเนินการแล้ว').where('type','==','ถอน').where('createdate','>=',moment().tz('Asia/Bangkok').format('YYYY-MM-DD')+' 00:00:00').get().then((result)=>{
								if(result.size >= Number(this.condition.qtyperday)){
									check = true;
								}
								result.forEach((doc)=>{
									total += Number(doc.data().qty);
								})
							});
						}
						if(check){
							this.$swal({ icon: 'error', title: this.$t('withdraw_modal.title'), text: this.$t('withdraw_modal.max_daily_count', { count: this.condition.qtyperday }) });
						}else if(total >= Number(this.condition.maximumperday)){
							this.$swal({ icon: 'error', title: this.$t('withdraw_modal.title'), text: this.$t('withdraw_modal.max_daily_amount', { amount: this.condition.maximumperday }) })
						}else{
							const selectedAccount = this.getSelectedWithdrawAccount();

							// ตรวจสอบเงื่อนไข TrueMoney Wallet
							if (selectedAccount.bank === 'truewallet') {
								const amount = Number(this.withdraw);
								if (amount < 100 || amount % 10 !== 0) {
									this.$swal({
										icon: 'error',
										title: this.$t('withdraw_modal.title'),
										text: this.$t('withdraw_modal.truewallet_amount_invalid')
									});
									return;
								}
							}

							axios({
								method: 'post',
								url: 'https://api.vr1game-v2.online/quserwithdraw/userwithdraw',
								data: {
									key: user.key,
									tel: user.tel,
									token: this.token(),
									credit: Number(this.withdraw),
									// Add selected account information
									bank: selectedAccount.bank,
									accountno: selectedAccount.account_no,
								}
							}).then(({ data }) => {
								if (data && data.status) {
									const successText = (data.message)
										? data.message
										: this.$t('home_page.withdraw_success');
									this.$swal({ icon: 'success', title: this.$t('withdraw_modal.title'), text: successText });
									$("#withdrawModal").modal('hide');
								} else {
									this.$swal({
										icon: 'error',
										title: this.$t('withdraw_modal.title'),
										text: (data && data.message) ? data.message : this.$t('home_page.withdraw_waiting')
									});
								}
							}).catch(() => {
								this.$swal({
									icon: 'error',
									title: this.$t('withdraw_modal.title'),
									text: 'ไม่สามารถทำรายการถอนได้ กรุณาลองใหม่อีกครั้ง'
								});
							})
						}
						
					}else{
						this.$swal({ icon: 'error', title: this.$t('withdraw_modal.title'), text: this.$t('home_page.withdraw_waiting') })
					}
				}else {
					this.$swal({ icon: 'error', title: this.$t('withdraw_modal.error_title'), text: this.$t('home_page.withdraw_credit') })
				}
			}else{
				this.$swal({ icon: 'error', title: this.$t('withdraw_modal.error_title'), text: this.$t('withdraw_modal.check_credit_condition') })
			}
		}
	},
    reloadBalance() {
      this.fa_spin = true;
	  const user = localStorage.getItem('userData');
	  if(user){
		  const _user = JSON.parse(user);
		  this.$store.dispatch('user/setUser',_user).finally(() => { 
			  setTimeout(() => {
				  this.fa_spin = false
			  }, 1000);
		  }).catch(err => { console.error(err) });
	  }else{
		firebase.auth().signOut()
		localStorage.removeItem('userData')
		router.replace('/login')
	  }
    	},
	showTabAccount() {
      if(!this.accountOpen) this.accountOpen = true; else this.accountOpen = false;
    },
	async changePassword(){
		if(this.password && this.password1 && this.password2){
		console.log(this.password1);
		console.log(this.password2);
		console.log(this.password);
			if(this.password1.length<6){
				this.$swal({ icon: 'warning', title: 'Password', text: `โปรดระบุรหัสผ่านมากกว่า 6 หลักค่ะ`}).then((result) => {
				});
				return;
			}else if(this.password1 != this.password2){
				this.$swal({ icon: 'warning', title: 'Password', text: `โปรดตรวจสอบรหัสผ่านใหม่อีกครั้งค่ะ`}).then((result) => {
				});
				return;
			}
			const user = this.getUserId();
			firebase.auth().signInWithEmailAndPassword(user.tel.trim().toLowerCase() + '@vr1game.com', this.password.trim()).then(async (res) => {
				if (res.user) {
					this.$store.commit('user/SET_LOADING', true)
					axios({
						method: 'post',
						url: 'https://api.vr1game-v2.online/api/resetpassword',
						data: {
							key: user.key,
							password: this.password1
						}
					}).then(async (result)=>{
						if(result.data && result.data.status){
							await firebase.auth().signInWithEmailAndPassword(user.tel.trim().toLowerCase() + '@vr1game.com', this.password1.trim()).then(async (res2) => {
								if (res2.user) {
									this.$swal({ icon: 'success', title: 'Password', text: `${this.$t('header.change_password')}เรียบร้อยแล้วค่ะ`}).then((result) => {});
									this.password = '';
									this.password1 = '';
									this.password2 = '';
									this.$store.commit('user/SET_LOADING', false)
								}
							}).catch(() => {
							})
						}
					}).catch(()=>{
						this.$store.commit('user/SET_LOADING', false)
					})
				}
			}).catch(() => {
				this.$swal({ icon: 'warning', title: 'Password', text: `โปรดตรวจสอบรหัสผ่านเดิมค่ะ`}).then((result) => {
				});
			})
			
			// this.$store.commit('user/SET_LOADING', true)
			// axios({
			// 	method: 'post',
			// 	url: 'https://api.vr1game-v2.online/api/resetpassword',
			// 	data: {
			// 		key: user.key,
			// 		password: this.password1
			// 	}
			// }).then(async (result)=>{
			// 	if(result.data && result.data.status){
			// 		await firebase.auth().signInWithEmailAndPassword(user.tel.trim().toLowerCase() + '@vr1game.com', this.password1.trim()).then(async (res2) => {
			// 			if (res2.user) {
			// 				this.$swal({ icon: 'success', title: 'Password', text: `${this.$t('header.change_password')}เรียบร้อยแล้วค่ะ`}).then((result) => {
			// 			});
			// 			}
			// 		}).catch(() => {
			// 		})
			// 	}
			// 	this.$store.commit('user/SET_LOADING', false)
			// }).catch(()=>{
			// 	this.$store.commit('user/SET_LOADING', false)
			// })
			$("#accountModalMobile").modal('hide')
			$("#accountModal").modal('hide')
		}
	},
	// Multiple bank accounts management methods
	setAccountActiveTab(tab) {
	  this.accountActiveTab = tab;
	},
	setMobileActiveTab(tab) {
	  this.mobileActiveTab = tab;
	  this.accountOpen = false; // Close sidebar immediately
	},
	resetMobileTabs() {
	  this.mobileActiveTab = null; // Reset to no active tab
	},
	getApprovedAccounts() {
	  if (!this.user.accounts || !Array.isArray(this.user.accounts)) {
		return [];
	  }
	  return this.user.accounts.filter(account => account.status === true);
	},
	getPendingAccounts() {
	  if (!this.user.accounts || !Array.isArray(this.user.accounts)) {
		return [];
	  }
	  return this.user.accounts.filter(account => account.status === false);
	},
	getBankImage(bankCode) {
	  const bankImages = {
		'truewallet': require('../assets/images/bank/tmw.png'),
		'bankokbank': require('../assets/images/bank/bankokbank.jpg'),
		'kbank': require('../assets/images/bank/kbank.jpg'),
		'scb': require('../assets/images/bank/scb.jpg'),
		'tisco': require('../assets/images/bank/tisco.jpg'),
		'ttb': require('../assets/images/bank/ttb.jpg'),
		'ktb': require('../assets/images/bank/ktb.jpg'),
		'krungsri': require('../assets/images/bank/krungsri.jpg'),
		'kiatnakin': require('../assets/images/bank/kiatnakin.jpg'),
		'gsb': require('../assets/images/bank/gsb.jpg'),
		'lh': require('../assets/images/bank/lh.jpg'),
		'uob': require('../assets/images/bank/uob.jpg'),
		'ธนาคารอิสลาม': require('../assets/images/bank/ธนาคารอิสลาม.jpg'),
		'ghbank': require('../assets/images/bank/ghbank.jpg'),
		'cimb': require('../assets/images/bank/cimb.jpg'),
		'baac': require('../assets/images/bank/baac.jpg'),
		'icbc': require('../assets/images/bank/icbc.jpg'),
		'standard': require('../assets/images/bank/standard.jpg'),
		'securepay': require('../assets/images/bank/scb.jpg')
	  };
	  
	  return bankImages[bankCode] || bankImages['scb']; // fallback to scb
	},
	getBankName(bankCode) {
	  return this.bankNames[bankCode] || bankCode;
	},
	onBankChange() {
	  if (this.newAccount.bank === 'truewallet') {
		this.newAccount.firstname = '';
		this.newAccount.lastname = '';
	  }
	},
	onBankChangeMobile() {
	  if (this.newAccountMobile.bank === 'truewallet') {
		this.newAccountMobile.firstname = '';
		this.newAccountMobile.lastname = '';
	  }
	},
	getSelectedWithdrawAccount() {
	  const approvedAccounts = this.getApprovedAccounts();
	  if (approvedAccounts.length === 0) {
		return {};
	  }
	  
	  // If multiple accounts and one is selected, return the selected one
	  if (approvedAccounts.length > 1 && this.selectedWithdrawAccount) {
		return this.selectedWithdrawAccount;
	  }
	  
	  // Default to first approved account
	  return approvedAccounts[0];
	},
	onWithdrawAccountChange() {
	  // This method is called when user selects a different account
	  // The selectedWithdrawAccount is automatically updated by v-model
	},
	normalizeAccountNumber(value) {
	  return String(value || '').replace(/\D/g, '').slice(0, 12);
	},
	onAccountNumberInput(event, platform) {
	  const accountData = platform === 'mobile' ? this.newAccountMobile : this.newAccount;
	  const normalizedAccountNo = this.normalizeAccountNumber(event.target.value);
	  accountData.account_no = normalizedAccountNo;
	  event.target.value = normalizedAccountNo;
	},
	onAccountNumberPaste(event, platform) {
	  const clipboard = event.clipboardData || window.clipboardData;
	  if (!clipboard) return;

	  event.preventDefault();
	  const accountData = platform === 'mobile' ? this.newAccountMobile : this.newAccount;
	  accountData.account_no = this.normalizeAccountNumber(clipboard.getData('text'));
	},
	async addNewAccount() {
	  await this.submitNewAccount('desktop');
	},
	async addNewAccountMobile() {
	  await this.submitNewAccount('mobile');
	},
	async submitNewAccount(platform) {
	  const accountData = platform === 'mobile' ? this.newAccountMobile : this.newAccount;
	  const showFormFlag = platform === 'mobile' ? 'showAddAccountFormMobile' : 'showAddAccountForm';
	  const normalizedAccountNo = this.normalizeAccountNumber(accountData.account_no);
	  accountData.account_no = normalizedAccountNo;

	  // Validation
	  if (!accountData.bank) {
		this.$swal({ icon: 'error', title: 'Error!', text: 'กรุณาเลือกธนาคารค่ะ!!!' });
		return;
	  }
	  if (!normalizedAccountNo) {
		this.$swal({ icon: 'error', title: 'Error!', text: 'กรุณากรอกหมายเลขบัญชีค่ะ!!!' });
		return;
	  }

	  this.$store.commit('user/SET_LOADING', true);
	  
	  try {
		const user = this.getUserId();
		const response = await axios({
		  method: 'post',
		  url: 'https://api.vr1game-v2.online/api/addaccount',
		  data: {
			userkey: user.key,
			bank: accountData.bank,
			account_no: normalizedAccountNo,
			status: false
		  }
		});

		// เช็ค response จาก API
		if (response.data.status === false) {
		  this.$swal({
			icon: 'error',
			title: 'ไม่สามารถเพิ่มบัญชีได้',
			text: response.data.error || 'กรุณาลองใหม่อีกครั้ง'
		  })
		  this.$store.commit('user/SET_LOADING', false)
		  return
		}

		this.$swal({
		  icon: 'success',
		  title: 'เพิ่มบัญชีสำเร็จ',
		  text: 'บัญชีของท่านได้ถูกเพิ่มแล้ว รอการอนุมัติจากเจ้าหน้าที่'
		});

		// Reset form
		if (platform === 'mobile') {
		  this.newAccountMobile = {
			bank: '',
			account_no: '',
			firstname: '',
			lastname: '',
		  };
		} else {
		  this.newAccount = {
			bank: '',
			account_no: '',
			firstname: '',
			lastname: '',
		  };
		}
		
		this[showFormFlag] = false;

		// Reload user data
		const userData = localStorage.getItem('userData');
		if(userData){
		  const _user = JSON.parse(userData);
		  this.$store.dispatch('user/setUser',_user).catch(err => { console.error(err) });
		}

	  } catch (error) {
		this.$swal({ 
		  icon: 'error', 
		  title: 'เกิดข้อผิดพลาด', 
		  text: 'ไม่สามารถเพิ่มบัญชีได้ กรุณาลองใหม่อีกครั้ง' 
		});
	  }

	  this.$store.commit('user/SET_LOADING', false);
	},
	cancelAddAccount() {
	  this.newAccount = {
		bank: '',
		account_no: '',
		firstname: '',
		lastname: '',
	  };
	  this.showAddAccountForm = false;
	},
	cancelAddAccountMobile() {
	  this.newAccountMobile = {
		bank: '',
		account_no: '',
		firstname: '',
		lastname: '',
	  };
	  this.showAddAccountFormMobile = false;
	},
	formatWithdrawSummaryAmount(amount) {
		return Number(amount || 0).toLocaleString('th-TH', {
			minimumFractionDigits: 0,
			maximumFractionDigits: 2
		});
	},
	getPromoWithdrawSummary() {
		const walletCredit = Number(this.user.credit || 0);
		const bonusAmount = Number(this.lastbonus.bonus || 0);
		const canwithdraw = Number(this.lastbonus.canwithdraw || 0);
		const backbonus = Boolean(this.lastbonus.backbonus);
		const eligibleCredit = Number(Math.max(0, backbonus ? walletCredit - bonusAmount : walletCredit).toFixed(2));
		const cappedByMaxWithdraw = canwithdraw > 0 && eligibleCredit > canwithdraw;
		const withdrawBase = cappedByMaxWithdraw ? canwithdraw : eligibleCredit;
		const withdrawAmount = Math.max(0, Math.floor(Number(withdrawBase || 0)));

		return {
			promotionName: this.lastbonus.promotionName || 'โปรโมชั่นที่รับ',
			walletCredit,
			bonusAmount,
			backbonus,
			canwithdraw,
			cappedByMaxWithdraw,
			withdrawAmount
		};
	},
	buildPromoWithdrawSummaryHTML(extraHTML = '') {
		const summary = this.getPromoWithdrawSummary();
		const lines = [
			`<div style="font-size: 18px; font-weight: 600; margin-bottom: 12px;">${summary.promotionName}</div>`,
			`<div style="margin-bottom: 6px;">• ลูกค้ามีเครดิต ${this.formatWithdrawSummaryAmount(summary.walletCredit)} บาท</div>`
		];

		if (summary.backbonus) {
			lines.push(`<div style="margin-bottom: 6px;">• หักโบนัสช่วยเล่น ${this.formatWithdrawSummaryAmount(summary.bonusAmount)} บาท</div>`);
		}

		if (summary.cappedByMaxWithdraw) {
			lines.push(`<div style="margin-bottom: 6px;">• ยอดถอนสูงสุด ${this.formatWithdrawSummaryAmount(summary.canwithdraw)} บาท</div>`);
		}

		lines.push(`<div style="margin-bottom: 12px;">• ยอดเงินที่ได้รับ ${this.formatWithdrawSummaryAmount(summary.withdrawAmount)} บาท</div>`);
		lines.push('<div style="font-weight: 600; margin-bottom: 12px;">ยอดเครดิตคงเหลือ 0 บาท</div>');

		if (extraHTML) {
			lines.push(extraHTML);
		}

		return lines.join('');
	},
	// Method สำหรับสร้าง HTML dropdown เลือกบัญชี
	generateAccountDropdownHTML() {
		const accounts = this.getApprovedAccounts();
		let html = '<select id="swal-account-select" class="swal2-input" style="margin-bottom: 15px; padding: 10px; font-size: 16px; font-family: \'Kanit\', sans-serif; border: 1px solid #ddd; border-radius: 5px;">';
		html += '<option value="">เลือกบัญชีที่จะรับเงิน</option>';
		accounts.forEach((account, index) => {
			const bankName = this.getBankName(account.bank);
			html += `<option value="${index}">${bankName} (${account.account_no})</option>`;
		});
		html += '</select>';
		return html;
	},
	// Method สำหรับดึงชื่อธนาคาร
	getBankName(bankCode) {
		return this.bankNames[bankCode] || bankCode;
	},
	// Method สำหรับแสดง Swal alert พร้อมการเลือกบัญชี
	async showWithdrawConfirmWithAccountSelection() {
		const approvedAccounts = this.getApprovedAccounts();
		
		if (approvedAccounts.length === 0) {
			this.$swal({ 
				icon: 'error', 
				title: this.$t('withdraw'), 
				text: 'กรุณาเพิ่มบัญชีธนาคารก่อนทำการถอนเงิน' 
			});
			return;
		}

		// สร้าง HTML สำหรับ dropdown
		const dropdownHTML = this.generateAccountDropdownHTML();
		const messageHTML = this.buildPromoWithdrawSummaryHTML(`กรุณาเลือกบัญชีที่จะรับเงิน:<br>${dropdownHTML}`);
		const promoSummary = this.getPromoWithdrawSummary();
		
		const result = await this.$swal({
			icon: 'question',
			title: this.$t('withdraw'),
			html: messageHTML,
			showCancelButton: true,
			confirmButtonText: this.$t('confirm'),
			cancelButtonText: 'ยกเลิก',
			preConfirm: () => {
				const selectElement = document.getElementById('swal-account-select');
				if (!selectElement || !selectElement.value) {
					this.$swal.showValidationMessage('กรุณาเลือกบัญชีที่จะรับเงิน');
					return false;
				}
				return selectElement.value;
			}
		});

		if (result.isConfirmed && result.value !== undefined) {
			// ตั้งค่าบัญชีที่เลือก
			const selectedAccountIndex = parseInt(result.value);
			this.selectedWithdrawAccount = approvedAccounts[selectedAccountIndex];
			
			// ตั้งค่าจำนวนเงินที่จะถอน
			this.withdraw = promoSummary.withdrawAmount;
			
			// เรียกฟังก์ชัน withdrawConfirm
			this.withdrawConfirm();
		}
	}
  }
}
</script>
<style scoped>
.glow {
    color: #fff;
    text-align: center;
    -webkit-animation: glow 1s ease-in-out infinite alternate;
    -moz-animation: glow 1s ease-in-out infinite alternate;
    animation: glow 1s ease-in-out infinite alternate;
    }

    @-webkit-keyframes glow {
    from {
text-shadow: 0 0 5px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 5px #dbc47a, 0 0 5px #dbc47a, 0 0 5px #dbc47a;
    }
    
    to {
text-shadow: 0 0 5px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 5px #dbc47a, 0 0 5px #dbc47a, 0 0 5px #dbc47a;
    }
}
@media (max-width: 500px) { 
	.x-header #headerBrand .navbar-brand .-logo {
		width: 150px;
	}
}
.-balance-container .-user-balance .-inner-box-wrapper2 {
    position: relative;
    margin-right: 5px;
    margin-left: 15px;
    padding: 6px 24px 6px 0px;
    font-weight: 500;
    border-radius: 20px;
    color: #fff;
    text-align: right;
}
.x-logged .-profile-container .-btn-wrapper .-profile-name2 {
	font-family: 'Kanit', sans-serif;
    font-size: 1.2rem;
  /*  color: #e5e5e5; */
    font-weight: 200;
    margin-right: 2px;
    padding-left: 10px;
    color: #f9f9d6;
	text-align: center;
}
.x-logged .-profile-container .-btn-mobile-wrapper .-profile-name2 {
	font-family: 'Kanit', sans-serif;
    font-size: 1.1rem;
  /*  color: #e5e5e5; */
    font-weight: 200;
    margin-right: 2px;
    padding-left: 10px;
    color: #f9f9d6;
	text-align: center;
}

.-balance-container .-user-balance .-btn-balance2 {
    position: absolute;
    right: 10px;
    padding: 0;
    color: #FFFFFF;
    background: transparent;
    border: none;
}
.cCsozd {
    display: inline-block;
    padding: 0.5rem 1rem;
    height: 44px;
    font-size: 1em;
    line-height: 1.5;
    border: none;
    border-radius: 0.25rem;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
}
.ewHin {
    background: rgb(0, 187, 0);
    color: rgb(255, 255, 255);
    height: 50px;
    min-width: 180px;
    border-radius: 25px;
    padding-left: 34px;
    padding-right: 34px;
}
.ewHin .icon {
    height: 18px;
    margin: 0px 0.5rem;
    vertical-align: sub;
    border: 0px;
}

.mid {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Switch starts here */
.rocker {
  display: inline-block;
  position: relative;
  /*
  SIZE OF SWITCH
  ==============
  All sizes are in em - therefore
  changing the font-size here
  will change the size of the switch.
  See .rocker-small below as example.
  */
  font-size: 1em;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  color: #888;
  width: 7em;
  height: 4em;
  overflow: hidden;
  border-bottom: 0.5em solid #eee;
}

.rocker-small {
  font-size: 0.75em; /* Sizes the switch */
  margin: 1em;
}

.rocker::before {
  content: "";
  position: absolute;
  top: 0.5em;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #999;
  border: 0.5em solid #eee;
  border-bottom: 0;
}

.rocker input {
  opacity: 0;
  width: 0;
  height: 0;
}

.switch-left,
.switch-right {
  cursor: pointer;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5em;
  width: 3em;
  transition: 0.2s;
}

.switch-left {
  height: 2.4em;
  width: 2.75em;
  left: 0.85em;
  bottom: 0.4em;
  background-color: #ddd;
  transform: rotate(15deg) skewX(15deg);
}

.switch-right {
  right: 0.5em;
  bottom: 0;
  background-color: #bd5757;
  color: #fff;
}

.switch-left::before,
.switch-right::before {
  content: "";
  position: absolute;
  width: 0.4em;
  height: 2.45em;
  bottom: -0.45em;
  background-color: #ccc;
  transform: skewY(-65deg);
}

.switch-left::before {
  left: -0.4em;
}

.switch-right::before {
  right: -0.375em;
  background-color: transparent;
  transform: skewY(65deg);
}

input:checked + .switch-left {
  background-color: #0084d0;
  color: #fff;
  bottom: 0px;
  left: 0.5em;
  height: 2.5em;
  width: 3em;
  transform: rotate(0deg) skewX(0deg);
}

input:checked + .switch-left::before {
  background-color: transparent;
  width: 3.0833em;
}

input:checked + .switch-left + .switch-right {
  background-color: #ddd;
  color: #888;
  bottom: 0.4em;
  right: 0.8em;
  height: 2.4em;
  width: 2.75em;
  transform: rotate(-15deg) skewX(-15deg);
}

input:checked + .switch-left + .switch-right::before {
  background-color: #ccc;
}

/* Keyboard Users */
input:focus + .switch-left {
  color: #333;
}

input:checked:focus + .switch-left {
  color: #fff;
}

input:focus + .switch-left + .switch-right {
  color: #fff;
}

input:checked:focus + .switch-left + .switch-right {
  color: #333;
}
#my_file {
    display: none;
}

/* Multiple bank accounts styles */
.x-mobile-tabs {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.x-mobile-tabs .-tab-btn {
  background-color: #333;
  color: #fff;
  border: 1px solid #555;
  padding: 8px 16px;
  border-radius: 4px;
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  transition: all 0.3s ease;
}

.x-mobile-tabs .-tab-btn.active {
  background-color: #C320D6;
  border-color: #C320D6;
}

.x-modal-account-menu .nav-item.-account-bank {
  border-left: 4px solid transparent;
  transition: all 0.3s ease;
}

.x-modal-account-menu .nav-item.-account-bank.active {
  border-left-color: #C320D6;
  background-color: rgba(195, 32, 214, 0.1);
}

.x-customer-bank-info-container.-v2 .-content-wrapper .-bank-name {
  display: block;
  font-size: 12px;
  color: #999;
  margin-top: 2px;
}

.x-customer-bank-info-container.-v2 .-content-wrapper .-status {
  display: block;
  font-size: 11px;
  font-weight: bold;
  margin-top: 4px;
  padding: 2px 8px;
  border-radius: 12px;
  text-align: center;
  width: fit-content;
}

.x-customer-bank-info-container.-v2 .-content-wrapper .-status.approved {
  background-color: #4CAF50;
  color: white;
}

.x-customer-bank-info-container.-v2 .-content-wrapper .-status.pending {
  background-color: #FF9800;
  color: white;
}

.-add-account-container {
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.-approved-accounts,
.-pending-accounts {
  margin-bottom: 20px;
}

.btn.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
  color: white;
}

.btn.btn-secondary:hover {
  background-color: #545b62;
  border-color: #4e555b;
}

/* Border colors for account status */
.x-customer-bank-info-container.-v2.approved-border {
  border: 2px solid #4CAF50;
  border-radius: 8px;
  padding: 10px;
  background-color: rgba(76, 175, 80, 0.2);
  backdrop-filter: blur(5px);
}

.x-customer-bank-info-container.-v2.approved-border .-content-wrapper {
  color: #ffffff !important;
}

.x-customer-bank-info-container.-v2.approved-border .-name,
.x-customer-bank-info-container.-v2.approved-border .-number,
.x-customer-bank-info-container.-v2.approved-border .-bank-name {
  color: #ffffff !important;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
}

.x-customer-bank-info-container.-v2.pending-border {
  border: 2px solid #F44336;
  border-radius: 8px;
  padding: 10px;
  background-color: rgba(244, 67, 54, 0.2);
  backdrop-filter: blur(5px);
}

.x-customer-bank-info-container.-v2.pending-border .-content-wrapper {
  color: #ffffff !important;
}

.x-customer-bank-info-container.-v2.pending-border .-name,
.x-customer-bank-info-container.-v2.pending-border .-number,
.x-customer-bank-info-container.-v2.pending-border .-bank-name {
  color: #ffffff !important;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
}

.x-language{position:absolute;right:0;top:200px;z-index:6;margin-right: -14px;}
@media (max-width:1199.98px){
	.x-language{/*position:relative;top:unset;z-index:unset;display:flex*/}
}
.x-language .-link-wrapper{
	background-color:rgba(0,0,0,.5);border-top-left-radius:20px;border-bottom-left-radius:20px;display:flex;padding:.4rem .75rem;color:#fff;align-items: center;
}
@media (min-width:1200px){
	.x-language .-link-wrapper:hover{text-decoration:none;background-color:rgba(0,0,0,.4)}
}@media (max-width:1199.98px){
	.x-language .-link-wrapper{padding:5px;margin-right:.5rem}
}@media (max-width:575.98px){
	.x-language .-link-wrapper{margin-right:.25rem}
}
.x-language .-link-wrapper .-image-wrapper{
	align-items:center;display:flex
}
.x-language .-link-wrapper .-image-wrapper .-ic-right-star-rank{width:30px}
@media (max-width:370px){
	.x-language .-link-wrapper .-image-wrapper .-ic-right-star-rank{min-width:25px}
}
.x-language .-link-wrapper .-text-wrapper{
	line-height:16px;font-size:1.1rem;margin-left:.5rem;
	display: block;
}

.x-ranking-entrance{position:absolute;right:0;top:150px;z-index:6;margin-right: -14px;}
@media (max-width:1199.98px){
  .x-ranking-entrance{/*position:relative;top:unset;z-index:unset;display:flex*/}
}
.x-ranking-entrance .-link-wrapper{
  background-color:rgba(0,0,0,.5);border-top-left-radius:20px;border-bottom-left-radius:20px;display:flex;padding:.4rem .75rem;color:#fff;align-items: center;
}
@media (min-width:1200px){
  .x-ranking-entrance .-link-wrapper:hover{text-decoration:none;background-color:rgba(0,0,0,.4)}
}@media (max-width:1199.98px){
  .x-ranking-entrance .-link-wrapper{padding:5px;margin-right:.5rem}
}@media (max-width:575.98px){
  .x-ranking-entrance .-link-wrapper{margin-right:.25rem}
}
.x-ranking-entrance .-link-wrapper .-image-wrapper{
  align-items:center;display:flex
}
.x-ranking-entrance .-link-wrapper .-image-wrapper .-ic-right-star-rank{width:30px}
@media (max-width:370px){
  .x-ranking-entrance .-link-wrapper .-image-wrapper .-ic-right-star-rank{min-width:25px}
}
.x-ranking-entrance .-link-wrapper .-text-wrapper{
  line-height:16px;font-size:1.1rem;margin-left:.5rem;
  display: block;
}

/* Loading animation for skeleton */
@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
  }
.s3pay-deposit-range {
  display: block;
  margin-top: 8px;
  color: #bbf7d0;
  font-family: 'Kanit', sans-serif;
  font-size: 12px;
  text-align: center;
}

#depositModal > .modal-dialog.s3pay-modal-dialog--active {
  padding: 0 !important;
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

#depositModal > .modal-dialog > .-modal-content.s3pay-modal-content--active {
  overflow: visible;
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

#depositModal > .modal-dialog > .-modal-content.s3pay-modal-content--active::before,
#depositModal > .modal-dialog > .-modal-content.s3pay-modal-content--active::after {
  display: none !important;
}

#depositModal .-modal-content.s3pay-modal-content--active > .-modal-body.s3pay-modal-body--active {
  position: relative;
  inset: auto;
  padding: 0;
  overflow: visible;
  background: transparent;
}

@media (max-width: 991.98px) {
  #depositModal > .modal-dialog.-modal-size {
    display: block;
    height: 100vh;
    height: 100dvh;
    overflow: hidden;
  }

  #depositModal > .modal-dialog > .-modal-content {
    position: relative;
    inset: auto;
    width: 100%;
    height: 100%;
    max-height: 100%;
    min-height: 0;
    margin: 0;
    overflow: hidden;
    border-radius: 0;
  }

  #depositModal.-v2 .-modal-content .-modal-body.deposit-form-modal-body--scrollable {
    overflow-x: hidden;
    overflow-y: auto !important;
    overflow-anchor: none;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: contain;
    touch-action: pan-y;
    padding-top: calc(1rem + env(safe-area-inset-top)) !important;
    padding-bottom: max(16px, env(safe-area-inset-bottom));
  }

  #depositModal .deposit-promotion-hint,
  #depositModal .promotion-term-single-line {
    font-size: clamp(10px, 3vw, 12px) !important;
    white-space: nowrap;
  }

  #depositModal .-modal-body.s3pay-modal-body--active {
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 0;
    min-height: 0 !important;
    padding: 8px;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: none;
  }
}

.paybridge-task-button { margin-right: 8px; padding: 7px 10px; display: flex; align-items: center; gap: 7px; color: #fff; background: #dc3545; border: 2px solid #fff; border-radius: 6px; box-shadow: 0 7px 18px rgba(153,27,27,.28); }
.paybridge-task-button span:last-child { display: flex; flex-direction: column; text-align: left; line-height: 1.05; }
.paybridge-task-button small { margin-top: 3px; color: #fff4d6; font-variant-numeric: tabular-nums; }
.paybridge-task-dot { width: 10px; height: 10px; background: #ffe14d; border-radius: 50%; animation: paybridge-task-pulse 1.2s infinite; }
@keyframes paybridge-task-pulse { 50% { transform: scale(1.35); } }
</style>
<style lang="scss" scoped>
.modal-window {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.58);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 20000;
  padding: 16px;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  
  &:target {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }
  & > div {
    box-sizing: border-box;
    width: 100%;
    max-width: 360px;
    max-height: calc(100vh - 32px);
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 16px;
    background: black;
	border: 4px solid #C320D6;
  	border-radius: 16px;
    box-shadow: 0 0 18px rgba(195, 32, 214, 0.75);
  }
}

@supports (height: 100dvh) {
  .modal-window > div {
    max-height: calc(100dvh - 32px);
  }
}

.modal-close {
  color: #aaa;
  line-height: 50px;
  font-size: 80%;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;
  width: 70px;
  text-decoration: none;
  &:hover {
    color: black;
  }
}

.announcement-modal {
  color: #fff;
  font-family: 'Kanit', sans-serif;
}

.announcement-modal-title {
  flex: 0 0 auto;
  color: #fff;
  font-size: 22px;
  line-height: 1.3;
  margin: 0 0 12px;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.announcement-modal-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding-right: 6px;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

.announcement-modal-detail {
  color: #fff;
  font-size: 15px;
  line-height: 1.55;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.announcement-modal-date {
  color: #d8d8d8;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 12px;
}

.announcement-modal-actions {
  flex: 0 0 auto;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding-top: 16px;
}

.announcement-modal-button {
  min-height: 34px;
  min-width: 0;
  flex: 1 1 0;
  border: 2px solid #C320D6;
  background-color: #000;
  color: #fff;
  border-radius: 50px;
  font-family: 'Kanit', sans-serif;
  font-size: 13px;
  line-height: 1.2;
  padding: 6px 10px;
  white-space: normal;
}

small {
  color: lightgray;
}

@media (max-width: 360px) {
  .modal-window {
    padding: 10px;
  }

  .modal-window > div {
    width: calc(100vw - 20px);
    max-height: calc(100vh - 20px);
    padding: 14px;
  }

  .announcement-modal-title {
    font-size: 20px;
  }

  .announcement-modal-actions {
    gap: 8px;
  }

  .announcement-modal-button {
    font-size: 12px;
    padding: 6px 8px;
  }
}

@supports (height: 100dvh) {
  @media (max-width: 360px) {
    .modal-window > div {
      max-height: calc(100dvh - 20px);
    }
  }
}

.x-ranking-entrance{position:absolute;right:0;top:150px;z-index:6;margin-right: -14px;}
@media (max-width:1199.98px){
	.x-ranking-entrance{/*position:relative;top:unset;z-index:unset;display:flex*/}
}
.x-ranking-entrance .-link-wrapper{
	background-color:rgba(0,0,0,.5);border-top-left-radius:20px;border-bottom-left-radius:20px;display:flex;padding:.4rem .75rem;color:#fff;align-items: center;
}
@media (min-width:1200px){
	.x-ranking-entrance .-link-wrapper:hover{text-decoration:none;background-color:rgba(0,0,0,.4)}
}@media (max-width:1199.98px){
	.x-ranking-entrance .-link-wrapper{padding:5px;margin-right:.5rem}
}@media (max-width:575.98px){
	.x-ranking-entrance .-link-wrapper{margin-right:.25rem}
}
.x-ranking-entrance .-link-wrapper .-image-wrapper{
	align-items:center;display:flex
}
.x-ranking-entrance .-link-wrapper .-image-wrapper .-ic-right-star-rank{width:30px}
@media (max-width:370px){
	.x-ranking-entrance .-link-wrapper .-image-wrapper .-ic-right-star-rank{min-width:25px}
}
.x-ranking-entrance .-link-wrapper .-text-wrapper{
	line-height:16px;font-size:1.1rem;margin-left:.5rem;
	display: block;
}

/* Enhanced copy button styles */
.-copy-wrapper .btn.-btn.js-copy-to-clipboard {
  padding: 12px 20px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  min-width: 50px !important;
  height: auto !important;
  background: linear-gradient(135deg, #ffc107, #ffab00) !important;
  color: #000 !important;
  border: 2px solid #ffc107 !important;
  box-shadow: 0 4px 12px rgba(255, 193, 7, 0.3) !important;
  transition: all 0.3s ease !important;
  font-family: 'Kanit', sans-serif !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  position: relative !important;
  overflow: hidden !important;
}

.-copy-wrapper .btn.-btn.js-copy-to-clipboard:hover {
  background: linear-gradient(135deg, #ffab00, #ff8f00) !important;
  color: #fff !important;
  border-color: #ffab00 !important;
  box-shadow: 0 6px 20px rgba(255, 193, 7, 0.5) !important;
  transform: translateY(-2px) !important;
}

.-copy-wrapper .btn.-btn.js-copy-to-clipboard:active {
  transform: translateY(0) !important;
  box-shadow: 0 2px 8px rgba(255, 193, 7, 0.4) !important;
}

/* Add animation effect */
.-copy-wrapper .btn.-btn.js-copy-to-clipboard::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.6s ease;
}

.-copy-wrapper .btn.-btn.js-copy-to-clipboard:hover::before {
  left: 100%;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .-copy-wrapper .btn.-btn.js-copy-to-clipboard {
    padding: 10px 16px !important;
    font-size: 14px !important;
    min-width: 100px !important;
  }
}

/* For smaller mobile screens */
@media (max-width: 480px) {
  .-copy-wrapper .btn.-btn.js-copy-to-clipboard {
    padding: 8px 12px !important;
    font-size: 13px !important;
    min-width: 80px !important;
  }
}
</style>
